var __defProp = Object.defineProperty;
var __returnValue = (v) => v;
function __exportSetter(name, newValue) {
  this[name] = __returnValue.bind(null, newValue);
}
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, {
      get: all[name],
      enumerable: true,
      configurable: true,
      set: __exportSetter.bind(all, name)
    });
};

// src/canvas-internals.ts
var exports_canvas_internals = {};
__export(exports_canvas_internals, {
  CanvasOutlinePolygon: () => CanvasOutlinePolygon,
  CanvasOutlineSnapLines: () => CanvasOutlineSnapLines,
  EMPTY_CANVAS_SELECTION: () => EMPTY_CANVAS_SELECTION,
  applyCanvasOutlineDragAxisLock: () => applyCanvasOutlineDragAxisLock,
  applyCanvasOutlineTranslateDelta: () => applyCanvasOutlineTranslateDelta,
  canEditKeyframeEasing: () => canEditKeyframeEasing,
  canMoveCanvasKeyframes: () => canMoveCanvasKeyframes,
  canvasOutlineDragThresholdPx: () => canvasOutlineDragThresholdPx,
  canvasOutlineSnapThresholdPx: () => canvasOutlineSnapThresholdPx,
  canvasOutlinesAreEqual: () => canvasOutlinesAreEqual,
  canvasTranslateFieldKey: () => canvasTranslateFieldKey,
  clearCanvasOutlineDragOverrides: () => clearCanvasOutlineDragOverrides,
  collectReactCommit: () => collectReactCommit,
  createCanvasOutlineLayoutTargetLookup: () => createCanvasOutlineLayoutTargetLookup,
  createCanvasOutlineTranslateSession: () => createCanvasOutlineTranslateSession,
  createTimelineCalculator: () => createTimelineCalculator,
  cropCanvasOutlinePoints: () => cropCanvasOutlinePoints,
  findCanvasOutlineSnap: () => findCanvasOutlineSnap,
  getBoundedKeyframeDragDelta: () => getBoundedKeyframeDragDelta,
  getCanvasActiveOutlineTargets: () => getCanvasActiveOutlineTargets,
  getCanvasKeyframeMove: () => getCanvasKeyframeMove,
  getCanvasKeyframeValueAtSourceFrame: () => getCanvasKeyframeValueAtSourceFrame,
  getCanvasKeyframeValueToAdd: () => getCanvasKeyframeValueToAdd,
  getCanvasOutlineActivity: () => getCanvasOutlineActivity,
  getCanvasOutlineLayoutTargets: () => getCanvasOutlineLayoutTargets,
  getCanvasOutlineNudgeDelta: () => getCanvasOutlineNudgeDelta,
  getCanvasOutlineNudgeDeltas: () => getCanvasOutlineNudgeDeltas,
  getCanvasOutlineNudgeDirection: () => getCanvasOutlineNudgeDirection,
  getCanvasOutlinePoint: () => getCanvasOutlinePoint,
  getCanvasOutlineSelectionInteraction: () => getCanvasOutlineSelectionInteraction,
  getCanvasOutlineSnapTargets: () => getCanvasOutlineSnapTargets,
  getCanvasOutlineTranslateDragChanges: () => getCanvasOutlineTranslateDragChanges,
  getCanvasOutlineTranslateDragStates: () => getCanvasOutlineTranslateDragStates,
  getCanvasOutlineTranslateDragValues: () => getCanvasOutlineTranslateDragValues,
  getCanvasOutlineUv: () => getCanvasOutlineUv,
  getCanvasSelectableOutlines: () => getCanvasSelectableOutlines,
  getCanvasSelectedSequenceKeys: () => getCanvasSelectedSequenceKeys,
  getCanvasSelectionAfterInteraction: () => getCanvasSelectionAfterInteraction,
  getCanvasSequenceKeysContainingSelection: () => getCanvasSequenceKeysContainingSelection,
  getCanvasSequenceSelectionKey: () => getCanvasSequenceSelectionKey,
  getCanvasVisibleOutlineTargets: () => getCanvasVisibleOutlineTargets,
  getConnectedCompositions: () => getConnectedCompositions,
  getKeyframeDisplayOffset: () => getKeyframeDisplayOffset,
  getKeyframeLocalFrame: () => getKeyframeLocalFrame,
  getKeyframePlaybackRate: () => getKeyframePlaybackRate,
  getKeyframeSegmentEasing: () => getKeyframeSegmentEasing,
  getKeyframeSegments: () => getKeyframeSegments,
  getKeyframeSourceFrame: () => getKeyframeSourceFrame,
  getMovedCanvasKeyframeOverride: () => getMovedCanvasKeyframeOverride,
  getMovedCanvasKeyframeStatus: () => getMovedCanvasKeyframeStatus,
  getNextKeyframeDisplayFrame: () => getNextKeyframeDisplayFrame,
  getParentSequencePlaybackRate: () => getParentSequencePlaybackRate,
  getPreviousKeyframeDisplayFrame: () => getPreviousKeyframeDisplayFrame,
  getSchemaField: () => getSchemaField,
  getTimelineKeyframes: () => getTimelineKeyframes,
  getTransformedSvgViewportPoints: () => getTransformedSvgViewportPoints,
  handleCanvasOutlinePointerDown: () => handleCanvasOutlinePointerDown,
  hasKeyframeAtSourceFrame: () => hasKeyframeAtSourceFrame,
  installReactCommitObserver: () => installReactCommitObserver,
  isCanvasKeyframablePropStatus: () => isCanvasKeyframablePropStatus,
  isCanvasOutlineDragPastThreshold: () => isCanvasOutlineDragPastThreshold,
  isPointerSessionRelease: () => isPointerSessionRelease,
  measureCanvasOutlineTargets: () => measureCanvasOutlineTargets,
  normalizeFontWeightForKeyframe: () => normalizeFontWeightForKeyframe,
  observePointerRelease: () => observePointerRelease,
  orderCanvasOutlinesForRendering: () => orderCanvasOutlinesForRendering,
  parseTranslate: () => parseTranslate,
  parseTranslateWithUnits: () => parseTranslateWithUnits,
  resolveKeyframeSourceFrame: () => resolveKeyframeSourceFrame,
  scaleCanvasOutline: () => scaleCanvasOutline,
  serializeTranslate: () => serializeTranslate,
  serializeTranslateWithUnits: () => serializeTranslateWithUnits,
  sortItemsByCommitOrder: () => sortItemsByCommitOrder,
  startCanvasOutlineTranslateDrag: () => startCanvasOutlineTranslateDrag,
  startCapturedPointerSession: () => startCapturedPointerSession,
  startDeferredCapturedPointerSession: () => startDeferredCapturedPointerSession,
  timelineSequenceNodePathToKey: () => timelineSequenceNodePathToKey,
  useCanvasOutlineMeasurements: () => useCanvasOutlineMeasurements,
  useCanvasOutlines: () => useCanvasOutlines,
  useCanvasRuntimeValueSnapshots: () => useCanvasRuntimeValueSnapshots,
  useCanvasSelectionController: () => useCanvasSelectionController,
  useIsCanvasSequenceHovered: () => useIsCanvasSequenceHovered
});

// src/react-commit-adapter.ts
import { Internals as Internals3 } from "remotion";

// src/commit-outline-collector.ts
import { Internals } from "remotion";
var createCommitOutlineCollector = (projectionFailed) => {
  const outlineNodesByRef = new Map;
  let outlineCollectionFailed = projectionFailed;
  return {
    visit: (fiber, metadata, outlineCollectors) => {
      let childOutlineCollectors = outlineCollectors;
      if (outlineCollectionFailed) {
        childOutlineCollectors = null;
      } else {
        try {
          const { outline } = fiber;
          const skipOutline = outlineCollectors === null || outline?.type === "hidden";
          childOutlineCollectors = skipOutline ? null : outline?.type === "portal" ? [] : outlineCollectors;
          if (metadata?.type === "sequence") {
            const outlineRef = metadata.outlineChildrenRef;
            if (outlineRef !== null) {
              const nodes = [];
              outlineNodesByRef.set(outlineRef, nodes);
              if (childOutlineCollectors !== null) {
                childOutlineCollectors = [...childOutlineCollectors, nodes];
              }
            }
          }
          if (childOutlineCollectors !== null && childOutlineCollectors.length > 0 && outline?.type === "host") {
            for (const collector of childOutlineCollectors) {
              collector.push(outline.node);
            }
            childOutlineCollectors = [];
          }
        } catch {
          outlineCollectionFailed = true;
          outlineNodesByRef.clear();
          childOutlineCollectors = null;
        }
      }
      return childOutlineCollectors;
    },
    publish: () => {
      for (const [ref, nodes] of outlineNodesByRef) {
        try {
          Internals.SequenceOutlineInternals.setNodes(ref, nodes);
        } catch {}
      }
      return outlineNodesByRef.size;
    }
  };
};

// src/commit-registry-collector.ts
var createCommitSnapshotCollector = (previous) => {
  let count = 0;
  let values = null;
  return {
    push: (value) => {
      if (values !== null) {
        values.push(value);
      } else if (previous?.[count] !== value) {
        values = previous?.slice(0, count) ?? [];
        values.push(value);
      }
      count++;
    },
    getSnapshot: () => values ?? (previous?.length === count ? previous : previous?.slice(0, count) ?? [])
  };
};
var createCommitRegistryCollector = (registrations = null, previousRegistrations = null, compositionRegistry = null) => {
  const compositionRegistrations = compositionRegistry?.registrations ?? null;
  const previousCompositionRegistrations = compositionRegistry?.previous ?? null;
  const sequencesByManager = new Map;
  const compositionsAndFoldersByManager = new Map;
  const visit = (metadata, sequenceManagerId, compositionManagerId) => {
    if (metadata?.type === "sequence-manager" && !sequencesByManager.has(metadata.id)) {
      const previous = previousRegistrations?.get(metadata.id) ?? null;
      const { onCommit } = metadata;
      sequencesByManager.set(metadata.id, {
        sequenceIds: createCommitSnapshotCollector(previous?.sequenceIds ?? null),
        registration: registrations !== null && onCommit !== null ? {
          onCommit,
          sequences: createCommitSnapshotCollector(previous?.sequences ?? null),
          previous
        } : null
      });
    }
    if (metadata?.type === "composition-manager" && !compositionsAndFoldersByManager.has(metadata.id)) {
      const previous = previousCompositionRegistrations?.get(metadata.id) ?? null;
      const { onCommit } = metadata;
      compositionsAndFoldersByManager.set(metadata.id, {
        registration: compositionRegistrations !== null && onCommit !== null ? {
          onCommit,
          previous,
          compositions: createCommitSnapshotCollector(previous?.snapshot.compositions ?? null),
          folders: createCommitSnapshotCollector(previous?.snapshot.folders ?? null),
          orderIds: createCommitSnapshotCollector(previous?.snapshot.orderIds ?? null)
        } : null
      });
    }
    if (metadata?.type === "sequence" && sequenceManagerId !== null) {
      const manager = sequencesByManager.get(sequenceManagerId);
      manager?.sequenceIds.push(metadata.id);
      if (metadata.value !== null) {
        manager?.registration?.sequences.push(metadata.value);
      }
    }
    if ((metadata?.type === "composition" || metadata?.type === "folder") && compositionManagerId !== null) {
      const manager = compositionsAndFoldersByManager.get(compositionManagerId);
      manager?.registration?.orderIds.push(`${metadata.type}:${metadata.id}`);
      if (metadata.type === "composition") {
        manager?.registration?.compositions.push(metadata.value);
      } else {
        manager?.registration?.folders.push(metadata.value);
      }
    }
  };
  return {
    visit,
    getSnapshot: () => {
      const sequenceManagers = [...sequencesByManager].map(([managerId, manager]) => {
        const sequenceIds = manager.sequenceIds.getSnapshot();
        const { registration } = manager;
        if (registration !== null && registrations !== null) {
          const sequences = registration.sequences.getSnapshot();
          const { previous } = registration;
          registrations.set(managerId, previous !== null && previous.onCommit === registration.onCommit && previous.sequences === sequences && previous.sequenceIds === sequenceIds ? previous : { onCommit: registration.onCommit, sequences, sequenceIds });
        }
        return { managerId, sequenceIds };
      });
      for (const [managerId, manager] of compositionsAndFoldersByManager) {
        const { registration } = manager;
        if (registration !== null && compositionRegistrations !== null) {
          const compositions = registration.compositions.getSnapshot();
          const folders = registration.folders.getSnapshot();
          const orderIds = registration.orderIds.getSnapshot();
          const { previous } = registration;
          compositionRegistrations.set(managerId, previous !== null && previous.onCommit === registration.onCommit && previous.snapshot.compositions === compositions && previous.snapshot.folders === folders && previous.snapshot.orderIds === orderIds ? previous : {
            onCommit: registration.onCommit,
            snapshot: { compositions, folders, orderIds }
          });
        }
      }
      return {
        sequenceManagers
      };
    }
  };
};

// src/react-commit-types.ts
import { Internals as Internals2 } from "remotion";
var { metadataProp } = Internals2.CommittedMetadataInternals;
var getCommittedMetadata = (props) => {
  if (typeof props !== "object" || props === null) {
    return null;
  }
  const metadata = Reflect.get(props, metadataProp);
  return typeof metadata === "object" && metadata !== null ? metadata : null;
};

// src/project-committed-fiber-tree.ts
var projectCommittedFiberTree = (root, cache) => {
  let outlineCollectionFailed = false;
  const visit = (fiber, previous) => {
    const metadata = getCommittedMetadata(fiber.memoizedProps);
    let outline = null;
    if (!outlineCollectionFailed) {
      try {
        if (fiber.tag === 22 && fiber.memoizedState !== null) {
          outline = { type: "hidden" };
        } else if (fiber.tag === 4) {
          outline = { type: "portal" };
        } else if ((fiber.tag === 5 || fiber.tag === 6) && fiber.stateNode !== null) {
          outline = { type: "host", node: fiber.stateNode };
        }
      } catch {
        outlineCollectionFailed = true;
      }
    }
    let childSnapshots;
    let projectedChildren;
    if (previous !== null && previous.child === fiber.child) {
      childSnapshots = previous.children;
      projectedChildren = previous.projectedChildren;
    } else {
      const previousChildren = new Map(previous?.children.map((entry) => [entry.fiber, entry]));
      const snapshots = [];
      const next = [];
      let { child } = fiber;
      while (child !== null) {
        const childSnapshot = visit(child, previousChildren.get(child) ?? (child.alternate ? previousChildren.get(child.alternate) ?? null : null));
        snapshots.push(childSnapshot);
        if (childSnapshot.projection !== null) {
          next.push(childSnapshot.projection);
        }
        child = child.sibling;
      }
      childSnapshots = snapshots;
      projectedChildren = next;
    }
    let children = projectedChildren;
    if (outline !== null) {
      children = children.filter((child) => child.hasMetadata);
    }
    const hasMetadata = metadata !== null || children.some((child) => child.hasMetadata);
    const projection = metadata === null && outline?.type !== "host" && children.length === 0 ? null : metadata === null && outline === null && children.length === 1 ? children[0] : { metadata, outline, children, hasMetadata };
    return {
      fiber,
      child: fiber.child,
      children: childSnapshots,
      projectedChildren,
      projection
    };
  };
  const snapshot = visit(root, cache?.current ?? null);
  if (cache !== null) {
    cache.current = outlineCollectionFailed ? null : snapshot;
  }
  return { projection: snapshot.projection, outlineCollectionFailed };
};

// src/react-commit-adapter.ts
var { installationMarker } = Internals3.CommittedMetadataInternals;
var collectReactCommit = (root, registrations = null, previousRegistrations = null, compositionRegistry = null, projectionCache = null) => {
  const projected = projectCommittedFiberTree(root.current, projectionCache);
  const registry = createCommitRegistryCollector(registrations, previousRegistrations, compositionRegistry);
  const outlines = createCommitOutlineCollector(projected.outlineCollectionFailed);
  const visit = (fiber, currentSequenceManagerId, currentCompositionManagerId, outlineCollectors) => {
    const { metadata } = fiber;
    if (!fiber.hasMetadata && !outlineCollectors?.length) {
      return;
    }
    const sequenceManagerId = metadata?.type === "sequence-manager" ? metadata.id : currentSequenceManagerId;
    const compositionManagerId = metadata?.type === "composition-manager" ? metadata.id : currentCompositionManagerId;
    registry.visit(metadata, sequenceManagerId, compositionManagerId);
    const childOutlines = outlineCollectors === null && metadata === null ? null : outlines.visit(fiber, metadata, outlineCollectors);
    for (const child of fiber.children) {
      visit(child, sequenceManagerId, compositionManagerId, childOutlines);
    }
  };
  if (projected.projection !== null) {
    visit(projected.projection, null, null, []);
  }
  return { ...registry.getSnapshot(), outlineCount: outlines.publish() };
};
var installReactCommitObserver = (target) => {
  const hook = target.__REACT_DEVTOOLS_GLOBAL_HOOK__;
  if (!hook?.supportsFiber) {
    return false;
  }
  if (hook[installationMarker] === true) {
    return true;
  }
  const previousOnCommitFiberRoot = hook.onCommitFiberRoot;
  const registrationsByRoot = new WeakMap;
  const compositionRegistrationsByRoot = new WeakMap;
  const projectionCachesByRoot = new WeakMap;
  hook.onCommitFiberRoot = function(...args) {
    let order = null;
    try {
      const [, root] = args;
      const projectionCache = projectionCachesByRoot.get(root) ?? {
        current: null
      };
      projectionCachesByRoot.set(root, projectionCache);
      const registrations = new Map;
      const previousRegistrations = registrationsByRoot.get(root);
      const compositionRegistrations = new Map;
      const previousCompositionRegistrations = compositionRegistrationsByRoot.get(root);
      order = collectReactCommit(root, registrations, previousRegistrations ?? null, {
        registrations: compositionRegistrations,
        previous: previousCompositionRegistrations ?? null
      }, projectionCache);
      registrationsByRoot.set(root, registrations);
      compositionRegistrationsByRoot.set(root, compositionRegistrations);
      for (const [managerId, registration] of registrations) {
        if (registration !== previousRegistrations?.get(managerId)) {
          registration.onCommit(registration.sequences, registration.sequenceIds);
        }
      }
      if (previousRegistrations) {
        for (const [managerId, registration] of previousRegistrations) {
          if (!registrations.has(managerId)) {
            registration.onCommit([], []);
          }
        }
      }
      for (const [managerId, registration] of compositionRegistrations) {
        if (registration !== previousCompositionRegistrations?.get(managerId)) {
          registration.onCommit(registration.snapshot);
        }
      }
      if (previousCompositionRegistrations) {
        for (const [
          managerId,
          registration
        ] of previousCompositionRegistrations) {
          if (!compositionRegistrations.has(managerId)) {
            registration.onCommit({
              compositions: [],
              folders: [],
              orderIds: []
            });
          }
        }
      }
    } catch {
      projectionCachesByRoot.delete(args[1]);
      hook[Internals3.CommittedMetadataInternals.failureMarker] = true;
      order = null;
      try {
        target.dispatchEvent(new CustomEvent(Internals3.CommittedMetadataInternals.registrationErrorEventName));
      } catch {}
    }
    if (order !== null && (order.outlineCount > 0 || order.sequenceManagers.length > 0)) {
      try {
        target.dispatchEvent(new CustomEvent(Internals3.CommittedMetadataInternals.eventName, {
          detail: {
            sequenceManagers: order.sequenceManagers
          }
        }));
      } catch {}
    }
    return previousOnCommitFiberRoot?.apply(this, args);
  };
  hook[installationMarker] = true;
  return true;
};
// src/sort-by-commit-order.ts
var sortItemsByCommitOrder = (items, getOrder) => {
  return items.map((item, internalOrder) => ({
    item,
    internalOrder,
    commitOrder: getOrder(item)
  })).sort((a, b) => {
    if (a.commitOrder === null && b.commitOrder === null) {
      return a.internalOrder - b.internalOrder;
    }
    if (a.commitOrder === null) {
      return 1;
    }
    if (b.commitOrder === null) {
      return -1;
    }
    return a.commitOrder - b.commitOrder || a.internalOrder - b.internalOrder;
  }).map(({ item }) => item);
};

// src/timeline-sequence-node-path-to-key.ts
var timelineSequenceNodePathToKey = (key) => `${key.absolutePath}:${JSON.stringify(key.nodePath)}`;

// src/calculate-timeline.ts
var EMPTY_COMPOSITIONS = [];
var calculateTimelineState = ({
  sequences,
  overrideIdsToNodePaths,
  compositions = EMPTY_COMPOSITIONS,
  showConnectedCompositionChildren = false
}, previous) => {
  const registeredSequencesById = new Map(sequences.map((sequence) => [sequence.id, sequence]));
  const completenessById = new Map;
  const hasCompleteAncestors = (sequence) => {
    if (sequence.parent === null) {
      return true;
    }
    const cached = completenessById.get(sequence.id);
    if (cached !== undefined) {
      return cached;
    }
    const parent = registeredSequencesById.get(sequence.parent);
    const complete = parent !== undefined && hasCompleteAncestors(parent);
    completenessById.set(sequence.id, complete);
    return complete;
  };
  const completeSequences = sequences.filter(hasCompleteAncestors);
  const sortedSequences = sortItemsByCommitOrder(completeSequences, (sequence) => sequence.timelineOrder);
  const connectedCompositionsBySequenceId = new Map;
  const compositionsByComponent = new Map;
  for (const composition of compositions) {
    const component = composition.componentFromProps;
    if (component === null || component === undefined || typeof component === "number" && Number.isNaN(component)) {
      continue;
    }
    const connectedCompositions = compositionsByComponent.get(component);
    if (connectedCompositions) {
      connectedCompositions.push(composition);
    } else {
      compositionsByComponent.set(component, [composition]);
    }
  }
  for (const sequence of sortedSequences) {
    const connectedCompositions = compositionsByComponent.get(sequence.singleChildComponent);
    if (connectedCompositions) {
      connectedCompositionsBySequenceId.set(sequence.id, connectedCompositions.slice());
    }
  }
  const sequencesById = new Map(sortedSequences.map((sequence) => [sequence.id, sequence]));
  const childrenByParentId = new Map;
  for (const sequence of sortedSequences) {
    if (sequence.parent === null) {
      continue;
    }
    const siblings = childrenByParentId.get(sequence.parent);
    if (siblings) {
      siblings.push(sequence);
    } else {
      childrenByParentId.set(sequence.parent, [sequence]);
    }
  }
  const timingsById = new Map;
  const getTiming = (sequence) => {
    const cached = timingsById.get(sequence.id);
    if (cached) {
      return cached;
    }
    const parent = sequence.parent === null ? null : sequencesById.get(sequence.parent);
    if (sequence.parent !== null && !parent) {
      throw new TypeError("Parent not found for sequence " + sequence.id);
    }
    const parentTiming = parent ? getTiming(parent) : null;
    const parentPlaybackRate = parent ? parent.sequencePlaybackRate * parentTiming.parentPlaybackRate : 1;
    const sequencePlaybackRate = parentPlaybackRate * sequence.sequencePlaybackRate;
    const cascadedStart = parentTiming ? parentTiming.cascadedStart + (sequence.from - (parent.trimBefore ?? 0)) / parentPlaybackRate : sequence.from;
    const visibleStart = parentTiming ? Math.max(parentTiming.visibleStart, Math.max(0, cascadedStart)) : Math.max(0, cascadedStart);
    const end = cascadedStart + sequence.duration / parentPlaybackRate;
    const visibleDuration = Math.max(0, (parentTiming ? Math.min(end, parentTiming.visibleStart + parentTiming.visibleDuration) : end) - visibleStart);
    const loopOwner = sequence.loopDisplay ? sequence : parentTiming?.loopOwner ?? null;
    const mediaIterationStart = sequence.loopDisplay ? cascadedStart : parentTiming?.loopOwner ? Math.max(parentTiming.mediaIterationStart, cascadedStart) : cascadedStart;
    const trackClip = sequence.timelineTrack?.role === "clip" ? sequence : parentTiming?.trackClip && (!sequence.showInTimeline || sequence.singleChildComponent === parentTiming.trackClip.singleChildComponent) ? parentTiming.trackClip : null;
    const timing = {
      parentPlaybackRate,
      sequencePlaybackRate,
      cascadedStart,
      visibleStart,
      visibleDuration,
      depth: parentTiming ? parentTiming.depth + (parent.showInTimeline ? 1 : 0) : 0,
      loopOwner,
      mediaIterationStart,
      trackClip,
      hasCollapsedConnectedCompositionAncestor: parent ? parentTiming.hasCollapsedConnectedCompositionAncestor || connectedCompositionsBySequenceId.has(parent.id) && !(showConnectedCompositionChildren && (parent.timelineTrack?.role === "track" || parentTiming.trackClip?.singleChildComponent === parent.singleChildComponent)) : false,
      isFrozen: sequence.frozenFrame !== null || (parentTiming?.isFrozen ?? false)
    };
    timingsById.set(sequence.id, timing);
    return timing;
  };
  const timelineSequences = sortedSequences.filter((sequence) => !getTiming(sequence).hasCollapsedConnectedCompositionAncestor);
  const getTrack = (sequence) => {
    const timing = getTiming(sequence);
    const parentTiming = sequence.parent === null ? null : getTiming(sequencesById.get(sequence.parent));
    const {
      cascadedStart,
      parentPlaybackRate,
      sequencePlaybackRate,
      visibleStart,
      visibleDuration
    } = timing;
    const cascadedStartWithTrim = cascadedStart - (sequence.trimBefore ?? 0) / sequencePlaybackRate;
    let displayDuration = visibleDuration;
    if (sequence.autoDuration && !timing.isFrozen && timing.loopOwner === null) {
      let end = visibleStart;
      for (const child of childrenByParentId.get(sequence.id) ?? []) {
        end = Math.max(end, getTiming(child).cascadedStart + (child.unclippedDuration ?? child.duration) / sequencePlaybackRate);
      }
      displayDuration = Math.min(visibleDuration, end - visibleStart);
    }
    let loopDisplay;
    if (sequence.loopDisplay || sequence.type === "audio" || sequence.type === "video" || sequence.type === "image" && sequence.animated !== null) {
      const owner = timing.loopOwner;
      if (owner?.loopDisplay) {
        const ownerTiming = getTiming(owner);
        const durationInFrames = owner.loopDisplay.durationInFrames / ownerTiming.parentPlaybackRate;
        const origin = timing.mediaIterationStart + owner.loopDisplay.startOffset / ownerTiming.parentPlaybackRate;
        let start = Math.max(0, origin);
        let end = origin + durationInFrames * owner.loopDisplay.numberOfTimes;
        if (owner.parent !== null) {
          const loopParentTiming = getTiming(sequencesById.get(owner.parent));
          start = Math.max(start, loopParentTiming.visibleStart);
          end = Math.min(end, loopParentTiming.visibleStart + loopParentTiming.visibleDuration);
        }
        loopDisplay = {
          durationInFrames,
          numberOfTimes: Math.max(0, end - start) / durationInFrames,
          startOffset: start - visibleStart,
          phaseOffsetInFrames: (start - origin) % durationInFrames,
          mediaOffsetInFrames: visibleStart - timing.mediaIterationStart
        };
      }
    }
    const overrideId = sequence.controls?.overrideId ?? null;
    const nodePath = overrideId ? overrideIdsToNodePaths[overrideId] : null;
    const hasKeyframeRows = sequence.controls !== null || sequence.effects.length > 0;
    const connectedCompositions = connectedCompositionsBySequenceId.get(sequence.id) ?? [];
    return {
      ...connectedCompositions.length > 0 ? { connectedCompositions } : {},
      sequence: {
        ...sequence,
        from: visibleStart,
        sequencePlaybackRate,
        premountDisplay: sequence.premountDisplay === null ? null : sequence.premountDisplay / parentPlaybackRate,
        postmountDisplay: sequence.postmountDisplay === null ? null : sequence.postmountDisplay / parentPlaybackRate,
        duration: displayDuration,
        loopDisplay
      },
      depth: timing.depth,
      cascadedStart,
      localStart: sequence.from,
      parentVisibleStart: parentTiming?.visibleStart ?? 0,
      parentVisibleEnd: parentTiming ? parentTiming.visibleStart + parentTiming.visibleDuration : null,
      keyframeDisplayOffset: hasKeyframeRows ? cascadedStart - sequence.from / parentPlaybackRate : 0,
      sequenceFrameOffset: (visibleStart - cascadedStartWithTrim) * sequencePlaybackRate,
      keyframePlaybackRate: parentPlaybackRate,
      nodePathInfo: nodePath ? {
        sequenceSubscriptionKey: {
          ...nodePath,
          videoConfigValues: sequence.controls?.videoConfigValues ?? null
        },
        auxiliaryKeys: [],
        index: 0,
        numberOfSequencesWithThisNodePath: 0,
        supportsEffects: sequence.controls?.supportsEffects === true
      } : null
    };
  };
  const tracks = timelineSequences.map(getTrack);
  const sequenceRanks = new Map;
  for (let i = 0;i < tracks.length; i++) {
    sequenceRanks.set(tracks[i].sequence.id, i);
  }
  const tracksById = new Map(tracks.map((track) => [track.sequence.id, track]));
  const sortKeysById = new Map;
  const getSortKey = (track) => {
    const cached = sortKeysById.get(track.sequence.id);
    if (cached !== undefined) {
      return cached;
    }
    const rank = sequenceRanks.get(track.sequence.id) ?? 0;
    const id = String(rank).padStart(6, "0");
    const parent = track.sequence.parent !== null ? tracksById.get(track.sequence.parent) : null;
    const key = parent ? `${getSortKey(parent)}-${id}` : id;
    sortKeysById.set(track.sequence.id, key);
    return key;
  };
  const sortedTracks = tracks.map((track) => ({ track, sortKey: getSortKey(track) })).sort((a, b) => a.sortKey.localeCompare(b.sortKey)).map(({ track }) => track);
  const nodePathIndexCounters = new Map;
  let currentTracks = sortedTracks.map((track) => {
    if (track.nodePathInfo === null) {
      return track;
    }
    const key = timelineSequenceNodePathToKey(track.nodePathInfo.sequenceSubscriptionKey);
    const index = nodePathIndexCounters.get(key) ?? 0;
    nodePathIndexCounters.set(key, index + 1);
    return {
      ...track,
      nodePathInfo: {
        sequenceSubscriptionKey: track.nodePathInfo.sequenceSubscriptionKey,
        auxiliaryKeys: track.nodePathInfo.auxiliaryKeys,
        index,
        numberOfSequencesWithThisNodePath: 0,
        supportsEffects: track.nodePathInfo.supportsEffects
      }
    };
  }).map((track) => {
    if (track.nodePathInfo === null) {
      return track;
    }
    const key = timelineSequenceNodePathToKey(track.nodePathInfo.sequenceSubscriptionKey);
    return {
      ...track,
      nodePathInfo: {
        sequenceSubscriptionKey: track.nodePathInfo.sequenceSubscriptionKey,
        auxiliaryKeys: track.nodePathInfo.auxiliaryKeys,
        index: track.nodePathInfo.index,
        numberOfSequencesWithThisNodePath: nodePathIndexCounters.get(key) ?? 0,
        supportsEffects: track.nodePathInfo.supportsEffects
      }
    };
  });
  if (previous !== null && previous.input.overrideIdsToNodePaths === overrideIdsToNodePaths && (previous.input.compositions ?? EMPTY_COMPOSITIONS) === compositions) {
    const previousSequencesById = new Map(previous.input.sequences.map((sequence) => [sequence.id, sequence]));
    currentTracks = currentTracks.map((track) => {
      const previousIndex = previous.result.structure.trackIndexById.get(track.sequence.id);
      if (previousIndex === undefined) {
        return track;
      }
      const oldTrack = previous.result.tracks[previousIndex];
      const oldNodePath = oldTrack.nodePathInfo;
      const nodePath = track.nodePathInfo;
      const oldLoop = oldTrack.sequence.loopDisplay;
      const loop = track.sequence.loopDisplay;
      if (sequencesById.get(track.sequence.id) !== previousSequencesById.get(track.sequence.id) || oldTrack.depth !== track.depth || oldTrack.cascadedStart !== track.cascadedStart || oldTrack.localStart !== track.localStart || oldTrack.parentVisibleStart !== track.parentVisibleStart || oldTrack.parentVisibleEnd !== track.parentVisibleEnd || oldTrack.keyframeDisplayOffset !== track.keyframeDisplayOffset || oldTrack.keyframePlaybackRate !== track.keyframePlaybackRate || oldTrack.sequenceFrameOffset !== track.sequenceFrameOffset || oldTrack.sequence.from !== track.sequence.from || oldTrack.sequence.duration !== track.sequence.duration || oldTrack.sequence.sequencePlaybackRate !== track.sequence.sequencePlaybackRate || oldTrack.sequence.premountDisplay !== track.sequence.premountDisplay || oldTrack.sequence.postmountDisplay !== track.sequence.postmountDisplay || oldNodePath === null !== (nodePath === null) || oldNodePath?.index !== nodePath?.index || oldNodePath?.numberOfSequencesWithThisNodePath !== nodePath?.numberOfSequencesWithThisNodePath || oldLoop === undefined !== (loop === undefined) || oldLoop !== undefined && loop !== undefined && (oldLoop.durationInFrames !== loop.durationInFrames || oldLoop.numberOfTimes !== loop.numberOfTimes || oldLoop.startOffset !== loop.startOffset || oldLoop.phaseOffsetInFrames !== loop.phaseOffsetInFrames || oldLoop.mediaOffsetInFrames !== loop.mediaOffsetInFrames)) {
        return track;
      }
      return oldTrack;
    });
  }
  const trackIndexById = new Map(currentTracks.map((track, index) => [track.sequence.id, index]));
  const structure = { trackIndexById };
  let currentSequences = sequences;
  const update = (input) => {
    if (input.overrideIdsToNodePaths !== overrideIdsToNodePaths || (input.compositions ?? EMPTY_COMPOSITIONS) !== compositions || (input.showConnectedCompositionChildren ?? false) !== showConnectedCompositionChildren) {
      return null;
    }
    if (input.sequences.length !== currentSequences.length || sequencesById.size !== currentSequences.length) {
      return null;
    }
    const changed = [];
    for (let i = 0;i < input.sequences.length; i++) {
      const sequence = input.sequences[i];
      const previousSequence = currentSequences[i];
      if (sequence === previousSequence) {
        continue;
      }
      if (sequence.id !== previousSequence.id || sequence.type !== "audio" && sequence.type !== "video" || sequence.frozenMediaFrame !== null || sequence.autoDuration || sequence.isInsideSeries || sequence.timelineTrack !== undefined || childrenByParentId.has(sequence.id) || !trackIndexById.has(sequence.id)) {
        return null;
      }
      const keys = Object.keys(sequence);
      if (keys.length !== Object.keys(previousSequence).length) {
        return null;
      }
      for (const key of keys) {
        if (!Object.hasOwn(previousSequence, key)) {
          return null;
        }
        if (key === "from" || key === "duration" || key === "trimBefore" || key === "startMediaFrom" || key === "mediaFrameAtSequenceZero") {
          continue;
        }
        if (sequence[key] !== previousSequence[key]) {
          return null;
        }
      }
      const timing = timingsById.get(sequence.id);
      if (timing.loopOwner !== null || timing.isFrozen) {
        return null;
      }
      if (sequence.parent !== null && sequencesById.get(sequence.parent).autoDuration) {
        return null;
      }
      changed.push(sequence);
    }
    if (changed.length > 0) {
      const nextTracks = currentTracks.slice();
      for (const sequence of changed) {
        const index = trackIndexById.get(sequence.id);
        const previousTrack = currentTracks[index];
        sequencesById.set(sequence.id, sequence);
        timingsById.delete(sequence.id);
        const track = getTrack(sequence);
        if (track.sequence.duration > 0 !== previousTrack.sequence.duration > 0) {
          return null;
        }
        nextTracks[index] = {
          ...track,
          nodePathInfo: previousTrack.nodePathInfo
        };
      }
      currentTracks = nextTracks;
    }
    currentSequences = input.sequences;
    return {
      tracks: currentTracks,
      structure
    };
  };
  return {
    result: { tracks: currentTracks, structure },
    update
  };
};
var createTimelineCalculator = () => {
  let state = null;
  let previous = null;
  return (input) => {
    if (previous !== null && input.sequences === previous.input.sequences && input.overrideIdsToNodePaths === previous.input.overrideIdsToNodePaths && (input.compositions ?? EMPTY_COMPOSITIONS) === (previous.input.compositions ?? EMPTY_COMPOSITIONS) && (input.showConnectedCompositionChildren ?? false) === (previous.input.showConnectedCompositionChildren ?? false)) {
      return previous.result;
    }
    const updated = state?.update(input) ?? null;
    if (updated !== null) {
      previous = { input, result: updated };
      return updated;
    }
    state = calculateTimelineState(input, previous);
    previous = { input, result: state.result };
    return state.result;
  };
};
// src/hover.ts
import { useCallback, useMemo } from "react";

// src/selection.ts
import { useState } from "react";

// src/use-sync-external-store.ts
import { Internals as Internals4 } from "remotion";
var {
  useSyncExternalStore
} = Internals4;

// src/selection.ts
var EMPTY_CANVAS_SELECTION = {
  selectedItems: [],
  anchor: null
};
var getCanvasNodePathInfoKey = (info) => [
  `${info.sequenceSubscriptionKey.absolutePath}:${JSON.stringify(info.sequenceSubscriptionKey.nodePath)}:${info.sequenceSubscriptionKey.sequenceKeys.join("\x00")}`,
  info.auxiliaryKeys.join("."),
  info.index
].join(".");
var getCanvasSequenceSelectionKey = (nodePathInfo) => getCanvasNodePathInfoKey({ ...nodePathInfo, auxiliaryKeys: [] });
var getCanvasSelectionItemKey = (item) => {
  switch (item.type) {
    case "guide":
      return `guide.${item.guideId}`;
    case "sequence":
      return `${getCanvasSequenceSelectionKey(item.nodePathInfo)}.sequence`;
    case "sequence-prop":
      return `${getCanvasSequenceSelectionKey(item.nodePathInfo)}.sequence-prop.${item.key}`;
    case "sequence-all-effects":
      return `${getCanvasSequenceSelectionKey(item.nodePathInfo)}.sequence-all-effects`;
    case "sequence-effect":
      return `${getCanvasSequenceSelectionKey(item.nodePathInfo)}.sequence-effect.${item.i}`;
    case "sequence-effect-prop":
      return `${getCanvasSequenceSelectionKey(item.nodePathInfo)}.sequence-effect-prop.${item.i}.${item.key}`;
    case "keyframe":
      return `${getCanvasNodePathInfoKey(item.nodePathInfo)}.keyframe.${item.frame}`;
    case "easing":
      return `${getCanvasNodePathInfoKey(item.nodePathInfo)}.easing.${item.segmentIndex}`;
    default:
      throw new Error(`Unexpected Canvas selection type: ${item}`);
  }
};
var getCanvasSelectionType = (item) => item.type;
var areCanvasSelectionTypesCompatible = (firstType, secondType) => {
  if (firstType === secondType) {
    return true;
  }
  return firstType === "sequence-prop" && secondType === "sequence-effect-prop" || firstType === "sequence-effect-prop" && secondType === "sequence-prop" || firstType === "keyframe" && secondType === "easing" || firstType === "easing" && secondType === "keyframe";
};
var isCanvasSelectionCompatibleWithType = (item, type) => areCanvasSelectionTypesCompatible(getCanvasSelectionType(item), type);
var getCanvasSelectionAnchor = (selectedItems, previousAnchor, targetType) => {
  if (previousAnchor && getCanvasSelectionType(previousAnchor) === targetType) {
    return previousAnchor;
  }
  for (let i = selectedItems.length - 1;i >= 0; i--) {
    const candidate = selectedItems[i];
    if (getCanvasSelectionType(candidate) === targetType) {
      return candidate;
    }
  }
  return null;
};
var getCanvasRangeSelection = ({
  anchor,
  clickedItem,
  allSelectableItems
}) => {
  const anchorKey = getCanvasSelectionItemKey(anchor);
  const clickedKey = getCanvasSelectionItemKey(clickedItem);
  const orderedOfType = allSelectableItems.filter((item) => getCanvasSelectionType(item) === clickedItem.type);
  const anchorIndex = orderedOfType.findIndex((item) => getCanvasSelectionItemKey(item) === anchorKey);
  const clickedIndex = orderedOfType.findIndex((item) => getCanvasSelectionItemKey(item) === clickedKey);
  if (anchorIndex === -1 || clickedIndex === -1) {
    return [clickedItem];
  }
  const [from, to] = anchorIndex < clickedIndex ? [anchorIndex, clickedIndex] : [clickedIndex, anchorIndex];
  return orderedOfType.slice(from, to + 1);
};
var getCanvasSelectionAfterInteraction = ({
  currentState,
  clickedItem,
  interaction,
  allSelectableItems
}) => {
  const { selectedItems, anchor: previousAnchor } = currentState;
  const clickedType = getCanvasSelectionType(clickedItem);
  if (clickedType === "guide") {
    return {
      selectedItems: [clickedItem],
      anchor: clickedItem
    };
  }
  const nextAnchor = getCanvasSelectionAnchor(selectedItems, previousAnchor, clickedType);
  const clickedKey = getCanvasSelectionItemKey(clickedItem);
  if (interaction.shiftKey && nextAnchor) {
    return {
      selectedItems: getCanvasRangeSelection({
        anchor: nextAnchor,
        clickedItem,
        allSelectableItems
      }),
      anchor: nextAnchor
    };
  }
  if (interaction.toggleKey) {
    const compatibleItems = selectedItems.filter((item) => isCanvasSelectionCompatibleWithType(item, clickedType));
    const existingKeySet = new Set(compatibleItems.map(getCanvasSelectionItemKey));
    if (existingKeySet.has(clickedKey)) {
      const toggledSelection = compatibleItems.filter((item) => getCanvasSelectionItemKey(item) !== clickedKey);
      return {
        selectedItems: toggledSelection,
        anchor: toggledSelection.length === 0 ? null : clickedItem
      };
    }
    const selectableOrderMap = new Map(allSelectableItems.filter((item) => isCanvasSelectionCompatibleWithType(item, clickedType)).map((item, index) => [getCanvasSelectionItemKey(item), index]));
    const extendedSelection = [...compatibleItems, clickedItem].sort((a, b) => {
      return (selectableOrderMap.get(getCanvasSelectionItemKey(a)) ?? 0) - (selectableOrderMap.get(getCanvasSelectionItemKey(b)) ?? 0);
    });
    return {
      selectedItems: extendedSelection,
      anchor: clickedItem
    };
  }
  return {
    selectedItems: [clickedItem],
    anchor: clickedItem
  };
};
var createCanvasSelectionController = () => {
  let snapshot = EMPTY_CANVAS_SELECTION;
  const listeners = new Set;
  const setSnapshot = (nextSnapshot) => {
    snapshot = nextSnapshot;
    for (const listener of listeners) {
      listener();
    }
  };
  return {
    getSnapshot: () => snapshot,
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    select: (item, interaction, allSelectableItems) => {
      setSnapshot(getCanvasSelectionAfterInteraction({
        currentState: snapshot,
        clickedItem: item,
        interaction,
        allSelectableItems
      }));
    },
    setSelectedItems: (items) => {
      setSnapshot({
        selectedItems: items,
        anchor: items.at(-1) ?? null
      });
    },
    setSnapshot,
    clear: () => setSnapshot(EMPTY_CANVAS_SELECTION)
  };
};
var useCanvasSelectionController = () => {
  const [controller] = useState(createCanvasSelectionController);
  return controller;
};
var useCanvasSelection = (controller) => {
  return useSyncExternalStore(controller.subscribe, controller.getSnapshot, controller.getSnapshot);
};

// src/hover.ts
var createCanvasHoverController = () => {
  let hoveredSequence = null;
  const listeners = new Set;
  const setHoveredSequence = (action) => {
    const nextHoveredSequence = typeof action === "function" ? action(hoveredSequence) : action;
    if (nextHoveredSequence === hoveredSequence || nextHoveredSequence !== null && hoveredSequence !== null && nextHoveredSequence.key === hoveredSequence.key && nextHoveredSequence.nodePathKey === hoveredSequence.nodePathKey && nextHoveredSequence.source === hoveredSequence.source) {
      return;
    }
    hoveredSequence = nextHoveredSequence;
    for (const listener of listeners) {
      listener();
    }
  };
  return {
    getSnapshot: () => hoveredSequence,
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    setHoveredSequence,
    clear: (source) => {
      if (source === null || hoveredSequence?.source === source) {
        setHoveredSequence(null);
      }
    }
  };
};
var useCanvasHover = (controller) => {
  return useSyncExternalStore(controller.subscribe, controller.getSnapshot, controller.getSnapshot);
};
var useIsCanvasSequenceHovered = (controller, nodePathKey) => {
  const getSnapshot = useCallback(() => nodePathKey !== null && controller.getSnapshot()?.nodePathKey === nodePathKey, [controller, nodePathKey]);
  return useSyncExternalStore(controller.subscribe, getSnapshot, getSnapshot);
};
var useCanvasSequenceHover = (controller, nodePathInfo, source) => {
  const sequenceKey = useMemo(() => nodePathInfo === null ? null : getCanvasSequenceSelectionKey(nodePathInfo), [nodePathInfo]);
  const nodePathKey = useMemo(() => nodePathInfo === null ? null : timelineSequenceNodePathToKey(nodePathInfo.sequenceSubscriptionKey), [nodePathInfo]);
  const hovered = useIsCanvasSequenceHovered(controller, nodePathKey);
  const onPointerEnter = useCallback(() => {
    if (sequenceKey === null || nodePathKey === null) {
      return;
    }
    controller.setHoveredSequence({
      key: sequenceKey,
      nodePathKey,
      source
    });
  }, [controller, nodePathKey, sequenceKey, source]);
  const onPointerLeave = useCallback(() => {
    controller.setHoveredSequence((currentHover) => {
      if (currentHover?.source !== source || currentHover.key !== sequenceKey || currentHover.nodePathKey !== nodePathKey) {
        return currentHover;
      }
      return null;
    });
  }, [controller, nodePathKey, sequenceKey, source]);
  return useMemo(() => ({ hovered, onPointerEnter, onPointerLeave }), [hovered, onPointerEnter, onPointerLeave]);
};
// src/outline-geometry.ts
var scaleCanvasOutline = (outline, scale) => {
  if (scale === 1) {
    return outline;
  }
  const scalePoint = (point) => ({
    x: point.x * scale,
    y: point.y * scale
  });
  const scalePoints = ([
    tl,
    tr,
    br,
    bl
  ]) => [
    scalePoint(tl),
    scalePoint(tr),
    scalePoint(br),
    scalePoint(bl)
  ];
  const points = scalePoints(outline.points);
  return {
    ...outline,
    points,
    uncroppedPoints: outline.uncroppedPoints === null ? null : outline.uncroppedPoints === outline.points ? points : scalePoints(outline.uncroppedPoints),
    path: outline.path === null ? null : {
      d: outline.path.d,
      matrix: {
        a: outline.path.matrix.a * scale,
        b: outline.path.matrix.b * scale,
        c: outline.path.matrix.c * scale,
        d: outline.path.matrix.d * scale,
        e: outline.path.matrix.e * scale,
        f: outline.path.matrix.f * scale
      }
    }
  };
};
var mix = (from, to, progress) => {
  return from + (to - from) * progress;
};
var mixPoint = (from, to, progress) => {
  return {
    x: mix(from.x, to.x, progress),
    y: mix(from.y, to.y, progress)
  };
};
var getBilinearUvHandlePosition = (points, uv) => {
  const [tl, tr, br, bl] = points;
  const top = mixPoint(tl, tr, uv[0]);
  const bottom = mixPoint(bl, br, uv[0]);
  return mixPoint(top, bottom, uv[1]);
};
var projectiveEpsilon = 0.000001;
var getProjectiveTransform = (points) => {
  const [tl, tr, br, bl] = points;
  const dx1 = tr.x - br.x;
  const dx2 = bl.x - br.x;
  const dx3 = tl.x - tr.x + br.x - bl.x;
  const dy1 = tr.y - br.y;
  const dy2 = bl.y - br.y;
  const dy3 = tl.y - tr.y + br.y - bl.y;
  let g = 0;
  let h = 0;
  if (Math.abs(dx3) > projectiveEpsilon || Math.abs(dy3) > projectiveEpsilon) {
    const determinant = dx1 * dy2 - dx2 * dy1;
    if (Math.abs(determinant) < projectiveEpsilon) {
      return null;
    }
    g = (dx3 * dy2 - dx2 * dy3) / determinant;
    h = (dx1 * dy3 - dx3 * dy1) / determinant;
  }
  return {
    a: tr.x - tl.x + g * tr.x,
    b: bl.x - tl.x + h * bl.x,
    c: tl.x,
    d: tr.y - tl.y + g * tr.y,
    e: bl.y - tl.y + h * bl.y,
    f: tl.y,
    g,
    h
  };
};
var applyProjectiveTransform = (transform, uv) => {
  const denominator = transform.g * uv[0] + transform.h * uv[1] + 1;
  return {
    x: (transform.a * uv[0] + transform.b * uv[1] + transform.c) / denominator,
    y: (transform.d * uv[0] + transform.e * uv[1] + transform.f) / denominator
  };
};
var getCanvasOutlinePoint = (points, uv) => {
  const transform = getProjectiveTransform(points);
  return transform === null ? getBilinearUvHandlePosition(points, uv) : applyProjectiveTransform(transform, uv);
};
var vectorBetween = (from, to) => {
  return { x: to.x - from.x, y: to.y - from.y };
};
var getBilinearUvCoordinateForPoint = (points, point) => {
  const [tl, tr, br, bl] = points;
  let u = 0.5;
  let v = 0.5;
  for (let i = 0;i < 8; i++) {
    const current = getBilinearUvHandlePosition(points, [u, v]);
    const errorX = current.x - point.x;
    const errorY = current.y - point.y;
    if (Math.abs(errorX) + Math.abs(errorY) < 0.001) {
      break;
    }
    const du = {
      x: mix(tr.x - tl.x, br.x - bl.x, v),
      y: mix(tr.y - tl.y, br.y - bl.y, v)
    };
    const dv = vectorBetween(mixPoint(tl, tr, u), mixPoint(bl, br, u));
    const determinant = du.x * dv.y - du.y * dv.x;
    if (Math.abs(determinant) < 0.000001) {
      break;
    }
    u -= (errorX * dv.y - errorY * dv.x) / determinant;
    v -= (du.x * errorY - du.y * errorX) / determinant;
  }
  return [u, v];
};
var getCanvasOutlineUv = (points, point) => {
  const transform = getProjectiveTransform(points);
  if (transform === null) {
    return getBilinearUvCoordinateForPoint(points, point);
  }
  const determinant = transform.a * (transform.e - transform.f * transform.h) - transform.b * (transform.d - transform.f * transform.g) + transform.c * (transform.d * transform.h - transform.e * transform.g);
  if (Math.abs(determinant) < projectiveEpsilon) {
    return getBilinearUvCoordinateForPoint(points, point);
  }
  const inverseA = transform.e - transform.f * transform.h;
  const inverseB = transform.c * transform.h - transform.b;
  const inverseC = transform.b * transform.f - transform.c * transform.e;
  const inverseD = transform.f * transform.g - transform.d;
  const inverseE = transform.a - transform.c * transform.g;
  const inverseF = transform.c * transform.d - transform.a * transform.f;
  const inverseG = transform.d * transform.h - transform.e * transform.g;
  const inverseH = transform.b * transform.g - transform.a * transform.h;
  const inverseI = transform.a * transform.e - transform.b * transform.d;
  const denominator = inverseG * point.x + inverseH * point.y + inverseI;
  if (Math.abs(denominator) < projectiveEpsilon) {
    return getBilinearUvCoordinateForPoint(points, point);
  }
  return [
    (inverseA * point.x + inverseB * point.y + inverseC) / denominator,
    (inverseD * point.x + inverseE * point.y + inverseF) / denominator
  ];
};
// src/get-box-quads-polyfill-internals.js
function convertQuadFromNode(node, quad, from, options) {
  const ancestor = (node.ownerDocument.defaultView ?? window).document.body;
  const m1 = getResultingTransformationBetweenElementAndAllAncestors(from, ancestor, options?.iframes, true);
  const m2 = getResultingTransformationBetweenElementAndAllAncestors(node, ancestor, options?.iframes, true).inverse();
  if (options?.fromBox && options?.fromBox !== "border") {
    const fromStyle = getCachedComputedStyle(from);
    quad = new DOMQuad(transformPointBox(quad.p1, options.fromBox, fromStyle, -1), transformPointBox(quad.p2, options.fromBox, fromStyle, -1), transformPointBox(quad.p3, options.fromBox, fromStyle, -1), transformPointBox(quad.p4, options.fromBox, fromStyle, -1));
  }
  let res = new DOMQuad(m2.transformPoint(m1.transformPoint(quad.p1)), m2.transformPoint(m1.transformPoint(quad.p2)), m2.transformPoint(m1.transformPoint(quad.p3)), m2.transformPoint(m1.transformPoint(quad.p4)));
  if (options?.toBox && options?.toBox !== "border" && (node instanceof Element || node instanceof (node.ownerDocument.defaultView ?? window).Element)) {
    const nodeStyle = getCachedComputedStyle(node);
    res = new DOMQuad(transformPointBox(res.p1, options.toBox, nodeStyle, -1), transformPointBox(res.p2, options.toBox, nodeStyle, -1), transformPointBox(res.p3, options.toBox, nodeStyle, -1), transformPointBox(res.p4, options.toBox, nodeStyle, -1));
  }
  return res;
}
function transformPointBox(point, box, style, operator) {
  if (box === "margin") {
    const mLeft = parseFloat(style.marginLeft);
    const mTop = parseFloat(style.marginTop);
    return new DOMPoint(point.x - operator * mLeft, point.y - operator * mTop);
  } else if (box === "padding") {
    const bLeft = parseFloat(style.borderLeftWidth);
    const bTop = parseFloat(style.borderTopWidth);
    return new DOMPoint(point.x + operator * bLeft, point.y + operator * bTop);
  } else if (box === "content") {
    const bLeft = parseFloat(style.borderLeftWidth);
    const bTop = parseFloat(style.borderTopWidth);
    const pLeft = parseFloat(style.paddingLeft);
    const pTop = parseFloat(style.paddingTop);
    return new DOMPoint(point.x + operator * (bLeft + pLeft), point.y + operator * (bTop + pTop));
  }
  return point;
}
var hash;
var boxQuadsCache;
var transformCache;
var computedStyleCache;
var hashId = 0;
function useCache() {
  hash = new WeakMap;
  boxQuadsCache = new Map;
  transformCache = new Map;
  computedStyleCache = new WeakMap;
}
function getCachedComputedStyle(element) {
  if (!computedStyleCache) {
    return (element.ownerDocument.defaultView ?? window).getComputedStyle(element);
  }
  let style = computedStyleCache.get(element);
  if (!style) {
    style = (element.ownerDocument.defaultView ?? window).getComputedStyle(element);
    computedStyleCache.set(element, style);
  }
  return style;
}
function isElementNode(node) {
  return !!node && node.nodeType === Node.ELEMENT_NODE;
}
function getElementZoom(element) {
  if (!isElementNode(element)) {
    return 1;
  }
  const actualElement = element;
  const zoom = getCachedComputedStyle(actualElement).zoom;
  if (!zoom || zoom === "normal") {
    return 1;
  }
  if (zoom.endsWith("%")) {
    const percentage = parseFloat(zoom);
    return Number.isFinite(percentage) && percentage > 0 ? percentage / 100 : 1;
  }
  const value = parseFloat(zoom);
  return Number.isFinite(value) && value > 0 ? value : 1;
}
function getElementZoomScaleTransform(element) {
  if (!isElementNode(element)) {
    return new DOMMatrix;
  }
  const zoom = getElementZoom(element);
  if (zoom === 1) {
    return new DOMMatrix;
  }
  return new DOMMatrix().scaleSelf(zoom);
}
function getElementTransformWithZoom(element, iframes, includeZoom = true) {
  const transform = getElementCombinedTransform(element, iframes);
  if (!includeZoom || !isElementNode(element)) {
    return transform;
  }
  const zoomTransform = getElementZoomScaleTransform(element);
  if (zoomTransform.isIdentity) {
    return transform;
  }
  return zoomTransform.multiply(transform);
}
function getBoxQuads(node, options) {
  const defaultRelativeTo = node.ownerDocument.documentElement ?? node.ownerDocument.body;
  const relativeTo = options?.relativeTo ?? defaultRelativeTo;
  const viewportRoot = node.ownerDocument.documentElement ?? node.ownerDocument.body;
  const resolveFixedThroughViewport = relativeTo !== viewportRoot && shouldResolveFixedPositionThroughViewport(node, relativeTo, options?.iframes);
  let key;
  if (boxQuadsCache) {
    let i1 = hash.get(node);
    if (i1 === undefined)
      hash.set(node, i1 = hashId++);
    let i2 = hash.get(relativeTo);
    if (i2 === undefined)
      hash.set(relativeTo, i2 = hashId++);
    key = i1 + "_" + i2 + "_" + (options?.box ?? "border");
    const q = boxQuadsCache.get(key);
    if (q)
      return q;
  }
  let originalElementAndAllParentsMultipliedMatrix = getResultingTransformationBetweenElementAndAllAncestors(node, resolveFixedThroughViewport ? viewportRoot : relativeTo, options?.iframes);
  const win = node.ownerDocument.defaultView ?? window;
  const _Text = win.Text;
  const _SVGGraphicsElement = win.SVGGraphicsElement;
  const _SVGSVGElement = win.SVGSVGElement;
  if (node instanceof Text || node instanceof _Text) {
    const canUseViewportTextRects = originalElementAndAllParentsMultipliedMatrix.is2D && Math.abs(originalElementAndAllParentsMultipliedMatrix.b) < 0.0000000001 && Math.abs(originalElementAndAllParentsMultipliedMatrix.c) < 0.0000000001;
    const range = node.ownerDocument.createRange();
    range.selectNodeContents(node);
    const clientRects = range.getClientRects();
    const convertViewportRectToRelativeQuad = (rect) => {
      return convertViewportQuadToRelativeNode(new DOMQuad(new DOMPoint(rect.x, rect.y), new DOMPoint(rect.x + rect.width, rect.y), new DOMPoint(rect.x + rect.width, rect.y + rect.height), new DOMPoint(rect.x, rect.y + rect.height)), node, relativeTo, options?.iframes);
    };
    if (clientRects.length > 1) {
      if (canUseViewportTextRects) {
        const quads = [];
        for (const cr of clientRects) {
          if (cr.width < 1 && cr.height < 1)
            continue;
          quads.push(convertViewportRectToRelativeQuad(cr));
        }
        if (quads.length > 0) {
          if (boxQuadsCache)
            boxQuadsCache.set(key, quads);
          return quads;
        }
      }
      const parent = getParentElementIncludingSlots(node, options?.iframes);
      const M_parent = getResultingTransformationBetweenElementAndAllAncestors(parent, resolveFixedThroughViewport ? viewportRoot : relativeTo, options?.iframes);
      const parentCss = getElementCombinedTransform(parent, options?.iframes);
      const pr = parent.getBoundingClientRect();
      const { a: pa, b: pb, c: pc, d: pd } = parentCss;
      const pw = parent.offsetWidth;
      const ph = parent.offsetHeight;
      const parentOriginX = pr.x + pr.width / 2 - (pa * pw / 2 + pc * ph / 2);
      const parentOriginY = pr.y + pr.height / 2 - (pb * pw / 2 + pd * ph / 2);
      const linearDet = pa * pd - pb * pc;
      const absA = Math.abs(pa), absB = Math.abs(pb);
      const absDet = absA * absA - absB * absB;
      const quads = [];
      for (const cr of clientRects) {
        if (cr.width < 1 && cr.height < 1)
          continue;
        const dx = cr.x + cr.width / 2 - parentOriginX;
        const dy = cr.y + cr.height / 2 - parentOriginY;
        let lcx, lcy;
        if (Math.abs(linearDet) > 0.0000000001) {
          lcx = (pd * dx - pc * dy) / linearDet;
          lcy = (pa * dy - pb * dx) / linearDet;
        } else {
          lcx = dx;
          lcy = dy;
        }
        let tw, th;
        if (Math.abs(absDet) > 0.000001) {
          tw = Math.max(0, (absA * cr.width - absB * cr.height) / absDet);
          th = Math.max(0, (absA * cr.height - absB * cr.width) / absDet);
        } else {
          const cs = getCachedComputedStyle(parent);
          th = Math.max(0, parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.2 || 16);
          const denom = Math.max(absA, absB);
          tw = denom > 0.000001 ? Math.max(0, (cr.width - th * absB) / denom) : cr.width;
        }
        const lx = lcx - tw / 2, ly = lcy - th / 2;
        const quad = new DOMQuad(M_parent.transformPoint(new DOMPoint(lx, ly)), M_parent.transformPoint(new DOMPoint(lx + tw, ly)), M_parent.transformPoint(new DOMPoint(lx + tw, ly + th)), M_parent.transformPoint(new DOMPoint(lx, ly + th)));
        quads.push(finishQuadRelativeToTarget(quad, node, relativeTo, options?.iframes, resolveFixedThroughViewport, options?.box));
      }
      if (quads.length > 0) {
        if (boxQuadsCache)
          boxQuadsCache.set(key, quads);
        return quads;
      }
    }
    const textBoundingRect = range.getBoundingClientRect();
    if (canUseViewportTextRects) {
      const tQuad = [convertViewportRectToRelativeQuad(textBoundingRect)];
      if (boxQuadsCache)
        boxQuadsCache.set(key, tQuad);
      return tQuad;
    }
    const { width: tw, height: th } = _getTextNodeSize(originalElementAndAllParentsMultipliedMatrix, textBoundingRect, node);
    const is2Dt = originalElementAndAllParentsMultipliedMatrix.is2D;
    const tCorners = [
      new DOMPoint(0, 0),
      new DOMPoint(tw, 0),
      new DOMPoint(tw, th),
      new DOMPoint(0, th)
    ];
    const tPoints = Array(4);
    if (is2Dt) {
      for (let i = 0;i < 4; i++)
        tPoints[i] = tCorners[i].matrixTransform(originalElementAndAllParentsMultipliedMatrix);
    } else {
      for (let i = 0;i < 4; i++) {
        tPoints[i] = projectPoint(tCorners[i], originalElementAndAllParentsMultipliedMatrix).matrixTransform(originalElementAndAllParentsMultipliedMatrix);
        tPoints[i] = as2DPoint(tPoints[i]);
      }
    }
    const tQuad = [
      finishQuadRelativeToTarget(new DOMQuad(tPoints[0], tPoints[1], tPoints[2], tPoints[3]), node, relativeTo, options?.iframes, resolveFixedThroughViewport, options?.box)
    ];
    if (boxQuadsCache)
      boxQuadsCache.set(key, tQuad);
    return tQuad;
  }
  if ((node instanceof SVGGraphicsElement || node instanceof _SVGGraphicsElement) && !(node instanceof SVGSVGElement || node instanceof _SVGSVGElement)) {
    const bbox = node.getBBox();
    const visualBox = getSvgVisualBox(node, bbox);
    const x0 = visualBox.x - bbox.x;
    const y0 = visualBox.y - bbox.y;
    const x1 = x0 + visualBox.width;
    const y1 = y0 + visualBox.height;
    const screenPts = [
      new DOMPoint(visualBox.x, visualBox.y),
      new DOMPoint(visualBox.x + visualBox.width, visualBox.y),
      new DOMPoint(visualBox.x + visualBox.width, visualBox.y + visualBox.height),
      new DOMPoint(visualBox.x, visualBox.y + visualBox.height)
    ];
    const pts = [
      new DOMPoint(x0, y0),
      new DOMPoint(x1, y0),
      new DOMPoint(x1, y1),
      new DOMPoint(x0, y1)
    ];
    const screenCtm = !hasTransformedHtmlAncestor(node, options?.iframes) ? node.getScreenCTM() : null;
    if (screenCtm) {
      const screenQuad = new DOMQuad(screenPts[0].matrixTransform(screenCtm), screenPts[1].matrixTransform(screenCtm), screenPts[2].matrixTransform(screenCtm), screenPts[3].matrixTransform(screenCtm));
      const svgQuad = [
        convertViewportQuadToRelativeNode(screenQuad, node, relativeTo, options?.iframes)
      ];
      if (boxQuadsCache)
        boxQuadsCache.set(key, svgQuad);
      return svgQuad;
    }
    const points = Array(4);
    if (originalElementAndAllParentsMultipliedMatrix.is2D) {
      for (let i = 0;i < 4; i++)
        points[i] = pts[i].matrixTransform(originalElementAndAllParentsMultipliedMatrix);
    } else {
      for (let i = 0;i < 4; i++) {
        points[i] = projectPoint(pts[i], originalElementAndAllParentsMultipliedMatrix).matrixTransform(originalElementAndAllParentsMultipliedMatrix);
        points[i] = as2DPoint(points[i]);
      }
    }
    const svgQuad = [
      finishQuadRelativeToTarget(new DOMQuad(points[0], points[1], points[2], points[3]), node, relativeTo, options?.iframes, resolveFixedThroughViewport, options?.box)
    ];
    if (boxQuadsCache)
      boxQuadsCache.set(key, svgQuad);
    return svgQuad;
  }
  if (node instanceof win.Element && relativeTo === node.ownerDocument.documentElement && (!options?.box || options.box === "border") && originalElementAndAllParentsMultipliedMatrix.is2D && Math.abs(originalElementAndAllParentsMultipliedMatrix.b) < 0.0000000001 && Math.abs(originalElementAndAllParentsMultipliedMatrix.c) < 0.0000000001) {
    const rect = node.getBoundingClientRect();
    const viewportQuad = [
      new DOMQuad(new DOMPoint(rect.x, rect.y), new DOMPoint(rect.x + rect.width, rect.y), new DOMPoint(rect.x + rect.width, rect.y + rect.height), new DOMPoint(rect.x, rect.y + rect.height))
    ];
    if (boxQuadsCache)
      boxQuadsCache.set(key, viewportQuad);
    return viewportQuad;
  }
  let { width, height } = getElementSize(node, originalElementAndAllParentsMultipliedMatrix);
  const _Element = win.Element;
  const is2D = originalElementAndAllParentsMultipliedMatrix.is2D;
  if (node instanceof Element || node instanceof _Element) {
    const box = options?.box;
    if (box === "margin" || box === "padding" || box === "content") {
      const cs = getCachedComputedStyle(node);
      let x0, y0, x1, y1, x2, y2, x3, y3;
      if (box === "margin") {
        const mL = parseFloat(cs.marginLeft);
        const mT = parseFloat(cs.marginTop);
        const mR = parseFloat(cs.marginRight);
        const mB = parseFloat(cs.marginBottom);
        x0 = -mL;
        y0 = -mT;
        x1 = width + mR;
        y1 = -mT;
        x2 = width + mR;
        y2 = height + mB;
        x3 = -mL;
        y3 = height + mB;
      } else if (box === "padding") {
        const bL = parseFloat(cs.borderLeftWidth);
        const bT = parseFloat(cs.borderTopWidth);
        const bR = parseFloat(cs.borderRightWidth);
        const bB = parseFloat(cs.borderBottomWidth);
        x0 = bL;
        y0 = bT;
        x1 = width - bR;
        y1 = bT;
        x2 = width - bR;
        y2 = height - bB;
        x3 = bL;
        y3 = height - bB;
      } else {
        const bL = parseFloat(cs.borderLeftWidth);
        const bT = parseFloat(cs.borderTopWidth);
        const bR = parseFloat(cs.borderRightWidth);
        const bB = parseFloat(cs.borderBottomWidth);
        const pL = parseFloat(cs.paddingLeft);
        const pT = parseFloat(cs.paddingTop);
        const pR = parseFloat(cs.paddingRight);
        const pB = parseFloat(cs.paddingBottom);
        x0 = bL + pL;
        y0 = bT + pT;
        x1 = width - bR - pR;
        y1 = bT + pT;
        x2 = width - bR - pR;
        y2 = height - bB - pB;
        x3 = bL + pL;
        y3 = height - bB - pB;
      }
      const pts = [
        new DOMPoint(x0, y0),
        new DOMPoint(x1, y1),
        new DOMPoint(x2, y2),
        new DOMPoint(x3, y3)
      ];
      const points = Array(4);
      if (is2D) {
        for (let i = 0;i < 4; i++)
          points[i] = pts[i].matrixTransform(originalElementAndAllParentsMultipliedMatrix);
      } else {
        for (let i = 0;i < 4; i++) {
          points[i] = projectPoint(pts[i], originalElementAndAllParentsMultipliedMatrix).matrixTransform(originalElementAndAllParentsMultipliedMatrix);
          points[i] = as2DPoint(points[i]);
        }
      }
      const quad = [
        finishQuadRelativeToTarget(new DOMQuad(points[0], points[1], points[2], points[3]), node, relativeTo, options?.iframes, resolveFixedThroughViewport, options?.box)
      ];
      if (boxQuadsCache)
        boxQuadsCache.set(key, quad);
      return quad;
    }
  }
  const corners = [
    new DOMPoint(0, 0),
    new DOMPoint(width, 0),
    new DOMPoint(width, height),
    new DOMPoint(0, height)
  ];
  const points = Array(4);
  if (is2D) {
    for (let i = 0;i < 4; i++)
      points[i] = corners[i].matrixTransform(originalElementAndAllParentsMultipliedMatrix);
  } else {
    for (let i = 0;i < 4; i++) {
      points[i] = projectPoint(corners[i], originalElementAndAllParentsMultipliedMatrix).matrixTransform(originalElementAndAllParentsMultipliedMatrix);
      points[i] = as2DPoint(points[i]);
    }
  }
  const quad = [
    finishQuadRelativeToTarget(new DOMQuad(points[0], points[1], points[2], points[3]), node, relativeTo, options?.iframes, resolveFixedThroughViewport, options?.box)
  ];
  if (boxQuadsCache)
    boxQuadsCache.set(key, quad);
  return quad;
}
function finishQuadRelativeToTarget(quad, node, relativeTo, iframes, resolveFixedThroughViewport, box) {
  if (resolveFixedThroughViewport) {
    quad = alignViewportBorderQuadToRenderedBox(quad, node, box);
    return convertViewportQuadToRelativeNode(quad, node, relativeTo, iframes);
  }
  return toViewportRelativeDocumentElementQuad(quad, node, relativeTo, iframes);
}
function alignViewportBorderQuadToRenderedBox(quad, node, box) {
  if (box && box !== "border") {
    return quad;
  }
  const win = node.ownerDocument.defaultView ?? window;
  if (!(node instanceof win.Element)) {
    return quad;
  }
  const rect = node.getBoundingClientRect();
  const left = Math.min(quad.p1.x, quad.p2.x, quad.p3.x, quad.p4.x);
  const top = Math.min(quad.p1.y, quad.p2.y, quad.p3.y, quad.p4.y);
  const dx = rect.left - left;
  const dy = rect.top - top;
  if (Math.abs(dx) < 0.0000000001 && Math.abs(dy) < 0.0000000001) {
    return quad;
  }
  const translate = (point) => new DOMPoint(point.x + dx, point.y + dy, point.z, point.w);
  return new DOMQuad(translate(quad.p1), translate(quad.p2), translate(quad.p3), translate(quad.p4));
}
function convertViewportQuadToRelativeNode(quad, node, relativeTo, iframes) {
  const viewportRoot = node.ownerDocument.documentElement ?? node.ownerDocument.body;
  if (relativeTo === viewportRoot) {
    return quad;
  }
  const win = node.ownerDocument.defaultView ?? window;
  if (relativeTo instanceof win.SVGElement) {
    const relativeScreenCtm = relativeTo.getScreenCTM();
    if (relativeScreenCtm) {
      const inverse = relativeScreenCtm.inverse();
      return new DOMQuad(quad.p1.matrixTransform(inverse), quad.p2.matrixTransform(inverse), quad.p3.matrixTransform(inverse), quad.p4.matrixTransform(inverse));
    }
  }
  if (relativeTo.ownerDocument === node.ownerDocument && relativeTo instanceof win.HTMLElement) {
    const htmlQuad = convertViewportQuadToHtmlElement(quad, relativeTo, iframes);
    if (htmlQuad) {
      return htmlQuad;
    }
  }
  if (relativeTo === node.ownerDocument.body) {
    const relativeRect = relativeTo.getBoundingClientRect();
    const scrollLeft = relativeTo.scrollLeft || 0;
    const scrollTop = relativeTo.scrollTop || 0;
    return new DOMQuad(new DOMPoint(quad.p1.x - relativeRect.x + scrollLeft, quad.p1.y - relativeRect.y + scrollTop), new DOMPoint(quad.p2.x - relativeRect.x + scrollLeft, quad.p2.y - relativeRect.y + scrollTop), new DOMPoint(quad.p3.x - relativeRect.x + scrollLeft, quad.p3.y - relativeRect.y + scrollTop), new DOMPoint(quad.p4.x - relativeRect.x + scrollLeft, quad.p4.y - relativeRect.y + scrollTop));
  }
  return convertQuadFromNode(relativeTo, quad, viewportRoot, { iframes });
}
function convertViewportQuadToHtmlElement(quad, relativeTo, iframes) {
  const scale = getPositiveAxisAlignedViewportScale(relativeTo, iframes);
  if (!scale) {
    return null;
  }
  const relativeRect = relativeTo.getBoundingClientRect();
  const scaleX = scale.x;
  const scaleY = scale.y;
  if (!Number.isFinite(scaleX) || !Number.isFinite(scaleY) || Math.abs(scaleX) < 0.0000000001 || Math.abs(scaleY) < 0.0000000001) {
    return null;
  }
  const scrollLeft = relativeTo.scrollLeft || 0;
  const scrollTop = relativeTo.scrollTop || 0;
  const convertPoint = (point) => new DOMPoint((point.x - relativeRect.x) / scaleX + scrollLeft, (point.y - relativeRect.y) / scaleY + scrollTop);
  return new DOMQuad(convertPoint(quad.p1), convertPoint(quad.p2), convertPoint(quad.p3), convertPoint(quad.p4));
}
function getPositiveAxisAlignedViewportScale(element, iframes) {
  const win = element.ownerDocument.defaultView ?? window;
  const scale = { x: 1, y: 1 };
  let current = element;
  while (current && current !== element.ownerDocument.documentElement) {
    if (current instanceof win.Element) {
      const style = getCachedComputedStyle(current);
      const transformScale = getPositiveAxisAlignedTransformScale(style);
      if (!transformScale) {
        return null;
      }
      const zoom = getElementZoom(current);
      scale.x *= transformScale.x * zoom;
      scale.y *= transformScale.y * zoom;
    }
    current = getParentElementIncludingSlots(current, iframes);
  }
  return scale;
}
function getPositiveAxisAlignedTransformScale(style) {
  if (style.perspective && style.perspective !== "none") {
    return null;
  }
  if (style.rotate && style.rotate !== "none" && !isZeroAngleValue(style.rotate)) {
    return null;
  }
  const individualScale = parsePositiveScaleValue(style.scale);
  if (!individualScale) {
    return null;
  }
  const transform = style.transform;
  if (!transform || transform === "none") {
    return individualScale;
  }
  if (transform.startsWith("matrix3d(")) {
    const values = parseCssMatrixValues(transform);
    if (values?.length === 16 && values[0] > 0 && values[5] > 0 && Math.abs(values[1]) < 0.0000000001 && Math.abs(values[4]) < 0.0000000001 && Math.abs(values[3]) < 0.0000000001 && Math.abs(values[7]) < 0.0000000001 && Math.abs(values[11]) < 0.0000000001) {
      return {
        x: individualScale.x * values[0],
        y: individualScale.y * values[5]
      };
    }
    return null;
  }
  if (transform.startsWith("matrix(")) {
    const values = parseCssMatrixValues(transform);
    if (values?.length === 6 && values[0] > 0 && values[3] > 0 && Math.abs(values[1]) < 0.0000000001 && Math.abs(values[2]) < 0.0000000001) {
      return {
        x: individualScale.x * values[0],
        y: individualScale.y * values[3]
      };
    }
    return null;
  }
  return null;
}
function parsePositiveScaleValue(value) {
  if (!value || value === "none") {
    return { x: 1, y: 1 };
  }
  const parts = value.split(/\s+/).map((part) => parseFloat(part)).filter(Number.isFinite);
  if (parts.length === 0 || parts[0] <= 0 || parts[1] != null && parts[1] <= 0) {
    return null;
  }
  return { x: parts[0], y: parts[1] ?? parts[0] };
}
function parseCssMatrixValues(transform) {
  const start = transform.indexOf("(");
  const end = transform.lastIndexOf(")");
  if (start < 0 || end <= start) {
    return null;
  }
  const values = transform.slice(start + 1, end).split(",").map((value) => parseFloat(value.trim()));
  return values.every(Number.isFinite) ? values : null;
}
function isZeroAngleValue(value) {
  const matches = value.match(/-?\d*\.?\d+(?:e[-+]?\d+)?/gi);
  if (!matches?.length) {
    return false;
  }
  const angle = parseFloat(matches[matches.length - 1]);
  return Number.isFinite(angle) && Math.abs(angle) < 0.0000000001;
}
function hasTransformedHtmlAncestor(node, iframes) {
  const win = node.ownerDocument.defaultView ?? window;
  let element = getParentElementIncludingSlots(node, iframes);
  while (element) {
    if (element instanceof win.HTMLElement) {
      const css = getCachedComputedStyle(element);
      if (transformProperties.some((value) => css[value] ? css[value] !== "none" : false)) {
        return true;
      }
    }
    if (element === node.ownerDocument.documentElement) {
      break;
    }
    element = getParentElementIncludingSlots(element, iframes);
  }
  return false;
}
function toViewportRelativeDocumentElementQuad(quad, node, relativeTo, iframes) {
  if (relativeTo !== node.ownerDocument.documentElement) {
    return quad;
  }
  if (isViewportFixedAnchoredNode(node, iframes)) {
    return quad;
  }
  const win = node.ownerDocument.defaultView ?? window;
  const scrollX = win.scrollX ?? node.ownerDocument.documentElement.scrollLeft ?? 0;
  const scrollY = win.scrollY ?? node.ownerDocument.documentElement.scrollTop ?? 0;
  if (scrollX === 0 && scrollY === 0) {
    return quad;
  }
  return new DOMQuad(new DOMPoint(quad.p1.x - scrollX, quad.p1.y - scrollY), new DOMPoint(quad.p2.x - scrollX, quad.p2.y - scrollY), new DOMPoint(quad.p3.x - scrollX, quad.p3.y - scrollY), new DOMPoint(quad.p4.x - scrollX, quad.p4.y - scrollY));
}
function isViewportFixedAnchoredNode(node, iframes) {
  const win = node.ownerDocument.defaultView ?? window;
  let element = null;
  if (node instanceof win.Text) {
    element = getParentElementIncludingSlots(node, iframes);
  } else if (node instanceof win.Element) {
    element = node;
  }
  while (element && element !== node.ownerDocument.documentElement) {
    const cs = getCachedComputedStyle(element);
    if (cs.position === "fixed") {
      return getNearestFixedContainingBlock(element, iframes) == null;
    }
    element = getParentElementIncludingSlots(element, iframes);
  }
  return false;
}
function shouldResolveFixedPositionThroughViewport(node, relativeTo, iframes) {
  const win = node.ownerDocument.defaultView ?? window;
  let element = null;
  if (node instanceof win.Text) {
    element = getParentElementIncludingSlots(node, iframes);
  } else if (node instanceof win.Element) {
    element = node;
  }
  while (element && element !== node.ownerDocument.documentElement) {
    const cs = getCachedComputedStyle(element);
    if (cs.position === "fixed") {
      const fixedContainer = getNearestFixedContainingBlock(element, iframes);
      return fixedContainer == null || fixedContainer !== relativeTo && !isFlatTreeInclusiveAncestor(relativeTo, fixedContainer);
    }
    if (element === relativeTo) {
      break;
    }
    element = getParentElementIncludingSlots(element, iframes);
  }
  return false;
}
function _getTextNodeSize(matrix, targetRect, node) {
  const absA = Math.abs(matrix?.a ?? 1);
  const absB = Math.abs(matrix?.b ?? 0);
  const det = absA * absA - absB * absB;
  let width, height;
  if (Math.abs(det) > 0.000001) {
    width = Math.max(0, (absA * targetRect.width - absB * targetRect.height) / det);
    height = Math.max(0, (absA * targetRect.height - absB * targetRect.width) / det);
  } else {
    const parentEl = node.parentElement;
    let lineH = 16;
    if (parentEl) {
      const cs = getCachedComputedStyle(parentEl);
      lineH = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.2 || 16;
    }
    height = Math.max(0, lineH);
    const denom = Math.max(absA, absB);
    width = denom > 0.000001 ? Math.max(0, (targetRect.width - height * absB) / denom) : targetRect.width;
  }
  return { width, height };
}
function projectPoint(point, m) {
  const z = -(point.x * m.m13 + point.y * m.m23 + m.m43) / m.m33;
  return new DOMPoint(point.x, point.y, z, 1);
}
function as2DPoint(point) {
  return new DOMPoint(point.x / point.w, point.y / point.w);
}
function getElementSize(node, matrix) {
  let width = 0;
  let height = 0;
  const win = node.ownerDocument.defaultView ?? window;
  if (node instanceof HTMLElement || node instanceof win.HTMLElement) {
    width = node.offsetWidth;
    height = node.offsetHeight;
  } else if (node instanceof SVGSVGElement || node instanceof win.SVGSVGElement) {
    width = node.width.baseVal.value;
    height = node.height.baseVal.value;
  } else if (node instanceof SVGGraphicsElement || node instanceof win.SVGGraphicsElement) {
    const bbox = node.getBBox();
    width = bbox.width;
    height = bbox.height;
  } else if (node instanceof MathMLElement || node instanceof win.MathMLElement) {
    const bbox = node.getBoundingClientRect();
    width = bbox.width / (matrix?.a ?? 1);
    height = bbox.height / (matrix?.d ?? 1);
  } else if (node instanceof Text || node instanceof win.Text) {
    const range = node.ownerDocument.createRange();
    range.selectNodeContents(node);
    const targetRect = range.getBoundingClientRect();
    const result = _getTextNodeSize(matrix, targetRect, node);
    width = result.width;
    height = result.height;
  }
  return { width, height };
}
function getSvgVisualBox(node, bbox) {
  const svgStyle = getCachedComputedStyle(node);
  const strokeWidth = svgStyle.stroke !== "none" ? parseFloat(svgStyle.strokeWidth) || 0 : 0;
  if (strokeWidth <= 0) {
    return bbox;
  }
  const strokeInflation = getSvgStrokeInflation(node, bbox, strokeWidth);
  return new DOMRect(bbox.x - strokeInflation.left, bbox.y - strokeInflation.top, bbox.width + strokeInflation.left + strokeInflation.right, bbox.height + strokeInflation.top + strokeInflation.bottom);
}
function getSvgStrokeInflation(node, bbox, strokeWidth) {
  const halfStrokeWidth = strokeWidth / 2;
  if (node instanceof SVGLineElement || node instanceof (node.ownerDocument.defaultView ?? window).SVGLineElement) {
    const x1 = node.x1.baseVal.value;
    const y1 = node.y1.baseVal.value;
    const x2 = node.x2.baseVal.value;
    const y2 = node.y2.baseVal.value;
    const dx = x2 - x1;
    const dy = y2 - y1;
    const length = Math.hypot(dx, dy);
    if (length > 0.0000000001) {
      let inflateX = halfStrokeWidth * Math.abs(dy) / length;
      let inflateY = halfStrokeWidth * Math.abs(dx) / length;
      const lineCap = getCachedComputedStyle(node).strokeLinecap;
      if (lineCap === "round" || lineCap === "square") {
        inflateX += halfStrokeWidth * Math.abs(dx) / length;
        inflateY += halfStrokeWidth * Math.abs(dy) / length;
      }
      return { left: inflateX, right: inflateX, top: inflateY, bottom: inflateY };
    }
  }
  const genericInflation = strokeWidth * 2;
  return {
    left: genericInflation,
    right: genericInflation,
    top: genericInflation,
    bottom: genericInflation
  };
}
function getElementOffsetsInContainer(node, includeScroll, iframes) {
  if (node instanceof HTMLElement || node instanceof (node.ownerDocument.defaultView ?? window).HTMLElement) {
    if (node instanceof HTMLHtmlElement || node instanceof (node.ownerDocument.defaultView ?? window).HTMLHtmlElement) {
      return new DOMPoint(0, 0);
    }
    const cs = getCachedComputedStyle(node);
    if (cs.position === "fixed") {
      const fixedContainer = getNearestFixedContainingBlock(node, iframes);
      if (!fixedContainer) {
        const left = cs.left && cs.left !== "auto" ? parseFloat(cs.left) : node.offsetLeft;
        const top = cs.top && cs.top !== "auto" ? parseFloat(cs.top) : node.offsetTop;
        return new DOMPoint(left, top);
      }
      const m = getResultingTransformationBetweenElementAndAllAncestors(fixedContainer, node.ownerDocument.body, iframes, true).inverse();
      const r1 = node.getBoundingClientRect();
      const r1t = m.transformPoint(r1);
      const r2 = fixedContainer.getBoundingClientRect();
      const r2t = m.transformPoint(r2);
      return new DOMPoint(r1t.x - r2t.x, r1t.y - r2t.y);
    }
    if (includeScroll) {
      return new DOMPoint(node.offsetLeft - (node.scrollLeft - parseFloat(cs.borderLeftWidth)), node.offsetTop - (node.scrollTop - parseFloat(cs.borderTopWidth)));
    } else {
      return new DOMPoint(node.offsetLeft, node.offsetTop);
    }
  } else if (node instanceof Text || node instanceof (node.ownerDocument.defaultView ?? window).Text) {
    const range = node.ownerDocument.createRange();
    range.selectNodeContents(node);
    const r1 = range.getBoundingClientRect();
    const parent = getParentElementIncludingSlots(node, iframes);
    const r2 = parent.getBoundingClientRect();
    const pt = getElementCombinedTransform(parent, iframes);
    const { a: pa, b: pb, c: pc, d: pd } = pt;
    const pw = parent.offsetWidth;
    const ph = parent.offsetHeight;
    const parentOriginX = r2.x + r2.width / 2 - (pa * pw / 2 + pc * ph / 2);
    const parentOriginY = r2.y + r2.height / 2 - (pb * pw / 2 + pd * ph / 2);
    const dx = r1.x + r1.width / 2 - parentOriginX;
    const dy = r1.y + r1.height / 2 - parentOriginY;
    const transformDet = pa * pd - pb * pc;
    let localCenterX, localCenterY;
    if (Math.abs(transformDet) > 0.0000000001) {
      localCenterX = (pd * dx - pc * dy) / transformDet;
      localCenterY = (pa * dy - pb * dx) / transformDet;
    } else {
      localCenterX = dx;
      localCenterY = dy;
    }
    const absA = Math.abs(pa), absB = Math.abs(pb);
    const absDet = absA * absA - absB * absB;
    let tw, th;
    if (Math.abs(absDet) > 0.000001) {
      tw = Math.max(0, (absA * r1.width - absB * r1.height) / absDet);
      th = Math.max(0, (absA * r1.height - absB * r1.width) / absDet);
    } else {
      const cs = getCachedComputedStyle(parent);
      th = parseFloat(cs.lineHeight) || parseFloat(cs.fontSize) * 1.2 || 16;
      th = Math.max(0, th);
      const denom = Math.max(absA, absB);
      tw = denom > 0.000001 ? Math.max(0, (r1.width - th * absB) / denom) : r1.width;
    }
    return new DOMPoint(localCenterX - tw / 2, localCenterY - th / 2);
  } else if (node instanceof Element || node instanceof (node.ownerDocument.defaultView ?? window).Element) {
    if ((node instanceof SVGGraphicsElement || node instanceof (node.ownerDocument.defaultView ?? window).SVGGraphicsElement) && !(node instanceof SVGSVGElement || node instanceof (node.ownerDocument.defaultView ?? window).SVGSVGElement)) {
      const bb = node.getBBox();
      return new DOMPoint(bb.x, bb.y);
    }
    const cs = getCachedComputedStyle(node);
    if (cs.position === "absolute") {
      return new DOMPoint(parseFloat(cs.left), parseFloat(cs.top));
    }
    const par = getParentElementIncludingSlots(node, iframes);
    const m = getResultingTransformationBetweenElementAndAllAncestors(par, document.body, iframes, true).inverse();
    const r1 = node.getBoundingClientRect();
    const r1t = m.transformPoint(r1);
    const r2 = par.getBoundingClientRect();
    const r2t = m.transformPoint(r2);
    return new DOMPoint(r1t.x - r2t.x, r1t.y - r2t.y);
  }
}
function getResultingTransformationBetweenElementAndAllAncestors(node, ancestor, iframes, excludeSelfZoom = false) {
  let key;
  if (transformCache) {
    let i1 = hash.get(node);
    if (i1 === undefined)
      hash.set(node, i1 = hashId++);
    let i2 = hash.get(ancestor);
    if (i2 === undefined)
      hash.set(ancestor, i2 = hashId++);
    key = i1 + "_" + i2 + "_" + (excludeSelfZoom ? "no-self-zoom" : "full");
    const q = transformCache.get(key);
    if (q)
      return q;
  }
  let actualElement = node;
  let parentElementMatrix;
  const useOwnSvgCtm = (actualElement instanceof SVGGraphicsElement || actualElement instanceof (actualElement.ownerDocument.defaultView ?? window).SVGGraphicsElement) && !(actualElement instanceof SVGSVGElement || actualElement instanceof (actualElement.ownerDocument.defaultView ?? window).SVGSVGElement);
  let currentElementTransform = useOwnSvgCtm ? new DOMMatrix : getElementTransformWithZoom(actualElement, iframes, !excludeSelfZoom);
  let originalElementAndAllParentsMultipliedMatrix = currentElementTransform.isIdentity ? new DOMMatrix : currentElementTransform;
  let perspectiveParentElement = getParentElementIncludingSlots(actualElement, iframes);
  if (perspectiveParentElement) {
    if (!originalElementAndAllParentsMultipliedMatrix.is2D) {
      const s = getCachedComputedStyle(perspectiveParentElement);
      if (s.transformStyle !== "preserve-3d") {
        projectTo2D(originalElementAndAllParentsMultipliedMatrix);
      }
    }
  }
  let lastOffsetParent = null;
  while (actualElement != ancestor && actualElement != null) {
    let parentElement = getParentElementIncludingSlots(actualElement, iframes);
    if (actualElement instanceof HTMLElement || actualElement instanceof (actualElement.ownerDocument.defaultView ?? window).HTMLElement) {
      const fixedStyle = getCachedComputedStyle(actualElement);
      if (fixedStyle.position === "fixed") {
        const fixedContainer = getNearestFixedContainingBlock(actualElement, iframes);
        parentElement = fixedContainer ?? ancestor;
      }
    }
    if (actualElement.assignedSlot != null) {
      if (actualElement.nodeType === Node.ELEMENT_NODE) {
        const slotOffsetParent = offsetParentPolyfill(actualElement);
        const shouldApplySlottedOffset = lastOffsetParent !== slotOffsetParent && (lastOffsetParent === null || actualElement === lastOffsetParent || !isFlatTreeInclusiveAncestor(lastOffsetParent, actualElement));
        if (shouldApplySlottedOffset) {
          const l = offsetTopLeftPolyfill(actualElement, "offsetLeft");
          const t = offsetTopLeftPolyfill(actualElement, "offsetTop");
          if (l !== 0 || t !== 0) {
            const mvMat = new DOMMatrix().translateSelf(l, t);
            originalElementAndAllParentsMultipliedMatrix = mvMat.multiplySelf(originalElementAndAllParentsMultipliedMatrix);
          }
          lastOffsetParent = slotOffsetParent;
        }
        if (lastOffsetParent === null)
          lastOffsetParent = slotOffsetParent;
      } else if (actualElement.nodeType === Node.TEXT_NODE) {
        const offsets = getElementOffsetsInContainer(actualElement, actualElement !== node, iframes);
        if (offsets.x !== 0 || offsets.y !== 0) {
          const mvMat = new DOMMatrix().translateSelf(offsets.x, offsets.y);
          originalElementAndAllParentsMultipliedMatrix = mvMat.multiplySelf(originalElementAndAllParentsMultipliedMatrix);
        }
      }
    } else {
      if (!(actualElement instanceof SVGSVGElement) && !(actualElement instanceof (actualElement.ownerDocument.defaultView ?? window).SVGSVGElement) && (actualElement instanceof SVGGraphicsElement || actualElement instanceof (actualElement.ownerDocument.defaultView ?? window).SVGGraphicsElement)) {
        const ctm = actualElement.getCTM();
        const bb = actualElement.getBBox();
        if (bb.x !== 0 || bb.y !== 0) {
          const mvMat = new DOMMatrix().translateSelf(bb.x, bb.y);
          originalElementAndAllParentsMultipliedMatrix = mvMat.multiplySelf(originalElementAndAllParentsMultipliedMatrix);
        }
        originalElementAndAllParentsMultipliedMatrix = new DOMMatrix([
          ctm.a,
          ctm.b,
          ctm.c,
          ctm.d,
          ctm.e,
          ctm.f
        ]).multiplySelf(originalElementAndAllParentsMultipliedMatrix);
        parentElement = actualElement.ownerSVGElement;
      } else if (actualElement instanceof HTMLElement || actualElement instanceof (actualElement.ownerDocument.defaultView ?? window).HTMLElement) {
        const actualStyle = getCachedComputedStyle(actualElement);
        const isFixedSelf = actualStyle.position === "fixed" && actualElement === node;
        if ((isFixedSelf || lastOffsetParent !== actualElement.offsetParent) && !(actualElement instanceof HTMLSlotElement || actualElement instanceof (actualElement.ownerDocument.defaultView ?? window).HTMLSlotElement) && (lastOffsetParent === null || actualElement === lastOffsetParent || !isFlatTreeInclusiveAncestor(lastOffsetParent, actualElement))) {
          const offsets = getElementOffsetsInContainer(actualElement, actualElement !== node, iframes);
          const zoom = getElementZoom(actualElement);
          lastOffsetParent = actualElement.offsetParent;
          if (offsets.x !== 0 || offsets.y !== 0) {
            const mvMat = new DOMMatrix().translateSelf(offsets.x * zoom, offsets.y * zoom);
            originalElementAndAllParentsMultipliedMatrix = mvMat.multiplySelf(originalElementAndAllParentsMultipliedMatrix);
          }
        }
      } else {
        const offsets = getElementOffsetsInContainer(actualElement, actualElement !== node, iframes);
        lastOffsetParent = null;
        if (offsets.x !== 0 || offsets.y !== 0) {
          const mvMat = new DOMMatrix().translateSelf(offsets.x, offsets.y);
          originalElementAndAllParentsMultipliedMatrix = mvMat.multiplySelf(originalElementAndAllParentsMultipliedMatrix);
        }
      }
    }
    if (parentElement) {
      if (parentElement === ancestor) {
        if (lastOffsetParent !== null && (parentElement instanceof HTMLElement || parentElement instanceof (parentElement.ownerDocument.defaultView ?? window).HTMLElement) && parentElement.offsetParent === lastOffsetParent) {
          const ancOff = getElementOffsetsInContainer(parentElement, false, iframes);
          if (ancOff.x !== 0 || ancOff.y !== 0) {
            originalElementAndAllParentsMultipliedMatrix = new DOMMatrix().translate(-ancOff.x, -ancOff.y).multiply(originalElementAndAllParentsMultipliedMatrix);
          }
        }
        const isViewportScrollContainer = parentElement === parentElement.ownerDocument.documentElement;
        if (!isViewportScrollContainer && (parentElement.scrollTop || parentElement.scrollLeft))
          originalElementAndAllParentsMultipliedMatrix = new DOMMatrix().translate(-parentElement.scrollLeft, -parentElement.scrollTop).multiply(originalElementAndAllParentsMultipliedMatrix);
        const ancestorZoom = getElementZoomScaleTransform(parentElement);
        if (!ancestorZoom.isIdentity)
          originalElementAndAllParentsMultipliedMatrix = ancestorZoom.multiply(originalElementAndAllParentsMultipliedMatrix);
        if (transformCache)
          transformCache.set(key, originalElementAndAllParentsMultipliedMatrix);
        return originalElementAndAllParentsMultipliedMatrix;
      }
      parentElementMatrix = getElementTransformWithZoom(parentElement, iframes);
      if (!parentElementMatrix.isIdentity)
        originalElementAndAllParentsMultipliedMatrix = parentElementMatrix.multiply(originalElementAndAllParentsMultipliedMatrix);
      perspectiveParentElement = getParentElementIncludingSlots(parentElement, iframes);
      if (perspectiveParentElement) {
        if (!originalElementAndAllParentsMultipliedMatrix.is2D) {
          const s = getCachedComputedStyle(perspectiveParentElement);
          if (s.transformStyle !== "preserve-3d") {
            projectTo2D(originalElementAndAllParentsMultipliedMatrix);
          }
        }
      }
    }
    actualElement = parentElement;
  }
  if (transformCache) {
    transformCache.set(key, originalElementAndAllParentsMultipliedMatrix);
  }
  return originalElementAndAllParentsMultipliedMatrix;
}
function getParentElementIncludingSlots(node, iframes) {
  if ((node instanceof Element || node instanceof (node.ownerDocument.defaultView ?? window).Element) && node.assignedSlot)
    return node.assignedSlot;
  if (node.parentElement == null) {
    if (node.parentNode instanceof ShadowRoot || node.parentNode instanceof (node.ownerDocument.defaultView ?? window).ShadowRoot) {
      return node.parentNode.host;
    }
  }
  if (node instanceof HTMLHtmlElement || node instanceof (node.ownerDocument.defaultView ?? window).HTMLHtmlElement) {
    if (iframes) {
      for (const f of iframes)
        if (f?.contentDocument == node.ownerDocument)
          return f;
    }
  }
  return node.parentElement;
}
function getElementCombinedTransform(element, iframes) {
  if (element instanceof Text || element instanceof (element.ownerDocument.defaultView ?? window).Text)
    return new DOMMatrix;
  const actualElement = element;
  let s = getCachedComputedStyle(actualElement);
  const hasTransform = s.transform !== "none" && !!s.transform;
  const hasTranslate = s.translate !== "none" && !!s.translate;
  const hasRotate = s.rotate !== "none" && !!s.rotate;
  const hasScale = s.scale !== "none" && !!s.scale;
  const hasOffsetPath = !!s.offsetPath && s.offsetPath !== "none";
  if (!hasTransform && !hasTranslate && !hasRotate && !hasScale && !hasOffsetPath) {
    const parent = getParentElementIncludingSlots(actualElement, iframes);
    if (!parent)
      return new DOMMatrix;
    const ps = getCachedComputedStyle(parent);
    if (!ps.perspective || ps.perspective === "none")
      return new DOMMatrix;
    const pt = getElementPerspectiveTransform(actualElement, iframes);
    return pt != null ? pt : new DOMMatrix;
  }
  let m = new DOMMatrix;
  const origin = s.transformOrigin.split(" ");
  const originX = parseFloat(origin[0]);
  const originY = parseFloat(origin[1]);
  const originZ = origin[2] ? parseFloat(origin[2]) : 0;
  const hasNonZeroOrigin = originX !== 0 || originY !== 0 || originZ !== 0;
  const mOri = hasNonZeroOrigin ? new DOMMatrix().translateSelf(originX, originY, originZ) : null;
  if (hasTranslate) {
    let tr = s.translate;
    if (tr.includes("%")) {
      const v = tr.split(" ");
      const r = actualElement.getBoundingClientRect();
      if (v[0].endsWith("%"))
        v[0] = parseFloat(v[0]) * r.width / 100 + "px";
      if (v[1]?.endsWith("%"))
        v[1] = parseFloat(v[1]) * r.height / 100 + "px";
      tr = v.join(",");
    }
    m.multiplySelf(new DOMMatrix("translate(" + tr.replaceAll(" ", ",") + ")"));
  }
  if (hasRotate) {
    const rotateParts = s.rotate.trim().split(/\s+/);
    const rotateTransform = rotateParts.length === 1 ? `rotate(${rotateParts[0]})` : rotateParts.length === 2 && /^[xyz]$/i.test(rotateParts[0]) ? `rotate${rotateParts[0].toUpperCase()}(${rotateParts[1]})` : `rotate3d(${rotateParts.join(",")})`;
    m.multiplySelf(new DOMMatrix(rotateTransform));
  }
  if (hasScale) {
    const scaleParts = s.scale.trim().split(/\s+/);
    const scaleFunction = scaleParts.length === 3 ? "scale3d" : "scale";
    m.multiplySelf(new DOMMatrix(`${scaleFunction}(${scaleParts.join(",")})`));
  }
  if (hasOffsetPath) {
    m.multiplySelf(computeOffsetTransformMatrix(element));
  }
  if (hasTransform) {
    m.multiplySelf(new DOMMatrix(s.transform));
  }
  if (hasNonZeroOrigin) {
    m = mOri.multiply(m.multiplySelf(mOri.inverse()));
  }
  const pt = getElementPerspectiveTransform(element, iframes);
  if (pt != null) {
    m = pt.multiplySelf(m);
  }
  return m;
}
function projectTo2D(m) {
  m.m31 = 0;
  m.m32 = 0;
  m.m13 = 0;
  m.m23 = 0;
  m.m33 = 1;
  m.m43 = 0;
  m.m34 = 0;
  if (m.m14 == 0 && m.m24 == 0 && m.m44 != 1 && m.m44 != 0) {
    const scale = 1 / m.m44;
    m.m11 *= scale;
    m.m12 *= scale;
    m.m21 *= scale;
    m.m22 *= scale;
    m.m41 *= scale;
    m.m42 *= scale;
    m.m44 = 1;
  }
}
function getElementPerspectiveTransform(element, iframes) {
  const perspectiveNode = getParentElementIncludingSlots(element, iframes);
  if (perspectiveNode) {
    let s = getCachedComputedStyle(perspectiveNode);
    if (s.perspective !== "none") {
      let m = new DOMMatrix;
      let p = parseFloat(s.perspective);
      m.m34 = -1 / p;
      if (s.perspectiveOrigin) {
        const origin = s.perspectiveOrigin.split(" ");
        const originX = parseFloat(origin[0]) - element.offsetLeft;
        const originY = parseFloat(origin[1]) - element.offsetTop;
        const mOri = new DOMMatrix().translateSelf(originX, originY);
        const mOriInv = new DOMMatrix().translateSelf(-originX, -originY);
        return mOri.multiplySelf(m.multiplySelf(mOriInv));
      }
    }
  }
  return null;
}
function computeOffsetTransformMatrix(elem) {
  const cs = getCachedComputedStyle(elem);
  const offsetPath = cs.offsetPath;
  const offsetDistance = cs.offsetDistance;
  const offsetRotate = cs.offsetRotate;
  const offsetAnchor = cs.offsetAnchor;
  const transformOrigin = cs.transformOrigin;
  let distance = parseOffsetDistance(offsetDistance);
  let { x, y, angle } = computeOffsetPathPoint(elem, offsetPath, distance);
  const parent = elem.parentElement;
  if (parent instanceof HTMLElement || parent instanceof (parent.ownerDocument.defaultView ?? window).HTMLElement) {
    if (elem.offsetParent === parent) {
      x -= elem.offsetLeft;
      y -= elem.offsetTop;
    } else if (elem.offsetParent === parent.offsetParent) {
      x -= elem.offsetLeft - parent.offsetLeft;
      y -= elem.offsetTop - parent.offsetTop;
    }
  }
  let rotateFinal = 0;
  if (offsetRotate.startsWith("auto")) {
    let parts = offsetRotate.split(/\s+/);
    let extra = parts.length === 2 ? parseFloat(parts[1]) : 0;
    rotateFinal = angle + extra;
  } else {
    rotateFinal = parseFloat(offsetRotate);
  }
  const anchor = parseOffsetAnchor(offsetAnchor, transformOrigin, elem);
  const anchorMatrix = new DOMMatrix().translateSelf(-anchor.x, -anchor.y);
  let m = anchorMatrix.translate(x, y);
  m.multiplySelf(anchorMatrix.invertSelf());
  m.rotateSelf(rotateFinal);
  m.translateSelf(-anchor.x, -anchor.y);
  return m;
}
function parseOffsetAnchor(str, transformOrigin, elem) {
  const width = elem.offsetWidth;
  const height = elem.offsetHeight;
  if (!str || str === "auto") {
    str = transformOrigin;
  }
  const parts = str.split(/\s+/);
  if (parts.length === 1) {
    const x = parsePosition(parts[0], width);
    return { x, y: height / 2 };
  }
  const x = parsePosition(parts[0], width);
  const y = parsePosition(parts[1], height);
  return { x, y };
}
function parsePosition(part, size) {
  part = part.trim();
  if (part.endsWith("%")) {
    return parseFloat(part) / 100 * size;
  }
  if (part.endsWith("px")) {
    return parseFloat(part);
  }
  switch (part) {
    case "left":
      return 0;
    case "top":
      return 0;
    case "center":
      return size / 2;
    case "right":
      return size;
    case "bottom":
      return size;
  }
  return parseFloat(part);
}
function parseOffsetDistance(str) {
  str = str.trim();
  if (str.endsWith("%")) {
    return parseFloat(str) / 100;
  }
  return parseFloat(str);
}
function parseAngle(str) {
  if (!str)
    return 0;
  str = str.trim();
  if (str.endsWith("deg"))
    return parseFloat(str);
  if (str.endsWith("rad"))
    return parseFloat(str) * (180 / Math.PI);
  if (str.endsWith("grad"))
    return parseFloat(str) * 0.9;
  return parseFloat(str);
}
function computeOffsetPathPoint(elem, offsetPath, distNorm) {
  if (!offsetPath || offsetPath === "none") {
    return { x: 0, y: 0, angle: 0 };
  }
  const value = offsetPath.trim();
  let m = value.match(/path\(["'](.+)["']\)/);
  if (m)
    return computePathType(m[1], distNorm);
  if (value.startsWith("circle("))
    return computeCircle(value, distNorm);
  if (value.startsWith("ellipse("))
    return computeEllipse(value, distNorm);
  if (value.startsWith("inset("))
    return computeInset(value, elem, distNorm);
  if (value.startsWith("rect("))
    return computeRect(value, distNorm);
  if (value.startsWith("xywh("))
    return computeXYWH(value, distNorm);
  if (value.startsWith("ray("))
    return computeRay(value, distNorm);
  if (value.startsWith("polygon("))
    return computePolygon(value, distNorm);
  console.warn("Unsupported offset-path:", offsetPath);
  return { x: 0, y: 0, angle: 0 };
}
function computePathType(pathData, distNorm) {
  let svgPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
  svgPath.setAttribute("d", pathData);
  const total = svgPath.getTotalLength();
  const dist = distNorm <= 1 ? distNorm * total : distNorm;
  const p1 = svgPath.getPointAtLength(dist);
  const p2 = svgPath.getPointAtLength(Math.min(total, dist + 0.01));
  let angle = Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI;
  return { x: p1.x, y: p1.y, angle };
}
function computeRay(str, t) {
  let m = str.match(/ray\(([^)]+)\)/);
  let inside = m[1].trim();
  let [beforeAt, atPart] = inside.split("at").map((s) => s && s.trim());
  let parts = beforeAt.split(/\s+/);
  let angleDeg = parseAngle(parts[0]);
  let angleRad = angleDeg * Math.PI / 180;
  let ox = 0, oy = 0;
  if (atPart) {
    const pos = atPart.split(/\s+/);
    ox = parseFloat(pos[0]);
    oy = parseFloat(pos[1]);
  }
  let dist = t <= 1 ? t : t;
  let x = ox + Math.cos(angleRad) * dist;
  let y = oy + Math.sin(angleRad) * dist;
  return { x, y, angle: angleDeg };
}
function computeCircle(str, t) {
  let m = str.match(/circle\(([^)]+)\)/);
  let inner = m[1];
  let [radiusPart, atPart] = inner.split("at").map((s) => s.trim());
  let r = parseFloat(radiusPart);
  let [cx, cy] = atPart.split(/\s+/).map(parseFloat);
  let angleRad = t * 2 * Math.PI;
  let x = cx + Math.cos(angleRad) * r;
  let y = cy + Math.sin(angleRad) * r;
  let tangentAngleDeg = angleRad * 180 / Math.PI + 90;
  return { x, y, angle: tangentAngleDeg };
}
function computeEllipse(str, t) {
  let m = str.match(/ellipse\(([^)]+)\)/);
  let parts = m[1].split("at");
  let radii = parts[0].trim().split(/\s+/).map(parseFloat);
  let center = parts[1].trim().split(/\s+/).map(parseFloat);
  let rx = radii[0];
  let ry = radii[1];
  let cx = center[0];
  let cy = center[1];
  let angleRad = t * 2 * Math.PI;
  let x = cx + Math.cos(angleRad) * rx;
  let y = cy + Math.sin(angleRad) * ry;
  let dx = -Math.sin(angleRad) * rx;
  let dy = Math.cos(angleRad) * ry;
  let tangentAngleDeg = Math.atan2(dy, dx) * 180 / Math.PI;
  return { x, y, angle: tangentAngleDeg };
}
function computeRect(str, t) {
  let m = str.match(/rect\(([^)]+)\)/);
  let nums = m[1].split(/\s+/).map((s) => parseFloat(s));
  let top = nums[0], right = nums[1], bottom = nums[2], left = nums[3];
  return rectPath(top, left, right, bottom, t);
}
function computeXYWH(str, t) {
  let m = str.match(/xywh\(([^)]+)\)/);
  let nums = m[1].split(/\s+/).map(parseFloat);
  let left = nums[0];
  let top = nums[1];
  let width = nums[2];
  let height = nums[3];
  return rectPath(top, left, left + width, top + height, t);
}
function computePolygon(str, t) {
  let m = str.match(/polygon\(([^)]+)\)/);
  let pairs = m[1].split(",").map((p) => p.trim().split(/\s+/).map(parseFloat));
  let pts = pairs;
  let lengths = [0];
  for (let i = 1;i < pts.length; i++) {
    let dx = pts[i][0] - pts[i - 1][0];
    let dy = pts[i][1] - pts[i - 1][1];
    lengths.push(Math.hypot(dx, dy) + lengths[i - 1]);
  }
  let dx = pts[0][0] - pts[pts.length - 1][0];
  let dy = pts[0][1] - pts[pts.length - 1][1];
  lengths.push(Math.hypot(dx, dy) + lengths[lengths.length - 1]);
  let total = lengths[lengths.length - 1];
  let target = t * total;
  let i = lengths.findIndex((len) => len >= target);
  if (i <= 0)
    i = 1;
  let prevLen = lengths[i - 1];
  let nextLen = lengths[i];
  let segT = (target - prevLen) / (nextLen - prevLen);
  let a = pts[(i - 1) % pts.length];
  let b = pts[i % pts.length];
  let x = a[0] + (b[0] - a[0]) * segT;
  let y = a[1] + (b[1] - a[1]) * segT;
  let angle = Math.atan2(b[1] - a[1], b[0] - a[0]) * 180 / Math.PI;
  return { x, y, angle };
}
function rectPath(top, left, right, bottom, t) {
  let w = right - left;
  let h = bottom - top;
  let perimeter = 2 * (w + h);
  let dist = t * perimeter;
  if (dist < w) {
    let x = left + dist;
    return { x, y: top, angle: 0 };
  }
  dist -= w;
  if (dist < h) {
    let y = top + dist;
    return { x: right, y, angle: 90 };
  }
  dist -= h;
  if (dist < w) {
    let x = right - dist;
    return { x, y: bottom, angle: 180 };
  }
  dist -= w;
  let y = bottom - dist;
  return { x: left, y, angle: 270 };
}
function tokenizeCalc(input) {
  let tokens = [];
  let i = 0;
  while (i < input.length) {
    let ch = input[i];
    if (/\s/.test(ch)) {
      i++;
      continue;
    }
    if ("+-*/()".includes(ch)) {
      tokens.push({ type: ch, value: ch });
      i++;
      continue;
    }
    if (/[0-9.]/.test(ch)) {
      let start = i;
      while (/[0-9.]/.test(input[i]))
        i++;
      let num = input.slice(start, i);
      if (input[i] === "%") {
        i++;
        tokens.push({ type: "percentage", value: parseFloat(num) });
        continue;
      }
      if (input.slice(i, i + 2) === "px") {
        i += 2;
        tokens.push({ type: "dimension", value: parseFloat(num), unit: "px" });
        continue;
      }
      tokens.push({ type: "number", value: parseFloat(num) });
      continue;
    }
    if (/[a-zA-Z]/.test(ch)) {
      let start = i;
      while (/[a-zA-Z]/.test(input[i]))
        i++;
      let name = input.slice(start, i);
      if (name === "calc" && input[i] === "(") {
        tokens.push({ type: "func", value: "calc" });
        continue;
      }
      throw new Error("Unsupported function: " + name);
    }
    throw new Error("Unexpected character in calc(): " + ch);
  }
  return tokens;
}
function parseCalc(tokens) {
  let i = 0;
  function peek() {
    return tokens[i];
  }
  function consume() {
    return tokens[i++];
  }
  function parseExpression() {
    let node = parseTerm();
    while (peek() && (peek().type === "+" || peek().type === "-")) {
      let op = consume().type;
      let right = parseTerm();
      node = { type: "binary", op, left: node, right };
    }
    return node;
  }
  function parseTerm() {
    let node = parseFactor();
    while (peek() && (peek().type === "*" || peek().type === "/")) {
      let op = consume().type;
      let right = parseFactor();
      node = { type: "binary", op, left: node, right };
    }
    return node;
  }
  function parseFactor() {
    let t = peek();
    if (!t)
      throw "Unexpected end in calc()";
    if (t.type === "number") {
      consume();
      return { type: "number", value: t.value };
    }
    if (t.type === "dimension") {
      consume();
      return { type: "dimension", value: t.value, unit: t.unit };
    }
    if (t.type === "percentage") {
      consume();
      return { type: "percentage", value: t.value };
    }
    if (t.type === "func") {
      consume();
      if (peek().type !== "(")
        throw "Expected '(' after calc";
      consume();
      let node = parseExpression();
      if (!peek() || peek().type !== ")")
        throw "Expected ')'";
      consume();
      return node;
    }
    if (t.type === "(") {
      consume();
      let node = parseExpression();
      if (!peek() || peek().type !== ")")
        throw "Expected ')'";
      consume();
      return node;
    }
    throw new Error("Unexpected calc token " + JSON.stringify(t));
  }
  let ast = parseExpression();
  if (i !== tokens.length)
    throw "Extra tokens after calc";
  return ast;
}
function evalCalc(ast, env) {
  switch (ast.type) {
    case "number":
      return ast.value;
    case "dimension":
      return ast.value;
    case "percentage":
      return env.percentBase * (ast.value / 100);
    case "binary": {
      let l = evalCalc(ast.left, env);
      let r = evalCalc(ast.right, env);
      switch (ast.op) {
        case "+":
          return l + r;
        case "-":
          return l - r;
        case "*":
          return l * r;
        case "/":
          return l / r;
      }
    }
  }
  throw "Invalid AST node " + ast.type;
}
function resolveLength(expr, element, useHeight = false) {
  expr = expr.trim();
  if (/^[0-9.]+px$/.test(expr))
    return parseFloat(expr);
  let base = useHeight ? element.offsetHeight : element.offsetWidth;
  if (/^[0-9.]+%$/.test(expr)) {
    let p = parseFloat(expr);
    return base * (p / 100);
  }
  const ast = parseCalc(tokenizeCalc(expr));
  return evalCalc(ast, {
    percentBase: base
  });
}
function parseInsetArgs(str) {
  let inside = str.trim().replace(/^inset\s*\(/, "").replace(/\)\s*$/, "");
  let args = [];
  let current = "";
  let depth = 0;
  for (let i = 0;i < inside.length; i++) {
    let ch = inside[i];
    if (ch === "(") {
      depth++;
      current += ch;
    } else if (ch === ")") {
      depth--;
      current += ch;
    } else if (/\s/.test(ch) && depth === 0) {
      if (current.trim() !== "") {
        args.push(current.trim());
        current = "";
      }
    } else {
      current += ch;
    }
  }
  if (current.trim() !== "") {
    args.push(current.trim());
  }
  return args;
}
function computeInset(str, element, progress) {
  const args = parseInsetArgs(str);
  if (args.length !== 4)
    throw new Error("inset() must have 4 arguments");
  const topPx = resolveLength(args[0], element, true);
  const rightPx = resolveLength(args[1], element, false);
  const bottomPx = resolveLength(args[2], element, true);
  const leftPx = resolveLength(args[3], element, false);
  const w = element.offsetWidth;
  const h = element.offsetHeight;
  const x1 = leftPx;
  const y1 = topPx;
  const x2 = w - rightPx;
  const y2 = h - bottomPx;
  const P = 2 * (x2 - x1 + (y2 - y1));
  let d = P * progress;
  let len = x2 - x1;
  if (d <= len)
    return { x: x1 + d, y: y1, angle: 0 };
  d -= len;
  len = y2 - y1;
  if (d <= len)
    return { x: x2, y: y1 + d, angle: 90 };
  d -= len;
  len = x2 - x1;
  if (d <= len)
    return { x: x2 - d, y: y2, angle: 180 };
  d -= len;
  return { x: x1, y: y2 - d, angle: 270 };
}
var transformProperties = [
  "transform",
  "translate",
  "scale",
  "rotate",
  "perspective"
];
var willChangeValues = [
  "transform",
  "translate",
  "scale",
  "rotate",
  "perspective",
  "filter"
];
var containValues = ["paint", "layout", "strict", "content"];
function isContainingBlock(css) {
  return transformProperties.some((value) => css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || (css.backdropFilter ? css.backdropFilter !== "none" : false) || (css.filter ? css.filter !== "none" : false) || willChangeValues.some((value) => (css.willChange || "").includes(value)) || containValues.some((value) => (css.contain || "").includes(value));
}
function flatTreeParent(element) {
  if (element.assignedSlot)
    return element.assignedSlot;
  if (element.parentNode instanceof ShadowRoot)
    return element.parentNode.host;
  return element.parentNode;
}
function isFlatTreeInclusiveAncestor(ancestor, node) {
  for (let current = node;current; current = flatTreeParent(current)) {
    if (current === ancestor)
      return true;
  }
  return false;
}
function ancestorTreeScopes(element) {
  const scopes = new Set;
  let currentScope = element.getRootNode();
  const shadowRootCtor = element.ownerDocument?.defaultView?.ShadowRoot ?? ShadowRoot;
  while (currentScope) {
    scopes.add(currentScope);
    if (currentScope instanceof shadowRootCtor) {
      currentScope = currentScope.host?.getRootNode() ?? null;
    } else {
      currentScope = currentScope.parentNode ? currentScope.parentNode.getRootNode() : null;
    }
  }
  return scopes;
}
function offsetParentPolyfill(element) {
  for (let ancestor = element;ancestor; ancestor = flatTreeParent(ancestor)) {
    if (!(ancestor instanceof Element))
      continue;
    if (getCachedComputedStyle(ancestor).display === "none")
      return null;
  }
  for (let ancestor = flatTreeParent(element);ancestor; ancestor = flatTreeParent(ancestor)) {
    if (!(ancestor instanceof Element))
      continue;
    const style = getCachedComputedStyle(ancestor);
    if (style.display === "contents")
      continue;
    if (style.position !== "static" || isContainingBlock(style))
      return ancestor;
    if (ancestor.tagName === "BODY")
      return ancestor;
  }
  return null;
}
function offsetTopLeftPolyfill(element, offsetTopOrLeft) {
  let value = element[offsetTopOrLeft];
  let nextOffsetParent = offsetParentPolyfill(element);
  const scopes = ancestorTreeScopes(element);
  while (nextOffsetParent && !scopes.has(nextOffsetParent.getRootNode())) {
    value -= nextOffsetParent[offsetTopOrLeft];
    nextOffsetParent = offsetParentPolyfill(nextOffsetParent);
  }
  return value;
}
function createsFixedContainingBlock(element) {
  const cs = getCachedComputedStyle(element);
  if (cs.transform && cs.transform !== "none" || cs.perspective && cs.perspective !== "none" || cs.filter && cs.filter !== "none" || cs.backdropFilter && cs.backdropFilter !== "none") {
    return true;
  }
  const contain = cs.contain || "";
  if (contain.includes("paint") || contain.includes("layout") || contain.includes("strict") || contain.includes("content")) {
    return true;
  }
  const willChange = cs.willChange || "";
  return /transform|perspective|filter|backdrop-filter/.test(willChange);
}
function getNearestFixedContainingBlock(element, iframes) {
  let parent = getParentElementIncludingSlots(element, iframes);
  while (parent) {
    if (createsFixedContainingBlock(parent))
      return parent;
    parent = getParentElementIncludingSlots(parent, iframes);
  }
  return null;
}

// src/get-box-quads-ponyfill.ts
var hasNativeGetBoxQuads = (element) => {
  return typeof element.getBoxQuads === "function";
};
var getBoxQuadsPonyfill = (element, options) => {
  try {
    if (hasNativeGetBoxQuads(element)) {
      return element.getBoxQuads(options);
    }
    return getBoxQuads(element, options);
  } catch {
    return null;
  }
};

// src/outline-nodes.ts
import { Internals as Internals5 } from "remotion";
var getCanvasOutlineNodes = (ref) => {
  const automaticNodes = Internals5.SequenceOutlineInternals.getNodes(ref);
  if (automaticNodes === null) {
    return ref.current === null ? [] : [ref.current];
  }
  const nodes = [];
  const visit = (node) => {
    if (!node.isConnected) {
      return;
    }
    if (node.nodeType === 1 && node.ownerDocument.defaultView?.getComputedStyle(node).display === "contents") {
      for (const child of node.childNodes) {
        if (child.nodeType === 1 || child.nodeType === 3) {
          visit(child);
        }
      }
      return;
    }
    nodes.push(node);
  };
  for (const node of automaticNodes) {
    visit(node);
  }
  return nodes;
};

// src/outline-measurement.ts
var rectToPoints = (elementRect, contentRoot, rootRect) => {
  const scaleX = rootRect.width / contentRoot.offsetWidth;
  const scaleY = rootRect.height / contentRoot.offsetHeight;
  const left = (elementRect.left - rootRect.left) / scaleX;
  const top = (elementRect.top - rootRect.top) / scaleY;
  const right = (elementRect.right - rootRect.left) / scaleX;
  const bottom = (elementRect.bottom - rootRect.top) / scaleY;
  return [
    { x: left, y: top },
    { x: right, y: top },
    { x: right, y: bottom },
    { x: left, y: bottom }
  ];
};
var getTransformedSvgViewportPoints = ({
  viewport,
  ctm,
  containerRect
}) => {
  const transformPoint = (x, y) => ({
    x: ctm.a * x + ctm.c * y + ctm.e - containerRect.left,
    y: ctm.b * x + ctm.d * y + ctm.f - containerRect.top
  });
  const left = viewport.x;
  const top = viewport.y;
  const right = viewport.x + viewport.width;
  const bottom = viewport.y + viewport.height;
  return [
    transformPoint(left, top),
    transformPoint(right, top),
    transformPoint(right, bottom),
    transformPoint(left, bottom)
  ];
};
var quadToPoints = (quad) => {
  return [
    { x: quad.p1.x, y: quad.p1.y },
    { x: quad.p2.x, y: quad.p2.y },
    { x: quad.p3.x, y: quad.p3.y },
    { x: quad.p4.x, y: quad.p4.y }
  ];
};
var isSvgSvgElement = (element) => {
  const ownerSvgSvgElement = element.ownerDocument.defaultView?.SVGSVGElement;
  return typeof SVGSVGElement !== "undefined" && element instanceof SVGSVGElement || ownerSvgSvgElement !== undefined && element instanceof ownerSvgSvgElement;
};
var getSvgSvgElementViewport = (element) => {
  const viewBox = element.viewBox.baseVal;
  if (viewBox.width > 0 && viewBox.height > 0) {
    return {
      x: viewBox.x,
      y: viewBox.y,
      width: viewBox.width,
      height: viewBox.height
    };
  }
  return {
    x: 0,
    y: 0,
    width: element.width.baseVal.value,
    height: element.height.baseVal.value
  };
};
var getSvgElementCompositionMatrix = (element, contentRoot) => {
  const ownerSvg = element.ownerSVGElement;
  if (!ownerSvg) {
    return null;
  }
  let walk;
  try {
    walk = getResultingTransformationBetweenElementAndAllAncestors(ownerSvg, contentRoot, []);
  } catch {
    return null;
  }
  const ctm = element.getCTM();
  if (ctm === null) {
    return null;
  }
  return walk.multiply(ctm);
};
var getSvgSvgElementOutlinePoints = (element, contentRoot) => {
  const viewport = getSvgSvgElementViewport(element);
  if (viewport.width === 0 && viewport.height === 0) {
    return null;
  }
  let walk;
  try {
    walk = getResultingTransformationBetweenElementAndAllAncestors(element, contentRoot, []);
  } catch {
    return null;
  }
  if (!walk.is2D) {
    return null;
  }
  const viewBox = element.viewBox.baseVal;
  const hasViewBox = viewBox.width > 0 && viewBox.height > 0;
  const viewportWidth = element.width.baseVal.value;
  const viewportHeight = element.height.baseVal.value;
  let scaleX = 1;
  let scaleY = 1;
  let translateX = 0;
  let translateY = 0;
  if (hasViewBox) {
    const { align, meetOrSlice } = element.preserveAspectRatio.baseVal;
    if (align === 1) {
      scaleX = viewportWidth / viewBox.width;
      scaleY = viewportHeight / viewBox.height;
    } else {
      const uniform = meetOrSlice === 2 ? Math.max(viewportWidth / viewBox.width, viewportHeight / viewBox.height) : Math.min(viewportWidth / viewBox.width, viewportHeight / viewBox.height);
      scaleX = uniform;
      scaleY = uniform;
      translateX = align % 3 === 0 ? (viewportWidth - viewBox.width * uniform) / 2 : align % 3 === 1 ? viewportWidth - viewBox.width * uniform : 0;
      translateY = align <= 4 ? 0 : align <= 7 ? (viewportHeight - viewBox.height * uniform) / 2 : viewportHeight - viewBox.height * uniform;
    }
    translateX -= viewBox.x * scaleX;
    translateY -= viewBox.y * scaleY;
  }
  return getTransformedSvgViewportPoints({
    viewport,
    ctm: {
      a: walk.a * scaleX,
      b: walk.b * scaleX,
      c: walk.c * scaleY,
      d: walk.d * scaleY,
      e: walk.a * translateX + walk.c * translateY + walk.e,
      f: walk.b * translateX + walk.d * translateY + walk.f
    },
    containerRect: { left: 0, top: 0 }
  });
};
var isSvgPathElement = (element) => {
  const ownerSvgPathElement = element.ownerDocument.defaultView?.SVGPathElement;
  return typeof SVGPathElement !== "undefined" && element instanceof SVGPathElement || ownerSvgPathElement !== undefined && element instanceof ownerSvgPathElement;
};
var getPathOutline = ({
  element,
  contentRoot
}) => {
  const d = element.getAttribute("d");
  if (d === null || d === "") {
    return null;
  }
  const ctm = getSvgElementCompositionMatrix(element, contentRoot);
  if (ctm === null || !ctm.is2D) {
    return null;
  }
  return {
    d,
    matrix: {
      a: ctm.a,
      b: ctm.b,
      c: ctm.c,
      d: ctm.d,
      e: ctm.e,
      f: ctm.f
    }
  };
};
var getElementOutlinePoints = (element, elementRect, contentRoot, rootRect) => {
  if (elementRect.width === 0 && elementRect.height === 0) {
    return null;
  }
  if (isSvgSvgElement(element)) {
    return getSvgSvgElementOutlinePoints(element, contentRoot);
  }
  const quads = getBoxQuadsPonyfill(element, {
    box: "border",
    relativeTo: contentRoot
  });
  const quad = quads?.[0];
  if (!quad) {
    return rectToPoints(elementRect, contentRoot, rootRect);
  }
  return quadToPoints(quad);
};
var cropCanvasOutlinePoints = (points, crop) => {
  if (crop.left === 0 && crop.right === 0 && crop.top === 0 && crop.bottom === 0) {
    return points;
  }
  const { left, top } = crop;
  const right = 1 - crop.right;
  const bottom = 1 - crop.bottom;
  return [
    getCanvasOutlinePoint(points, [left, top]),
    getCanvasOutlinePoint(points, [right, top]),
    getCanvasOutlinePoint(points, [right, bottom]),
    getCanvasOutlinePoint(points, [left, bottom])
  ];
};
var measureCanvasOutlineTargets = (contentRoot, targets) => {
  useCache();
  const rootRect = contentRoot.getBoundingClientRect();
  const outlines = [];
  if (rootRect.width === 0 || rootRect.height === 0) {
    return outlines;
  }
  const geometry = new Map;
  for (const target of targets) {
    const nodes = getCanvasOutlineNodes(target.ref);
    let left = Infinity;
    let top = Infinity;
    let right = -Infinity;
    let bottom = -Infinity;
    const measurableNodes = [];
    for (const node of nodes) {
      if (!geometry.has(node)) {
        if (node.nodeType === 3) {
          const text = node;
          const quads = getBoxQuadsPonyfill(text, { relativeTo: contentRoot });
          let textPoints = quads?.flatMap(quadToPoints) ?? [];
          if (textPoints.length === 0) {
            const range = text.ownerDocument.createRange();
            range.selectNodeContents(text);
            const rect = range.getBoundingClientRect();
            if (rect.width !== 0 || rect.height !== 0) {
              textPoints = [...rectToPoints(rect, contentRoot, rootRect)];
            }
          }
          if (textPoints.length === 0) {
            geometry.set(node, null);
          } else {
            const xs = textPoints.map((point) => point.x);
            const ys = textPoints.map((point) => point.y);
            const textLeft = Math.min(...xs);
            const textTop = Math.min(...ys);
            const textRight = Math.max(...xs);
            const textBottom = Math.max(...ys);
            geometry.set(node, textLeft === textRight && textTop === textBottom ? null : {
              dimensions: null,
              path: null,
              uncroppedPoints: [
                { x: textLeft, y: textTop },
                { x: textRight, y: textTop },
                { x: textRight, y: textBottom },
                { x: textLeft, y: textBottom }
              ]
            });
          }
        } else {
          const element = node;
          const uncroppedPoints = getElementOutlinePoints(element, element.getBoundingClientRect(), contentRoot, rootRect);
          const ownerHTMLElement = element.ownerDocument.defaultView?.HTMLElement;
          geometry.set(node, uncroppedPoints === null ? null : {
            dimensions: ownerHTMLElement !== undefined && element instanceof ownerHTMLElement ? {
              width: element.offsetWidth,
              height: element.offsetHeight
            } : isSvgSvgElement(element) ? {
              width: element.width.baseVal.value,
              height: element.height.baseVal.value
            } : null,
            path: isSvgPathElement(element) ? getPathOutline({ element, contentRoot }) : null,
            uncroppedPoints
          });
        }
      }
      const measured = geometry.get(node);
      if (!measured) {
        continue;
      }
      measurableNodes.push(node);
      for (const point of measured.uncroppedPoints) {
        left = Math.min(left, point.x);
        top = Math.min(top, point.y);
        right = Math.max(right, point.x);
        bottom = Math.max(bottom, point.y);
      }
    }
    if (measurableNodes.length === 0 || !target.includeOutsideContainer && (right <= 0 || left >= contentRoot.offsetWidth || bottom <= 0 || top >= contentRoot.offsetHeight)) {
      continue;
    }
    if (measurableNodes.length !== 1 || measurableNodes[0].nodeType !== 1) {
      const groupPoints = [
        { x: left, y: top },
        { x: right, y: top },
        { x: right, y: bottom },
        { x: left, y: bottom }
      ];
      outlines.push({
        key: target.key,
        points: groupPoints,
        uncroppedPoints: groupPoints,
        dimensions: null,
        path: null
      });
      continue;
    }
    const elementGeometry = geometry.get(measurableNodes[0]);
    if (!elementGeometry) {
      throw new Error("Expected measured outline geometry");
    }
    outlines.push({
      ...elementGeometry,
      key: target.key,
      points: cropCanvasOutlinePoints(elementGeometry.uncroppedPoints, target.crop)
    });
  }
  return outlines;
};
var canvasOutlinesAreEqual = (a, b) => {
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0;i < a.length; i++) {
    if (a[i].key !== b[i].key) {
      return false;
    }
    if (a[i].dimensions?.width !== b[i].dimensions?.width || a[i].dimensions?.height !== b[i].dimensions?.height) {
      return false;
    }
    const aUncropped = a[i].uncroppedPoints;
    const bUncropped = b[i].uncroppedPoints;
    if (aUncropped === null !== (bUncropped === null)) {
      return false;
    }
    if (aUncropped !== null && bUncropped !== null) {
      for (let j = 0;j < aUncropped.length; j++) {
        if (Math.abs(aUncropped[j].x - bUncropped[j].x) > 0.01 || Math.abs(aUncropped[j].y - bUncropped[j].y) > 0.01) {
          return false;
        }
      }
    }
    const aPath = a[i].path;
    const bPath = b[i].path;
    if (aPath === null !== (bPath === null)) {
      return false;
    }
    if (aPath !== null && bPath !== null) {
      if (aPath.d !== bPath.d) {
        return false;
      }
      if (Math.abs(aPath.matrix.a - bPath.matrix.a) > 0.01 || Math.abs(aPath.matrix.b - bPath.matrix.b) > 0.01 || Math.abs(aPath.matrix.c - bPath.matrix.c) > 0.01 || Math.abs(aPath.matrix.d - bPath.matrix.d) > 0.01 || Math.abs(aPath.matrix.e - bPath.matrix.e) > 0.01 || Math.abs(aPath.matrix.f - bPath.matrix.f) > 0.01) {
        return false;
      }
    }
    for (let j = 0;j < a[i].points.length; j++) {
      if (Math.abs(a[i].points[j].x - b[i].points[j].x) > 0.01 || Math.abs(a[i].points[j].y - b[i].points[j].y) > 0.01) {
        return false;
      }
    }
  }
  return true;
};
// src/outline-order.ts
var outlinePointEqualityTolerance = 0.5;
var outlineAreaEqualityTolerance = 0.5;
var outlineBoundsOverlapTolerance = 0.5;
var outlinePointsAreEquivalent = (a, b) => {
  return Math.abs(a.x - b.x) <= outlinePointEqualityTolerance && Math.abs(a.y - b.y) <= outlinePointEqualityTolerance;
};
var outlinesHaveEquivalentHitArea = (a, b) => {
  if (a.points.length !== b.points.length) {
    return false;
  }
  for (let startIndex = 0;startIndex < b.points.length; startIndex++) {
    for (const direction of [1, -1]) {
      const pointsMatch = a.points.every((point, index) => {
        const bIndex = (startIndex + direction * index + b.points.length) % b.points.length;
        return outlinePointsAreEquivalent(point, b.points[bIndex]);
      });
      if (pointsMatch) {
        return true;
      }
    }
  }
  return false;
};
var getOutlineHitArea = (outline) => {
  let area = 0;
  for (let i = 0;i < outline.points.length; i++) {
    const current = outline.points[i];
    const next = outline.points[(i + 1) % outline.points.length];
    area += current.x * next.y - next.x * current.y;
  }
  return Math.abs(area) / 2;
};
var getOutlineBounds = (outline) => {
  const xs = outline.points.map((point) => point.x);
  const ys = outline.points.map((point) => point.y);
  return {
    maxX: Math.max(...xs),
    maxY: Math.max(...ys),
    minX: Math.min(...xs),
    minY: Math.min(...ys)
  };
};
var outlineBoundsOverlap = (aBounds, bBounds) => {
  return aBounds.minX <= bBounds.maxX + outlineBoundsOverlapTolerance && aBounds.maxX + outlineBoundsOverlapTolerance >= bBounds.minX && aBounds.minY <= bBounds.maxY + outlineBoundsOverlapTolerance && aBounds.maxY + outlineBoundsOverlapTolerance >= bBounds.minY;
};
var getSequenceId = (target) => {
  return target?.sequence?.id ?? null;
};
var getParentBySequenceId = ({
  sequences,
  targetsByKey
}) => {
  const parentBySequenceId = new Map;
  for (const sequence of sequences) {
    parentBySequenceId.set(sequence.id, sequence.parent);
  }
  for (const target of targetsByKey.values()) {
    const sequenceId = getSequenceId(target);
    if (sequenceId !== null && !parentBySequenceId.has(sequenceId)) {
      parentBySequenceId.set(sequenceId, target.sequence.parent);
    }
  }
  return parentBySequenceId;
};
var isAncestorTarget = ({
  ancestor,
  descendant,
  parentBySequenceId
}) => {
  const ancestorId = getSequenceId(ancestor);
  if (ancestorId === null) {
    return false;
  }
  let parentId = descendant.sequence?.parent ?? null;
  while (parentId !== null) {
    if (parentId === ancestorId) {
      return true;
    }
    parentId = parentBySequenceId.get(parentId) ?? null;
  }
  return false;
};
var orderOutlineGroup = ({
  outlines,
  parentBySequenceId,
  targetsByKey
}) => {
  const incomingEdges = new Map;
  const outgoingEdges = new Map;
  const outlinesByKey = new Map(outlines.map((outline) => [outline.key, outline]));
  for (const outline of outlines) {
    incomingEdges.set(outline.key, new Set);
    outgoingEdges.set(outline.key, new Set);
  }
  const hasPath = ({
    fromKey,
    seen,
    toKey
  }) => {
    if (fromKey === toKey) {
      return true;
    }
    if (seen.has(fromKey)) {
      return false;
    }
    seen.add(fromKey);
    for (const nextKey of outgoingEdges.get(fromKey) ?? []) {
      if (hasPath({ fromKey: nextKey, seen, toKey })) {
        return true;
      }
    }
    return false;
  };
  const addEdge = (before, after, options) => {
    if (before.key === after.key) {
      return;
    }
    const incoming = incomingEdges.get(after.key);
    const outgoing = outgoingEdges.get(before.key);
    if (incoming === undefined || outgoing === undefined) {
      throw new Error("Expected outline to be registered before adding edge");
    }
    if (outgoing.has(after.key)) {
      return;
    }
    if (hasPath({ fromKey: after.key, seen: new Set, toKey: before.key })) {
      if (options?.skipIfCycle) {
        return;
      }
      throw new Error("Could not determine a stable outline rendering order");
    }
    incoming.add(before.key);
    outgoing.add(after.key);
  };
  const addAncestorConstraint = ({
    ancestor,
    ancestorIsSeries,
    descendant,
    descendantContainsSelection,
    equivalentHitArea
  }) => {
    if (equivalentHitArea && !descendantContainsSelection && !ancestorIsSeries) {
      addEdge(descendant, ancestor, null);
    } else {
      addEdge(ancestor, descendant, null);
    }
  };
  const outlineBySequenceId = new Map;
  for (const outline of outlines) {
    const sequenceId = getSequenceId(targetsByKey.get(outline.key));
    if (sequenceId !== null) {
      outlineBySequenceId.set(sequenceId, outline);
    }
  }
  for (const descendant of outlines) {
    const descendantTarget = targetsByKey.get(descendant.key);
    let parentId = descendantTarget?.sequence?.parent ?? null;
    while (parentId !== null) {
      const ancestor = outlineBySequenceId.get(parentId);
      if (ancestor !== undefined) {
        const ancestorComponentIdentity = targetsByKey.get(ancestor.key)?.sequence.controls?.componentIdentity;
        addAncestorConstraint({
          ancestor,
          ancestorIsSeries: ancestorComponentIdentity === "dev.remotion.remotion.Series" || ancestorComponentIdentity === "dev.remotion.transitions.TransitionSeries",
          descendant,
          descendantContainsSelection: (descendantTarget?.selected ?? false) || (descendantTarget?.containsSelection ?? false),
          equivalentHitArea: outlinesHaveEquivalentHitArea(ancestor, descendant)
        });
        break;
      }
      parentId = parentBySequenceId.get(parentId) ?? null;
    }
  }
  const bounds = outlines.map(getOutlineBounds);
  const areas = outlines.map(getOutlineHitArea);
  for (let i = 0;i < outlines.length; i++) {
    const a = outlines[i];
    const aTarget = targetsByKey.get(a.key);
    if (aTarget === undefined) {
      continue;
    }
    for (let j = i + 1;j < outlines.length; j++) {
      if (!outlineBoundsOverlap(bounds[i], bounds[j])) {
        continue;
      }
      const aArea = areas[i];
      const bArea = areas[j];
      if (Math.abs(aArea - bArea) <= outlineAreaEqualityTolerance) {
        continue;
      }
      const b = outlines[j];
      const bTarget = targetsByKey.get(b.key);
      if (bTarget === undefined) {
        continue;
      }
      const aAncestorOfB = isAncestorTarget({
        ancestor: aTarget,
        descendant: bTarget,
        parentBySequenceId
      });
      const bAncestorOfA = isAncestorTarget({
        ancestor: bTarget,
        descendant: aTarget,
        parentBySequenceId
      });
      if (aAncestorOfB || bAncestorOfA) {
        continue;
      }
      if (aArea > bArea) {
        addEdge(a, b, { skipIfCycle: true });
      } else {
        addEdge(b, a, { skipIfCycle: true });
      }
    }
  }
  const emitted = new Set;
  const visiting = new Set;
  const ordered = [];
  const visit = (outline) => {
    if (emitted.has(outline.key)) {
      return;
    }
    if (visiting.has(outline.key)) {
      throw new Error("Could not determine a stable outline rendering order");
    }
    visiting.add(outline.key);
    for (const dependencyKey of incomingEdges.get(outline.key) ?? []) {
      const dependency = outlinesByKey.get(dependencyKey);
      if (dependency === undefined) {
        throw new Error("Expected outline dependency to exist");
      }
      visit(dependency);
    }
    visiting.delete(outline.key);
    emitted.add(outline.key);
    ordered.push(outline);
  };
  for (const outline of outlines) {
    visit(outline);
  }
  return ordered;
};
var orderCanvasOutlinesForRendering = ({
  outlines,
  sequences,
  targetsByKey
}) => {
  const parentBySequenceId = getParentBySequenceId({ sequences, targetsByKey });
  return orderOutlineGroup({
    outlines,
    parentBySequenceId,
    targetsByKey
  });
};
// src/use-canvas-outline-measurements.ts
import { useCallback as useCallback2, useLayoutEffect, useRef, useState as useState2 } from "react";
import { Internals as Internals6 } from "remotion";
var useCanvasOutlineMeasurements = ({
  contentRoot,
  targets
}) => {
  const [outlines, setOutlines] = useState2([]);
  const outlinesRef = useRef(outlines);
  const latestUpdateRef = useRef(() => {
    return;
  });
  const resizeObserverRef = useRef(null);
  const observedElementsRef = useRef(new Set);
  const measuredNodesRef = useRef(new Map);
  const updateOutlines = useCallback2(() => {
    if (targets.length === 0) {
      resizeObserverRef.current?.disconnect();
      observedElementsRef.current = new Set;
      if (outlinesRef.current.length === 0) {
        return;
      }
      outlinesRef.current = [];
      setOutlines(outlinesRef.current);
      return;
    }
    const resizeObserver = resizeObserverRef.current;
    if (resizeObserver !== null) {
      const nextObservedElements = new Set;
      nextObservedElements.add(contentRoot);
      for (const target of targets) {
        for (const node of getCanvasOutlineNodes(target.ref)) {
          const element = node.nodeType === 1 ? node : node.parentElement;
          if (element !== null) {
            nextObservedElements.add(element);
          }
        }
      }
      for (const element of observedElementsRef.current) {
        if (!nextObservedElements.has(element)) {
          resizeObserver.unobserve(element);
        }
      }
      for (const element of nextObservedElements) {
        if (!observedElementsRef.current.has(element)) {
          resizeObserver.observe(element);
        }
      }
      observedElementsRef.current = nextObservedElements;
    }
    const nextOutlines = measureCanvasOutlineTargets(contentRoot, targets);
    measuredNodesRef.current = new Map(targets.map((target) => [
      target.ref,
      Internals6.SequenceOutlineInternals.getNodes(target.ref)
    ]));
    if (canvasOutlinesAreEqual(outlinesRef.current, nextOutlines)) {
      return;
    }
    outlinesRef.current = nextOutlines;
    setOutlines(nextOutlines);
  }, [contentRoot, targets]);
  useLayoutEffect(() => {
    latestUpdateRef.current = updateOutlines;
    let active = true;
    let scheduled = false;
    const scheduleUpdate = () => {
      if (scheduled)
        return;
      scheduled = true;
      queueMicrotask(() => {
        scheduled = false;
        if (active)
          updateOutlines();
      });
    };
    const ownerWindow = contentRoot.ownerDocument.defaultView;
    const onCommit = () => {
      if (targets.some((target) => measuredNodesRef.current.get(target.ref) !== Internals6.SequenceOutlineInternals.getNodes(target.ref))) {
        scheduleUpdate();
      }
    };
    const hasAutomaticTargets = targets.some((target) => Internals6.SequenceOutlineInternals.getNodes(target.ref) !== null);
    if (hasAutomaticTargets) {
      latestUpdateRef.current = scheduleUpdate;
      ownerWindow?.addEventListener(Internals6.CommittedMetadataInternals.eventName, onCommit);
      scheduleUpdate();
    } else {
      updateOutlines();
    }
    return () => {
      active = false;
      ownerWindow?.removeEventListener(Internals6.CommittedMetadataInternals.eventName, onCommit);
      latestUpdateRef.current = () => {
        return;
      };
    };
  }, [contentRoot, targets, updateOutlines]);
  useLayoutEffect(() => {
    const ownerWindow = contentRoot.ownerDocument.defaultView;
    if (!ownerWindow || typeof ownerWindow.ResizeObserver === "undefined") {
      return;
    }
    let animationFrame = null;
    const resizeObserver = new ownerWindow.ResizeObserver(() => {
      if (animationFrame !== null) {
        return;
      }
      animationFrame = ownerWindow.requestAnimationFrame(() => {
        animationFrame = null;
        latestUpdateRef.current();
      });
    });
    resizeObserverRef.current = resizeObserver;
    latestUpdateRef.current();
    return () => {
      if (animationFrame !== null) {
        ownerWindow.cancelAnimationFrame(animationFrame);
      }
      resizeObserver.disconnect();
      resizeObserverRef.current = null;
      observedElementsRef.current = new Set;
    };
  }, [contentRoot]);
  useLayoutEffect(() => {
    const ownerWindow = contentRoot.ownerDocument.defaultView;
    if (!ownerWindow || typeof ownerWindow.MutationObserver === "undefined") {
      return;
    }
    const observer = new ownerWindow.MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.target !== contentRoot || mutation.type !== "attributes")) {
        latestUpdateRef.current();
      }
    });
    observer.observe(contentRoot, {
      attributes: true,
      characterData: true,
      childList: true,
      subtree: true
    });
    return () => observer.disconnect();
  }, [contentRoot]);
  return outlines;
};
// src/use-canvas-outlines.ts
import { useEffect, useLayoutEffect as useLayoutEffect2, useMemo as useMemo2, useRef as useRef2 } from "react";
var useCanvasOutlines = ({
  contentRoot,
  targets,
  sequences,
  hoverController,
  freezeOrder
}) => {
  const hover = useCanvasHover(hoverController);
  const hoveredNodePathKey = hover?.nodePathKey ?? null;
  const hoveredTimelineNodePathKey = hover?.source === "timeline" ? hoveredNodePathKey : null;
  const measurementTargets = useMemo2(() => targets.map((target) => ({
    crop: target.crop,
    includeOutsideContainer: target.showSelectedOutline || timelineSequenceNodePathToKey(target.nodePathInfo.sequenceSubscriptionKey) === hoveredTimelineNodePathKey,
    key: target.key,
    ref: target.ref
  })), [hoveredTimelineNodePathKey, targets]);
  const outlines = useCanvasOutlineMeasurements({
    contentRoot,
    targets: measurementTargets
  });
  const targetsByKey = useMemo2(() => new Map(targets.map((target) => [target.key, target])), [targets]);
  const previousOrderInputsRef = useRef2(null);
  const orderInputs = useMemo2(() => {
    const previous = previousOrderInputsRef.current;
    if (previous !== null && previous.sequences.length === sequences.length && previous.sequences.every((sequence, index) => sequence.id === sequences[index].id && sequence.parent === sequences[index].parent) && previous.targets.length === targets.length && previous.targets.every((target, index) => {
      const next = targets[index];
      return target.key === next.key && target.selected === next.selected && target.containsSelection === next.containsSelection && target.sequence.id === next.sequence.id && target.sequence.parent === next.sequence.parent && target.sequence.controls?.componentIdentity === (next.sequence.controls?.componentIdentity ?? null);
    })) {
      return previous;
    }
    const orderTargets = targets.map((target) => ({
      key: target.key,
      selected: target.selected,
      containsSelection: target.containsSelection,
      sequence: {
        id: target.sequence.id,
        parent: target.sequence.parent,
        controls: {
          componentIdentity: target.sequence.controls?.componentIdentity ?? null
        }
      }
    }));
    return {
      sequences: sequences.map(({ id, parent }) => ({ id, parent })),
      targets: orderTargets,
      targetsByKey: new Map(orderTargets.map((target) => [target.key, target]))
    };
  }, [sequences, targets]);
  useLayoutEffect2(() => {
    previousOrderInputsRef.current = orderInputs;
  }, [orderInputs]);
  const renderingOrderRef = useRef2([]);
  const outlinesForRendering = useMemo2(() => {
    if (!freezeOrder || renderingOrderRef.current.length === 0) {
      const ordered = orderCanvasOutlinesForRendering({
        outlines,
        sequences: orderInputs.sequences,
        targetsByKey: orderInputs.targetsByKey
      });
      renderingOrderRef.current = ordered.map((outline) => outline.key);
      return ordered;
    }
    const currentOutlinesByKey = new Map(outlines.map((outline) => [outline.key, outline]));
    const frozenKeys = new Set(renderingOrderRef.current);
    renderingOrderRef.current = [
      ...renderingOrderRef.current,
      ...outlines.filter((outline) => !frozenKeys.has(outline.key)).map((outline) => outline.key)
    ];
    return renderingOrderRef.current.flatMap((key) => {
      const outline = currentOutlinesByKey.get(key);
      return outline === undefined ? [] : [outline];
    });
  }, [freezeOrder, orderInputs, outlines]);
  const outlinesByKey = useMemo2(() => new Map(outlines.map((outline) => [outline.key, outline])), [outlines]);
  useEffect(() => {
    if (hover?.source !== "canvas" || targetsByKey.has(hover.key) && outlinesByKey.has(hover.key)) {
      return;
    }
    hoverController.setHoveredSequence((current) => current?.source === "canvas" && current.key === hover.key ? null : current);
  }, [hover, hoverController, outlinesByKey, targetsByKey]);
  return {
    outlines,
    outlinesForRendering,
    outlinesByKey,
    targetsByKey,
    hoveredNodePathKey
  };
};
// src/canvas-outline-polygon.tsx
import { forwardRef, memo, useCallback as useCallback3, useMemo as useMemo3 } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var CanvasOutlinePolygon = memo(forwardRef(({
  outline,
  directlySelected,
  dragging,
  visible,
  interactive,
  fill,
  stroke,
  onHoverChange,
  ...props
}, ref) => {
  const points = useMemo3(() => outline.points.map((point) => `${point.x},${point.y}`).join(" "), [outline.points]);
  const matrixTransform = useMemo3(() => outline.path === null ? null : `matrix(${outline.path.matrix.a} ${outline.path.matrix.b} ${outline.path.matrix.c} ${outline.path.matrix.d} ${outline.path.matrix.e} ${outline.path.matrix.f})`, [outline.path]);
  const onPointerEnter = useCallback3(() => {
    if (!dragging) {
      onHoverChange(outline.key);
    }
  }, [dragging, onHoverChange, outline.key]);
  const onPointerLeave = useCallback3(() => {
    if (!dragging) {
      onHoverChange(null);
    }
  }, [dragging, onHoverChange]);
  return /* @__PURE__ */ jsxs("g", {
    children: [
      /* @__PURE__ */ jsx("polygon", {
        ...props,
        ref,
        "data-remotion-canvas-outline-key": outline.key,
        "data-remotion-directly-selected-outline": directlySelected ? "true" : undefined,
        points,
        fill,
        stroke: matrixTransform === null ? stroke : "transparent",
        strokeOpacity: visible ? 1 : 0,
        strokeWidth: 2,
        vectorEffect: "non-scaling-stroke",
        pointerEvents: interactive ? "all" : "none",
        onPointerEnter,
        onPointerLeave
      }),
      matrixTransform === null ? null : /* @__PURE__ */ jsx("path", {
        d: outline.path?.d ?? "",
        transform: matrixTransform,
        fill: "none",
        stroke,
        strokeOpacity: visible ? 1 : 0,
        strokeWidth: 2,
        vectorEffect: "non-scaling-stroke",
        pointerEvents: "none"
      })
    ]
  });
}));
// src/outline-interaction.ts
var getCanvasOutlineSelectionInteraction = ({
  shiftKey,
  metaKey,
  ctrlKey
}) => ({
  shiftKey,
  toggleKey: metaKey || ctrlKey
});
var handleCanvasOutlinePointerDown = ({
  event,
  polygon,
  hasTarget,
  selected,
  containsSelection,
  translateWithCommandKey,
  isMac
}) => {
  if (event.button !== 0 || !hasTarget) {
    return null;
  }
  event.preventDefault();
  event.stopPropagation();
  const temporaryTranslate = translateWithCommandKey && (selected || containsSelection) && (isMac ? event.metaKey : event.ctrlKey);
  const interaction = temporaryTranslate ? { shiftKey: false, toggleKey: false } : getCanvasOutlineSelectionInteraction(event);
  const shouldUpdateSelection = !selected || interaction.shiftKey || interaction.toggleKey;
  const ownerSvg = polygon?.ownerSVGElement;
  let pointerInsideSelectedOutline = false;
  if (ownerSvg) {
    pointerInsideSelectedOutline = Array.from(ownerSvg.querySelectorAll('polygon[data-remotion-directly-selected-outline="true"]')).some((selectedPolygon) => {
      const rect = selectedPolygon.getBoundingClientRect();
      if (rect.width === 0 && rect.height === 0) {
        return false;
      }
      const bbox = selectedPolygon.getBBox();
      if (bbox.width === 0 && bbox.height === 0) {
        return false;
      }
      const scaleX = rect.width / bbox.width;
      const scaleY = rect.height / bbox.height;
      if (!Number.isFinite(scaleX) || !Number.isFinite(scaleY)) {
        return false;
      }
      if (Math.abs(scaleX) < 0.000001 || Math.abs(scaleY) < 0.000001) {
        return false;
      }
      const localX = (event.clientX - rect.left) / scaleX + bbox.x;
      const localY = (event.clientY - rect.top) / scaleY + bbox.y;
      if (!Number.isFinite(localX) || !Number.isFinite(localY)) {
        return false;
      }
      const polygonPoint = ownerSvg.createSVGPoint();
      polygonPoint.x = localX;
      polygonPoint.y = localY;
      return selectedPolygon.isPointInFill(polygonPoint) || selectedPolygon.isPointInStroke(polygonPoint);
    });
  }
  const deferSelection = !selected && !interaction.shiftKey && !interaction.toggleKey && (containsSelection || pointerInsideSelectedOutline);
  return {
    interaction,
    temporaryTranslate,
    shouldUpdateSelection,
    deferSelection,
    dragExistingSelection: selected || deferSelection,
    pointerInsideSelectedOutline
  };
};
// src/outline-targets.ts
var getCanvasVisibleOutlineTargets = ({
  targets,
  timelinePosition
}) => {
  return targets.filter(({ sequence }) => timelinePosition >= sequence.from && timelinePosition < sequence.from + sequence.duration);
};
var getCanvasSelectableOutlines = ({
  tracks,
  timelinePosition,
  resolveSequenceNodePathInfo
}) => {
  const selectableOutlines = tracks.flatMap((track, index) => {
    const { sequence } = track;
    if (!sequence.showInTimeline || sequence.refForOutline === null) {
      return [];
    }
    const nodePathInfo = resolveSequenceNodePathInfo === null ? track.nodePathInfo : resolveSequenceNodePathInfo(track, index);
    if (nodePathInfo === null || nodePathInfo.auxiliaryKeys.length !== 0) {
      return [];
    }
    return [
      {
        depth: track.depth,
        keyframeDisplayOffset: track.keyframeDisplayOffset,
        keyframePlaybackRate: track.keyframePlaybackRate,
        key: getCanvasSequenceSelectionKey(nodePathInfo),
        nodePathInfo,
        registeredNodePathInfo: track.nodePathInfo,
        sequence
      }
    ];
  }).sort((a, b) => a.depth - b.depth);
  return timelinePosition === null ? selectableOutlines : getCanvasVisibleOutlineTargets({
    targets: selectableOutlines,
    timelinePosition
  });
};
var getCanvasSelectedSequenceKeys = (selectedItems) => {
  return new Set(selectedItems.filter((item) => item.type === "sequence").map((item) => getCanvasSequenceSelectionKey(item.nodePathInfo)));
};
var getCanvasSequenceKeysContainingSelection = (selectedItems) => {
  return new Set(selectedItems.filter((item) => item.type !== "guide").map((item) => getCanvasSequenceSelectionKey(item.nodePathInfo)));
};
var getCanvasActiveOutlineTargets = ({
  targets,
  selectedSequenceKeys,
  sequenceKeysContainingSelection,
  hoveredNodePathKey,
  measureAll
}) => {
  if (measureAll) {
    return targets;
  }
  const activeNodePathKeys = new Set;
  for (const { key, nodePathInfo } of targets) {
    const nodePathKey = timelineSequenceNodePathToKey(nodePathInfo.sequenceSubscriptionKey);
    if (selectedSequenceKeys.has(key) || sequenceKeysContainingSelection.has(key) || nodePathKey === hoveredNodePathKey) {
      activeNodePathKeys.add(nodePathKey);
    }
  }
  return targets.filter(({ nodePathInfo }) => activeNodePathKeys.has(timelineSequenceNodePathToKey(nodePathInfo.sequenceSubscriptionKey)));
};
var createCanvasOutlineLayoutTargetLookup = ({
  selectableOutlines,
  selectedSequenceKeys,
  sequenceKeysContainingSelection
}) => {
  const firstNodePathInfoBySourceNode = new Map;
  const selectedSourceNodeKeys = new Set;
  for (const { key, nodePathInfo } of selectableOutlines) {
    const sourceNodeKey = timelineSequenceNodePathToKey(nodePathInfo.sequenceSubscriptionKey);
    if (selectedSequenceKeys.has(key)) {
      selectedSourceNodeKeys.add(sourceNodeKey);
    }
    const currentFirst = firstNodePathInfoBySourceNode.get(sourceNodeKey);
    if (currentFirst === undefined || nodePathInfo.index < currentFirst.index) {
      firstNodePathInfoBySourceNode.set(sourceNodeKey, nodePathInfo);
    }
  }
  let outlinesByKey = null;
  return (targetKey) => {
    let matchingOutlines = selectableOutlines;
    if (targetKey !== null) {
      if (outlinesByKey === null) {
        outlinesByKey = new Map;
        for (const outline of selectableOutlines) {
          const matches = outlinesByKey.get(outline.key) ?? [];
          matches.push(outline);
          outlinesByKey.set(outline.key, matches);
        }
      }
      matchingOutlines = outlinesByKey.get(targetKey) ?? [];
    }
    return matchingOutlines.map((selectableOutline) => {
      const { key, nodePathInfo, sequence } = selectableOutline;
      if (sequence.refForOutline === null) {
        throw new Error("Expected sequence to have a ref for outline");
      }
      const nodePathKey = timelineSequenceNodePathToKey(nodePathInfo.sequenceSubscriptionKey);
      const selectionNodePathInfo = firstNodePathInfoBySourceNode.get(nodePathKey);
      if (selectionNodePathInfo === undefined) {
        throw new Error("Expected a first sequence for the source node");
      }
      const containsSelection = sequenceKeysContainingSelection.has(key);
      return {
        ...selectableOutline,
        nodePathKey,
        ref: sequence.refForOutline,
        selected: selectedSequenceKeys.has(key),
        containsSelection,
        showSelectedOutline: containsSelection || selectedSourceNodeKeys.has(nodePathKey),
        selection: {
          type: "sequence",
          nodePathInfo: selectionNodePathInfo
        }
      };
    });
  };
};
var getCanvasOutlineLayoutTargets = ({
  selectableOutlines,
  selectedSequenceKeys,
  sequenceKeysContainingSelection,
  targetKey
}) => {
  return createCanvasOutlineLayoutTargetLookup({
    selectableOutlines,
    selectedSequenceKeys,
    sequenceKeysContainingSelection
  })(targetKey);
};
var getCanvasOutlineActivity = ({
  canvasHovered,
  dragging,
  contextMenuOpen,
  hasSelection,
  hoveredSequence
}) => {
  const measureAllOutlines = canvasHovered || dragging || contextMenuOpen;
  return {
    measurementActive: measureAllOutlines || hasSelection || hoveredSequence?.source === "timeline",
    measureAllOutlines,
    hoveredTimelineNodePathKey: hoveredSequence?.source === "timeline" ? hoveredSequence.nodePathKey : null
  };
};
// src/get-connected-compositions.ts
var getConnectedCompositions = ({
  compositions,
  singleChildComponent
}) => {
  if (singleChildComponent === null || typeof singleChildComponent === "undefined") {
    return [];
  }
  return compositions.filter((composition) => composition.componentFromProps === singleChildComponent);
};
// src/get-sequence-visible-range.ts
var getParentSequencePlaybackRate = (sequence, sequences) => {
  if (sequence.parent === null) {
    return 1;
  }
  const parent = sequences.find((candidate) => candidate.id === sequence.parent);
  if (!parent) {
    throw new TypeError("Parent not found for sequence " + sequence.id);
  }
  return parent.sequencePlaybackRate * getParentSequencePlaybackRate(parent, sequences);
};
// src/use-runtime-value-snapshots.ts
import { useMemo as useMemo4 } from "react";
var useCanvasRuntimeValueSnapshots = (controls) => {
  const stores = useMemo4(() => controls.map((control) => control.runtimeValues), [controls]);
  const aggregateStore = useMemo4(() => {
    let lastSnapshots = stores.map((store) => store.getSnapshot());
    const getSnapshot = () => {
      const nextSnapshots = stores.map((store) => store.getSnapshot());
      if (nextSnapshots.length === lastSnapshots.length && nextSnapshots.every((snapshot, index) => snapshot === lastSnapshots[index])) {
        return lastSnapshots;
      }
      lastSnapshots = nextSnapshots;
      return lastSnapshots;
    };
    return {
      getSnapshot,
      subscribe: (listener) => {
        let active = true;
        let scheduled = false;
        const onStoreChange = () => {
          if (scheduled) {
            return;
          }
          scheduled = true;
          queueMicrotask(() => {
            scheduled = false;
            if (active) {
              listener();
            }
          });
        };
        const unsubscribers = stores.map((store) => store.subscribe(onStoreChange));
        return () => {
          active = false;
          for (const unsubscribe of unsubscribers) {
            unsubscribe();
          }
        };
      }
    };
  }, [stores]);
  return useSyncExternalStore(aggregateStore.subscribe, aggregateStore.getSnapshot, aggregateStore.getSnapshot);
};
// src/pointer-session.ts
var isPointerSessionRelease = (reason, event) => {
  if (event === null) {
    return false;
  }
  return reason === "pointerup" || reason === "buttons-released" || reason === "lostpointercapture" && event.buttons === 0;
};
var getButtonMask = (button) => {
  if (button === 0) {
    return 1;
  }
  if (button === 1) {
    return 4;
  }
  if (button === 2) {
    return 2;
  }
  return 1 << button;
};
var startPointerSession = ({
  event,
  captureTarget,
  onMove,
  onEnd
}) => {
  const { pointerId } = event;
  const buttonMask = getButtonMask(event.button);
  let ended = false;
  let activeCaptureTarget = null;
  let cleanup = () => {
    return;
  };
  const end = (reason, pointerEvent) => {
    if (ended) {
      return;
    }
    ended = true;
    cleanup();
    onEnd(reason, pointerEvent);
  };
  const handleLostPointerCapture = (lostEvent) => {
    const pointerEvent = lostEvent;
    if (pointerEvent.pointerId === pointerId) {
      end("lostpointercapture", pointerEvent);
    }
  };
  const capturePointer = (target) => {
    if (activeCaptureTarget !== null) {
      return;
    }
    activeCaptureTarget = target;
    try {
      target.setPointerCapture?.(pointerId);
    } catch {}
    target.addEventListener("lostpointercapture", handleLostPointerCapture);
  };
  const handleMove = (moveEvent) => {
    if (moveEvent.pointerId !== pointerId) {
      return;
    }
    if ((moveEvent.buttons & buttonMask) === 0) {
      end("buttons-released", moveEvent);
      return;
    }
    onMove?.(moveEvent, capturePointer);
  };
  const handleUp = (upEvent) => {
    if (upEvent.pointerId === pointerId) {
      end("pointerup", upEvent);
    }
  };
  const handleCancel = (cancelEvent) => {
    if (cancelEvent.pointerId === pointerId) {
      end("pointercancel", cancelEvent);
    }
  };
  const handleBlur = () => {
    end("blur", null);
  };
  const handleVisibilityChange = () => {
    if (document.visibilityState === "hidden") {
      end("visibilitychange", null);
    }
  };
  cleanup = () => {
    window.removeEventListener("pointermove", handleMove);
    window.removeEventListener("pointerup", handleUp);
    window.removeEventListener("pointercancel", handleCancel);
    window.removeEventListener("blur", handleBlur);
    document.removeEventListener("visibilitychange", handleVisibilityChange);
    activeCaptureTarget?.removeEventListener("lostpointercapture", handleLostPointerCapture);
    if (activeCaptureTarget?.hasPointerCapture?.(pointerId)) {
      try {
        activeCaptureTarget.releasePointerCapture(pointerId);
      } catch {}
    }
  };
  if (captureTarget !== null) {
    capturePointer(captureTarget);
  }
  window.addEventListener("pointermove", handleMove);
  window.addEventListener("pointerup", handleUp);
  window.addEventListener("pointercancel", handleCancel);
  window.addEventListener("blur", handleBlur);
  document.addEventListener("visibilitychange", handleVisibilityChange);
  return () => end("manual", null);
};
var startCapturedPointerSession = ({
  event,
  captureTarget,
  onMove,
  onEnd
}) => {
  return startPointerSession({ event, captureTarget, onMove, onEnd });
};
var startDeferredCapturedPointerSession = ({
  event,
  captureTarget,
  onMove,
  onEnd
}) => {
  return startPointerSession({
    event,
    captureTarget: null,
    onMove: (moveEvent, capturePointer) => {
      onMove(moveEvent, () => capturePointer(captureTarget));
    },
    onEnd
  });
};
var observePointerRelease = ({
  event,
  onEnd
}) => {
  return startPointerSession({
    event,
    captureTarget: null,
    onEnd
  });
};
// src/translate-value.ts
var TRANSLATE_PATTERN = /^(-?\d+(?:\.\d+)?)(px|%)?(?:\s+(-?\d+(?:\.\d+)?)(px|%)?)?(?:\s+(-?\d+(?:\.\d+)?)(px)?)?$/i;
var translateDecimalPlaces = 1;
var roundToDecimalPlaces = (value, decimalPlaces) => {
  const factor = 10 ** decimalPlaces;
  const rounded = Math.round(value * factor) / factor;
  return Object.is(rounded, -0) ? 0 : rounded;
};
var normalizeNumber = (value) => roundToDecimalPlaces(value, 6);
var parseTranslateWithUnits = (value) => {
  const match = value.match(TRANSLATE_PATTERN);
  if (!match) {
    return null;
  }
  const x = normalizeNumber(Number(match[1]));
  const y = match[3] === undefined ? 0 : normalizeNumber(Number(match[3]));
  const z = match[5] === undefined ? null : normalizeNumber(Number(match[5]));
  if (match[2] === undefined && x !== 0 || match[3] !== undefined && match[4] === undefined && y !== 0 || match[5] !== undefined && match[6] === undefined && z !== 0) {
    return null;
  }
  return [
    {
      value: x,
      unit: match[2] === undefined ? "px" : match[2].toLowerCase()
    },
    {
      value: y,
      unit: match[4] === undefined ? "px" : match[4].toLowerCase()
    },
    z === null ? z : {
      value: z,
      unit: "px"
    }
  ];
};
var parseTranslate = (value) => {
  const parsed = parseTranslateWithUnits(value);
  if (parsed === null || parsed[0].unit !== "px" || parsed[1].unit !== "px") {
    return [0, 0, null];
  }
  return [parsed[0].value, parsed[1].value, parsed[2]?.value ?? null];
};
var formatTranslateCoordinate = (value, decimalPlaces) => {
  const rounded = roundToDecimalPlaces(normalizeNumber(value), decimalPlaces);
  return String(Object.is(rounded, -0) ? 0 : rounded);
};
var serializeTranslateWithUnits = ([x, y, z], decimalPlaces = translateDecimalPlaces) => {
  const xy = `${formatTranslateCoordinate(x.value, decimalPlaces)}${x.unit} ${formatTranslateCoordinate(y.value, decimalPlaces)}${y.unit}`;
  return z === null ? xy : `${xy} ${formatTranslateCoordinate(z.value, decimalPlaces)}${z.unit}`;
};
var serializeTranslate = ([x, y, z], decimalPlaces = translateDecimalPlaces) => {
  return serializeTranslateWithUnits([
    { value: x, unit: "px" },
    { value: y, unit: "px" },
    z === null ? null : { value: z, unit: "px" }
  ], decimalPlaces);
};
// src/keyframe-frames.ts
var getKeyframePlaybackRate = (propStatus, keyframePlaybackRate) => keyframePlaybackRate * (propStatus && propStatus.status !== "computed" ? propStatus.keyframePlaybackRateAdjustment ?? 1 : 1);
var getKeyframeLocalFrame = (sourceFrame, propStatus) => propStatus.status === "computed" ? sourceFrame : (sourceFrame + (propStatus.keyframeDisplayOffsetAdjustment ?? 0)) / (propStatus.keyframePlaybackRateAdjustment ?? 1);
var getKeyframeSourceFrame = ({
  displayFrame,
  keyframeDisplayOffset,
  keyframePlaybackRate,
  propStatus
}) => {
  const playbackRate = getKeyframePlaybackRate(propStatus, keyframePlaybackRate);
  const sourceFrame = (displayFrame - keyframeDisplayOffset) * playbackRate;
  if (propStatus?.status !== "keyframed") {
    return sourceFrame;
  }
  const tolerance = Number.EPSILON * Math.max(1, Math.abs(displayFrame), Math.abs(keyframeDisplayOffset)) * playbackRate * 8;
  let closestFrame = sourceFrame;
  let closestDistance = Infinity;
  for (const keyframe of propStatus.keyframes) {
    const distance = Math.abs(keyframe.frame - sourceFrame);
    if (distance <= tolerance && distance < closestDistance) {
      closestFrame = keyframe.frame;
      closestDistance = distance;
    }
  }
  return closestFrame;
};
var resolveKeyframeSourceFrame = (sourceFrame, propStatus) => {
  return getKeyframeSourceFrame({
    ...typeof sourceFrame === "number" ? {
      displayFrame: sourceFrame,
      keyframeDisplayOffset: 0,
      keyframePlaybackRate: 1 / getKeyframePlaybackRate(propStatus, 1)
    } : sourceFrame,
    propStatus
  });
};
var getKeyframeDisplayOffset = ({
  propStatus,
  keyframeDisplayOffset,
  keyframePlaybackRate
}) => {
  return keyframeDisplayOffset + (propStatus?.status === "keyframed" || propStatus?.status === "static" ? propStatus.keyframeDisplayOffsetAdjustment === null ? 0 : propStatus.keyframeDisplayOffsetAdjustment / getKeyframePlaybackRate(propStatus, keyframePlaybackRate) : 0);
};
var getTimelineKeyframes = (propStatus, keyframeDisplayOffset = 0, keyframePlaybackRate = 1) => {
  if (!propStatus) {
    return [];
  }
  if (propStatus.status !== "keyframed") {
    return [];
  }
  const { keyframes } = propStatus;
  const playbackRate = getKeyframePlaybackRate(propStatus, keyframePlaybackRate);
  const resolvedKeyframeDisplayOffset = getKeyframeDisplayOffset({
    propStatus,
    keyframeDisplayOffset,
    keyframePlaybackRate
  });
  if (resolvedKeyframeDisplayOffset === 0 && playbackRate === 1) {
    return keyframes;
  }
  return keyframes.map((keyframe) => ({
    ...keyframe,
    frame: keyframe.frame / playbackRate + resolvedKeyframeDisplayOffset
  }));
};
// src/keyframe-navigation.ts
var isKeyframeInTimelineRange = (frame, durationInFrames) => {
  return frame >= 0 && frame < durationInFrames;
};
var getPreviousKeyframeDisplayFrame = (keyframes, currentDisplayFrame, durationInFrames) => {
  let previous = null;
  for (const keyframe of keyframes) {
    if (isKeyframeInTimelineRange(keyframe.frame, durationInFrames) && keyframe.frame < currentDisplayFrame && (previous === null || keyframe.frame > previous)) {
      previous = keyframe.frame;
    }
  }
  return previous;
};
var getNextKeyframeDisplayFrame = (keyframes, currentDisplayFrame, durationInFrames) => {
  let next = null;
  for (const keyframe of keyframes) {
    if (isKeyframeInTimelineRange(keyframe.frame, durationInFrames) && keyframe.frame > currentDisplayFrame && (next === null || keyframe.frame < next)) {
      next = keyframe.frame;
    }
  }
  return next;
};
var hasKeyframeAtSourceFrame = (keyframes, sourceFrame) => {
  return keyframes.some((keyframe) => keyframe.frame === sourceFrame);
};
// src/keyframe-value.ts
import { isSchemaFieldKeyframable } from "@remotion/studio-shared";
import { Internals as Internals7 } from "remotion";
var normalizeFontWeightForKeyframe = (value) => {
  if (value === "normal") {
    return 400;
  }
  if (value === "bold") {
    return 700;
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value === "string" && /^\d+(?:\.\d+)?$/.test(value)) {
    return Number(value);
  }
  return null;
};
var isCanvasKeyframablePropStatus = ({
  propStatus,
  schema,
  key
}) => {
  if (propStatus.status === "computed") {
    return false;
  }
  if (propStatus.status === "static" && propStatus.canKeyframe === false) {
    return false;
  }
  return isSchemaFieldKeyframable({ schema, key });
};
var getCanvasKeyframeValueAtSourceFrame = ({
  propStatus,
  sourceFrame,
  defaultValue,
  dragOverrideValue
}) => {
  if (propStatus.status === "computed") {
    return null;
  }
  const value = Internals7.getEffectiveVisualModeValue({
    propStatus,
    dragOverrideValue,
    frame: getKeyframeLocalFrame(sourceFrame, propStatus),
    defaultValue,
    shouldResortToDefaultValueIfUndefined: true
  });
  return value === undefined ? null : value;
};
var getCanvasKeyframeValueToAdd = ({
  propStatus,
  schema,
  key,
  sourceFrame,
  defaultValue,
  dragOverrideValue
}) => {
  const value = getCanvasKeyframeValueAtSourceFrame({
    propStatus,
    sourceFrame,
    defaultValue,
    dragOverrideValue
  });
  if (value === null) {
    return null;
  }
  return Internals7.getFlatSchemaWithAllKeys(schema)[key]?.type === "font-weight" ? normalizeFontWeightForKeyframe(value) : value;
};
// src/keyframe-move.ts
import {
  canMoveKeyframesWithoutCollisions,
  moveKeyframesInPropStatus
} from "@remotion/studio-shared";
var getBoundedKeyframeDragDelta = ({
  delta,
  durationInFrames,
  targets
}) => {
  if (targets.length === 0 || durationInFrames <= 0) {
    return 0;
  }
  const minDelta = Math.max(...targets.map((target) => -target.displayFrame));
  const maxDelta = Math.min(...targets.map((target) => durationInFrames - 1 - target.displayFrame));
  return Math.min(Math.max(delta, minDelta), maxDelta);
};
var getCanvasKeyframeMove = (target, delta) => ({
  fromFrame: target.sourceFrame,
  toFrame: resolveKeyframeSourceFrame(target.sourceFrame + delta * getKeyframePlaybackRate(target.propStatus, target.keyframePlaybackRate), target.propStatus)
});
var getCanvasKeyframeMoves = (targets, delta) => {
  const moves = targets.map((target) => getCanvasKeyframeMove(target, delta));
  if (moves.length < 2) {
    return moves;
  }
  const destinations = new Map;
  return moves.filter(({ fromFrame, toFrame }) => {
    if (destinations.get(fromFrame) === toFrame) {
      return false;
    }
    destinations.set(fromFrame, toFrame);
    return true;
  });
};
var canMoveCanvasKeyframes = ({
  targets,
  delta
}) => {
  const [first] = targets;
  if (!first) {
    return true;
  }
  return canMoveKeyframesWithoutCollisions({
    status: first.propStatus,
    moves: getCanvasKeyframeMoves(targets, delta)
  });
};
var getMovedCanvasKeyframeStatus = ({
  targets,
  delta
}) => {
  const [first] = targets;
  if (!first) {
    throw new Error("Expected a keyframe to move");
  }
  const moved = moveKeyframesInPropStatus({
    status: first.propStatus,
    moves: getCanvasKeyframeMoves(targets, delta)
  });
  if (moved.status !== "keyframed") {
    throw new Error("Expected keyframed status");
  }
  return moved;
};
var getMovedCanvasKeyframeOverride = ({
  targets,
  delta
}) => ({
  type: "keyframed",
  status: getMovedCanvasKeyframeStatus({ targets, delta })
});
// src/keyframes.ts
import { Internals as Internals8 } from "remotion";
var getCanvasKeyframes = ({
  track,
  propStatus
}) => {
  return getTimelineKeyframes(propStatus, track.keyframeDisplayOffset, track.keyframePlaybackRate);
};
var getCanvasKeyframeSourceFrame = ({
  track,
  propStatus,
  frame
}) => {
  return getKeyframeSourceFrame({
    displayFrame: frame,
    keyframeDisplayOffset: getKeyframeDisplayOffset({
      propStatus,
      keyframeDisplayOffset: track.keyframeDisplayOffset,
      keyframePlaybackRate: track.keyframePlaybackRate
    }),
    keyframePlaybackRate: track.keyframePlaybackRate,
    propStatus
  });
};
var getCanvasKeyframeDisplayFrame = ({
  track,
  propStatus,
  sourceFrame
}) => {
  return sourceFrame / getKeyframePlaybackRate(propStatus, track.keyframePlaybackRate) + getKeyframeDisplayOffset({
    propStatus,
    keyframeDisplayOffset: track.keyframeDisplayOffset,
    keyframePlaybackRate: track.keyframePlaybackRate
  });
};
var getSchemaField = (schema, key) => Internals8.getFlatSchemaWithAllKeys(schema)[key];
var getCanvasKeyframeValueChange = ({
  nodePathInfo,
  track,
  schema,
  key,
  propStatus,
  frame,
  value
}) => {
  if (propStatus?.status !== "keyframed" || value === undefined || value === null || !isCanvasKeyframablePropStatus({ propStatus, schema, key })) {
    return null;
  }
  const sourceFrame = getCanvasKeyframeSourceFrame({ track, propStatus, frame });
  if (!propStatus.keyframes.some((keyframe) => keyframe.frame === sourceFrame)) {
    return null;
  }
  const normalizedValue = getSchemaField(schema, key)?.type === "font-weight" ? normalizeFontWeightForKeyframe(value) : value;
  if (normalizedValue === null) {
    return null;
  }
  if (propStatus.interpolationFunction === "interpolatePaths") {
    if (typeof normalizedValue !== "string") {
      return null;
    }
  } else if (Internals8.interpolateKeyframedStatus({
    frame: sourceFrame,
    forceSpringAllowTail: null,
    status: {
      ...propStatus,
      keyframes: propStatus.keyframes.map((keyframe) => keyframe.frame === sourceFrame ? { ...keyframe, value: normalizedValue } : keyframe)
    }
  }) === null) {
    return null;
  }
  return {
    nodePathInfo,
    key,
    schema,
    operation: { type: "add", frame: sourceFrame, value: normalizedValue }
  };
};
var getSchemaFieldDefault = (schema, key) => {
  const field = getSchemaField(schema, key);
  return field !== undefined && "default" in field ? field.default : undefined;
};
var getCanvasPropValueAtFrame = ({
  track,
  schema,
  key,
  propStatus,
  frame
}) => {
  return getCanvasKeyframeValueAtSourceFrame({
    propStatus,
    sourceFrame: getCanvasKeyframeSourceFrame({ track, propStatus, frame }),
    defaultValue: getSchemaFieldDefault(schema, key),
    dragOverrideValue: undefined
  });
};
var getCanvasKeyframeToggle = ({
  nodePathInfo,
  track,
  schema,
  key,
  propStatus,
  frame,
  durationInFrames
}) => {
  const keyframes = getCanvasKeyframes({ track, propStatus });
  const sourceFrame = getCanvasKeyframeSourceFrame({ track, propStatus, frame });
  const hasKeyframe = propStatus.status === "keyframed" && hasKeyframeAtSourceFrame(propStatus.keyframes, sourceFrame);
  const keyframable = isCanvasKeyframablePropStatus({ propStatus, schema, key });
  const base = { nodePathInfo, key, schema };
  let change = null;
  if (hasKeyframe) {
    change = {
      ...base,
      operation: {
        type: "remove",
        frame: sourceFrame,
        valueWhenLastKeyframeDeleted: null
      }
    };
  } else if (keyframable) {
    const value = getCanvasKeyframeValueToAdd({
      propStatus,
      schema,
      key,
      sourceFrame,
      defaultValue: getSchemaFieldDefault(schema, key),
      dragOverrideValue: undefined
    });
    change = value === null ? null : { ...base, operation: { type: "add", frame: sourceFrame, value } };
  }
  return {
    keyframable,
    hasKeyframe,
    previousFrame: getPreviousKeyframeDisplayFrame(keyframes, frame, durationInFrames),
    nextFrame: getNextKeyframeDisplayFrame(keyframes, frame, durationInFrames),
    change
  };
};
// src/keyframe-easing.ts
import {
  canEditEasingForInterpolationFunction,
  isInteractivitySchemaFieldHoldOnly,
  KEYFRAME_EASING_PRESETS,
  LINEAR_KEYFRAME_EASING
} from "@remotion/studio-shared";
var canvasKeyframeEasingPresets = [
  { id: "linear", label: "Linear", easing: LINEAR_KEYFRAME_EASING },
  ...KEYFRAME_EASING_PRESETS
];
var getKeyframeSegments = (keyframes) => {
  return keyframes.flatMap((keyframe, index) => {
    const nextKeyframe = keyframes[index + 1];
    if (!nextKeyframe) {
      return [];
    }
    return [
      {
        segmentIndex: index,
        fromFrame: keyframe.frame,
        toFrame: nextKeyframe.frame
      }
    ];
  });
};
var getKeyframeSegmentEasing = (propStatus, segmentIndex) => propStatus.easing[segmentIndex] ?? LINEAR_KEYFRAME_EASING;
var canEditKeyframeEasing = ({
  field,
  propStatus
}) => propStatus?.status === "keyframed" && !isInteractivitySchemaFieldHoldOnly(field) && canEditEasingForInterpolationFunction(propStatus.interpolationFunction);
var getCanvasKeyframeEasingSegments = ({
  track,
  schema,
  key,
  propStatus
}) => {
  if (propStatus?.status !== "keyframed" || !canEditKeyframeEasing({ field: getSchemaField(schema, key), propStatus })) {
    return [];
  }
  return getKeyframeSegments(getCanvasKeyframes({ track, propStatus })).map((segment) => ({
    ...segment,
    easing: getKeyframeSegmentEasing(propStatus, segment.segmentIndex)
  }));
};
var getCanvasKeyframeEasingChange = ({
  nodePathInfo,
  schema,
  key,
  propStatus,
  segmentIndex,
  easing
}) => {
  if (propStatus.status !== "keyframed" || !canEditKeyframeEasing({ field: getSchemaField(schema, key), propStatus }) || !Number.isInteger(segmentIndex) || segmentIndex < 0 || segmentIndex >= propStatus.keyframes.length - 1) {
    return null;
  }
  return {
    nodePathInfo,
    key,
    schema,
    operation: { type: "easing", segmentIndex, easing }
  };
};
// src/outline-snap.ts
var canvasOutlineSnapThresholdPx = 10;
var EPSILON = 0.000001;
var getCanvasOutlineSnapTargets = ({
  compositionHeight,
  compositionWidth,
  guides
}) => {
  return [
    { axis: "x", position: 0, type: "canvas-left" },
    {
      axis: "x",
      position: compositionWidth / 2,
      type: "canvas-horizontal-center"
    },
    { axis: "x", position: compositionWidth, type: "canvas-right" },
    { axis: "y", position: 0, type: "canvas-top" },
    {
      axis: "y",
      position: compositionHeight / 2,
      type: "canvas-vertical-center"
    },
    { axis: "y", position: compositionHeight, type: "canvas-bottom" },
    ...guides.flatMap((guide) => {
      if (!guide.show) {
        return [];
      }
      return [
        guide.orientation === "vertical" ? {
          axis: "x",
          position: guide.position,
          type: "guide-vertical"
        } : {
          axis: "y",
          position: guide.position,
          type: "guide-horizontal"
        }
      ];
    })
  ];
};
var canSnapEdgeToTarget = (edge, target) => {
  if (target.type === "canvas-horizontal-center") {
    return edge === "center-x";
  }
  if (target.type === "canvas-vertical-center") {
    return edge === "center-y";
  }
  if (target.type === "canvas-left" || target.type === "canvas-right") {
    return edge === "left" || edge === "right";
  }
  if (target.type === "guide-vertical") {
    return edge === "left" || edge === "right" || edge === "center-x";
  }
  if (target.type === "canvas-top" || target.type === "canvas-bottom") {
    return edge === "top" || edge === "bottom";
  }
  return edge === "top" || edge === "bottom" || edge === "center-y";
};
var findBestSnapForAxis = ({
  edges,
  targets,
  threshold
}) => {
  let bestDistance = Infinity;
  let bestSnaps = [];
  for (const target of targets) {
    for (const edge of edges) {
      if (!canSnapEdgeToTarget(edge.edge, target)) {
        continue;
      }
      const distance = Math.abs(edge.position - target.position);
      if (distance > threshold || distance > bestDistance + EPSILON) {
        continue;
      }
      if (distance < bestDistance - EPSILON) {
        bestSnaps = [];
        bestDistance = distance;
      }
      bestSnaps.push({
        offset: target.position - edge.position,
        snapPoint: {
          distance,
          edge: edge.edge,
          target
        }
      });
    }
  }
  if (bestSnaps.length > 1) {
    const centerSnap = bestSnaps.find((snap) => snap.snapPoint.target.type === "canvas-horizontal-center" || snap.snapPoint.target.type === "canvas-vertical-center");
    if (centerSnap) {
      return centerSnap;
    }
  }
  return bestSnaps[0] ?? null;
};
var findCanvasOutlineSnap = ({
  allowX,
  allowY,
  deltaX,
  deltaY,
  outlines,
  scale,
  targets
}) => {
  if (outlines.length === 0) {
    return {
      activeSnapPoints: [],
      snapOffsetX: null,
      snapOffsetY: null
    };
  }
  const points = outlines.flatMap((outline) => outline.points);
  const left = Math.min(...points.map((point) => point.x)) / scale + deltaX;
  const right = Math.max(...points.map((point) => point.x)) / scale + deltaX;
  const top = Math.min(...points.map((point) => point.y)) / scale + deltaY;
  const bottom = Math.max(...points.map((point) => point.y)) / scale + deltaY;
  const threshold = canvasOutlineSnapThresholdPx / scale;
  const snapX = allowX ? findBestSnapForAxis({
    edges: [
      { edge: "left", position: left },
      { edge: "center-x", position: left + (right - left) / 2 },
      { edge: "right", position: right }
    ],
    targets: targets.filter((target) => target.axis === "x"),
    threshold
  }) : null;
  const snapY = allowY ? findBestSnapForAxis({
    edges: [
      { edge: "top", position: top },
      { edge: "center-y", position: top + (bottom - top) / 2 },
      { edge: "bottom", position: bottom }
    ],
    targets: targets.filter((target) => target.axis === "y"),
    threshold
  }) : null;
  return {
    activeSnapPoints: [
      snapX?.snapPoint ?? null,
      snapY?.snapPoint ?? null
    ].filter((snapPoint) => snapPoint !== null),
    snapOffsetX: snapX?.offset ?? null,
    snapOffsetY: snapY?.offset ?? null
  };
};
// src/canvas-outline-snap-lines.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var CanvasOutlineSnapLines = ({ compositionHeight, compositionWidth, scale, snapPoints, color }) => {
  if (snapPoints.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx2("g", {
    pointerEvents: "none",
    children: snapPoints.map((snapPoint) => {
      const key = `${snapPoint.target.axis}-${snapPoint.target.type}-${snapPoint.target.position}-${snapPoint.edge}`;
      if (snapPoint.target.axis === "x") {
        const x = snapPoint.target.position * scale;
        return /* @__PURE__ */ jsx2("line", {
          x1: x,
          x2: x,
          y1: 0,
          y2: compositionHeight * scale,
          stroke: color,
          strokeWidth: 1,
          vectorEffect: "non-scaling-stroke"
        }, key);
      }
      const y = snapPoint.target.position * scale;
      return /* @__PURE__ */ jsx2("line", {
        x1: 0,
        x2: compositionWidth * scale,
        y1: y,
        y2: y,
        stroke: color,
        strokeWidth: 1,
        vectorEffect: "non-scaling-stroke"
      }, key);
    })
  });
};
// src/outline-translate-drag.ts
import { Internals as Internals9 } from "remotion";
var canvasTranslateFieldKey = "style.translate";
var canvasOutlineDragThresholdPx = 4;
var getCanvasOutlineTranslateDragStates = ({
  dragTargets,
  getDragOverrides,
  timelinePosition
}) => {
  return dragTargets.flatMap((target) => {
    const dragOverrideValue = (getDragOverrides(target.nodePath) ?? {})[canvasTranslateFieldKey];
    const sourceFrame = getKeyframeSourceFrame({
      displayFrame: timelinePosition,
      keyframeDisplayOffset: target.keyframeDisplayOffset,
      keyframePlaybackRate: target.keyframePlaybackRate,
      propStatus: target.propStatus
    });
    let effectiveValue;
    if (target.propStatus === null) {
      const dragOverride = Internals9.resolveDragOverrideValue({
        dragOverrideValue,
        frame: sourceFrame
      });
      effectiveValue = dragOverride.type === "resolved" ? dragOverride.value : target.runtimeValue ?? target.fieldDefault;
    } else {
      effectiveValue = Internals9.getEffectiveVisualModeValue({
        propStatus: target.propStatus,
        dragOverrideValue,
        defaultValue: target.fieldDefault,
        frame: getKeyframeLocalFrame(sourceFrame, target.propStatus),
        shouldResortToDefaultValueIfUndefined: true
      });
    }
    const parsed = parseTranslateWithUnits(String(effectiveValue ?? "0px 0px"));
    if (parsed === null || parsed[0].unit !== "px" || parsed[1].unit !== "px") {
      return [];
    }
    return [
      {
        defaultValue: target.fieldDefault !== undefined ? JSON.stringify(target.fieldDefault) : null,
        key: Internals9.makeSequencePropsSubscriptionKey(target.nodePath),
        sourceFrame,
        startX: parsed[0].value,
        startY: parsed[1].value,
        startZ: parsed[2]?.value ?? null,
        target
      }
    ];
  });
};
var getCanvasOutlineTranslateDragValues = ({
  dragStates,
  deltaX,
  deltaY
}) => {
  return new Map(dragStates.map((dragState) => [
    dragState.key,
    serializeTranslate([
      dragState.startX + deltaX,
      dragState.startY + deltaY,
      dragState.startZ
    ])
  ]));
};
var applyCanvasOutlineDragAxisLock = ({
  deltaX,
  deltaY,
  axisLocked
}) => {
  if (!axisLocked) {
    return { deltaX, deltaY };
  }
  if (Math.abs(deltaX) >= Math.abs(deltaY)) {
    return { deltaX, deltaY: 0 };
  }
  return { deltaX: 0, deltaY };
};
var isCanvasOutlineDragPastThreshold = ({
  deltaX,
  deltaY
}) => {
  return Math.hypot(deltaX, deltaY) >= canvasOutlineDragThresholdPx;
};
var getCanvasOutlineTranslateDragChanges = ({
  dragStates,
  lastValues
}) => {
  const changes = [];
  for (const dragState of dragStates) {
    const value = lastValues.get(dragState.key);
    if (value === undefined) {
      continue;
    }
    const { propStatus } = dragState.target;
    if (propStatus?.status === "keyframed") {
      const startValue = serializeTranslate([
        dragState.startX,
        dragState.startY,
        dragState.startZ
      ]);
      if (value === startValue) {
        continue;
      }
      changes.push({
        type: "keyframed",
        fileName: dragState.target.nodePath.absolutePath,
        nodePath: dragState.target.nodePath,
        fieldKey: canvasTranslateFieldKey,
        sourceFrame: dragState.sourceFrame,
        value,
        schema: dragState.target.schema
      });
      continue;
    }
    const currentValue = propStatus === null ? dragState.target.runtimeValue : propStatus.codeValue;
    const shouldSave = value !== currentValue && !(dragState.defaultValue === JSON.stringify(value) && currentValue === undefined);
    if (!shouldSave) {
      continue;
    }
    changes.push({
      type: "static",
      fileName: dragState.target.nodePath.absolutePath,
      nodePath: dragState.target.nodePath,
      fieldKey: canvasTranslateFieldKey,
      value,
      defaultValue: dragState.defaultValue,
      schema: dragState.target.schema
    });
  }
  return changes;
};
var clearCanvasOutlineDragOverrides = ({
  clearDragOverrides,
  dragStates
}) => {
  for (const dragState of dragStates) {
    clearDragOverrides(dragState.target.nodePath);
  }
};
var getCanvasOutlineNudgeDirection = (key) => {
  if (key === "ArrowLeft") {
    return "left";
  }
  if (key === "ArrowRight") {
    return "right";
  }
  if (key === "ArrowUp") {
    return "up";
  }
  if (key === "ArrowDown") {
    return "down";
  }
  return null;
};
var getCanvasOutlineNudgeDelta = ({
  direction,
  shiftKey
}) => {
  const increment = shiftKey ? 10 : 1;
  return direction === "left" || direction === "up" ? -increment : increment;
};
var getCanvasOutlineNudgeDeltas = ({
  deltaX,
  deltaY,
  direction,
  shiftKey
}) => {
  const delta = getCanvasOutlineNudgeDelta({ direction, shiftKey });
  if (direction === "left" || direction === "right") {
    return { deltaX: deltaX + delta, deltaY };
  }
  return { deltaX, deltaY: deltaY + delta };
};
var createCanvasOutlineTranslateSession = (dragStates) => ({
  dragStates,
  deltaX: 0,
  deltaY: 0,
  lastValues: new Map
});
var applyCanvasOutlineTranslateDelta = ({
  session,
  deltaX,
  deltaY,
  setDragOverrides
}) => {
  session.deltaX = deltaX;
  session.deltaY = deltaY;
  session.lastValues = getCanvasOutlineTranslateDragValues({
    dragStates: session.dragStates,
    deltaX,
    deltaY
  });
  for (const dragState of session.dragStates) {
    const value = session.lastValues.get(dragState.key);
    if (value === undefined) {
      throw new Error("Expected drag value to be available");
    }
    const { propStatus } = dragState.target;
    setDragOverrides(dragState.target.nodePath, canvasTranslateFieldKey, propStatus?.status === "keyframed" ? Internals9.makeKeyframedDragOverride({
      status: propStatus,
      frame: dragState.sourceFrame,
      value
    }) : Internals9.makeStaticDragOverride(value));
  }
};
var startCanvasOutlineTranslateDrag = ({
  event,
  captureTarget,
  dragStates,
  scale,
  snapping,
  setDragOverrides,
  clearDragOverrides,
  onDragStart,
  onDragEnd
}) => {
  const session = createCanvasOutlineTranslateSession(dragStates);
  const startPointerX = event.clientX;
  const startPointerY = event.clientY;
  let currentPointerX = startPointerX;
  let currentPointerY = startPointerY;
  let axisLocked = false;
  let dragStarted = false;
  let snappingDisabled = snapping?.modifierDisablesSnapping === true && (event.metaKey || event.ctrlKey);
  let snapTargets = null;
  const update = () => {
    const screenDeltaX = currentPointerX - startPointerX;
    const screenDeltaY = currentPointerY - startPointerY;
    if (!dragStarted) {
      if (!isCanvasOutlineDragPastThreshold({
        deltaX: screenDeltaX,
        deltaY: screenDeltaY
      })) {
        return;
      }
      dragStarted = true;
      onDragStart();
    }
    const axisLockedDirection = axisLocked ? Math.abs(screenDeltaX) >= Math.abs(screenDeltaY) ? "horizontal" : "vertical" : null;
    let { deltaX, deltaY } = applyCanvasOutlineDragAxisLock({
      deltaX: screenDeltaX / scale,
      deltaY: screenDeltaY / scale,
      axisLocked
    });
    if (snapping !== null && !snappingDisabled) {
      snapTargets ??= snapping.getTargets();
      const snapResult = findCanvasOutlineSnap({
        allowX: axisLockedDirection !== "vertical",
        allowY: axisLockedDirection !== "horizontal",
        deltaX,
        deltaY,
        outlines: snapping.outlines,
        scale,
        targets: snapTargets
      });
      deltaX += snapResult.snapOffsetX ?? 0;
      deltaY += snapResult.snapOffsetY ?? 0;
      snapping.onSnapPointsChange(snapResult.activeSnapPoints);
    } else {
      snapping?.onSnapPointsChange([]);
    }
    applyCanvasOutlineTranslateDelta({
      session,
      deltaX,
      deltaY,
      setDragOverrides
    });
  };
  const onKeyChange = (keyEvent) => {
    if (keyEvent.key !== "Shift") {
      return;
    }
    const nextAxisLocked = keyEvent.type === "keydown";
    if (nextAxisLocked === axisLocked) {
      return;
    }
    axisLocked = nextAxisLocked;
    update();
  };
  const end = startCapturedPointerSession({
    event,
    captureTarget,
    onMove: (moveEvent) => {
      moveEvent.preventDefault();
      currentPointerX = moveEvent.clientX;
      currentPointerY = moveEvent.clientY;
      axisLocked = moveEvent.shiftKey;
      snappingDisabled = snapping?.modifierDisablesSnapping === true && (moveEvent.metaKey || moveEvent.ctrlKey);
      update();
    },
    onEnd: (reason, endEvent) => {
      window.removeEventListener("keydown", onKeyChange);
      window.removeEventListener("keyup", onKeyChange);
      if (dragStarted) {
        snapping?.onSnapPointsChange([]);
      }
      const changes = getCanvasOutlineTranslateDragChanges({
        dragStates: session.dragStates,
        lastValues: session.lastValues
      });
      if (changes.length === 0) {
        clearCanvasOutlineDragOverrides({
          clearDragOverrides,
          dragStates: session.dragStates
        });
      }
      onDragEnd({
        changes,
        dragged: dragStarted,
        released: isPointerSessionRelease(reason, endEvent),
        session
      });
    }
  });
  window.addEventListener("keydown", onKeyChange);
  window.addEventListener("keyup", onKeyChange);
  return end;
};
// src/canvas.tsx
import { Player, PlayerInternals as PlayerInternals2 } from "@remotion/player";
import React3, {
  forwardRef as forwardRef2,
  useCallback as useCallback5,
  useContext as useContext2,
  useEffect as useEffect3,
  useMemo as useMemo6
} from "react";
import { Internals as Internals13 } from "remotion";

// src/canvas-controller.ts
import { useState as useState3 } from "react";
import { Internals as Internals10 } from "remotion";

// src/sequence-node-path-remapping.ts
var findRemapping = (key, remappings) => {
  const nodePath = JSON.stringify(key.nodePath);
  return remappings.find((remapping) => remapping.filePath === key.absolutePath && remapping.oldNodePath !== null && JSON.stringify(remapping.oldNodePath) === nodePath) ?? null;
};
var remapSequenceNodePathInfo = (nodePathInfo, remappings) => {
  const remapping = findRemapping(nodePathInfo.sequenceSubscriptionKey, remappings);
  if (remapping === null || JSON.stringify(remapping.newNodePath) === JSON.stringify(nodePathInfo.sequenceSubscriptionKey.nodePath)) {
    return nodePathInfo;
  }
  if (remapping.newNodePath === null) {
    return null;
  }
  return {
    ...nodePathInfo,
    sequenceSubscriptionKey: {
      ...nodePathInfo.sequenceSubscriptionKey,
      nodePath: remapping.newNodePath
    }
  };
};
var remapOverrideIdToNodePaths = (nodePaths, remappings) => {
  let changed = false;
  const next = {};
  for (const [overrideId, key] of Object.entries(nodePaths)) {
    const remapping = findRemapping(key, remappings);
    const nodePath = JSON.stringify(key.nodePath);
    const pathStillExists = remappings.some((candidate) => candidate.filePath === key.absolutePath && candidate.newNodePath !== null && JSON.stringify(candidate.newNodePath) === nodePath);
    if (remapping === null || pathStillExists) {
      next[overrideId] = key;
      continue;
    }
    changed = true;
    if (remapping.newNodePath !== null) {
      next[overrideId] = { ...key, nodePath: remapping.newNodePath };
    }
  }
  return changed ? next : null;
};
var remapSelectionItem = (item, remappings) => {
  if (item.type === "guide") {
    return item;
  }
  const nodePathInfo = remapSequenceNodePathInfo(item.nodePathInfo, remappings);
  if (nodePathInfo === item.nodePathInfo) {
    return item;
  }
  return nodePathInfo === null ? null : { ...item, nodePathInfo };
};
var remapCanvasSelection = (snapshot, remappings) => {
  const selectedItems = snapshot.selectedItems.map((item) => remapSelectionItem(item, remappings)).filter((item) => item !== null);
  const anchor = snapshot.anchor === null ? null : remapSelectionItem(snapshot.anchor, remappings);
  if (selectedItems.length === snapshot.selectedItems.length && selectedItems.every((item, index) => item === snapshot.selectedItems[index]) && anchor === snapshot.anchor) {
    return null;
  }
  return { selectedItems, anchor };
};

// src/canvas-controller.ts
var controllerInternals = new WeakMap;
var nodePathsAreEqual = (previous, next) => {
  const previousIds = Object.keys(previous);
  if (previousIds.length !== Object.keys(next).length) {
    return false;
  }
  return previousIds.every((overrideId) => {
    const previousNodePath = previous[overrideId];
    const nextNodePath = next[overrideId];
    return nextNodePath !== undefined && Internals10.makeSequencePropsSubscriptionKey(previousNodePath) === Internals10.makeSequencePropsSubscriptionKey(nextNodePath);
  });
};
var createCanvasController = () => {
  const calculateTimeline = createTimelineCalculator();
  let timelineSnapshot = [];
  let sequences = [];
  let nodePaths = {};
  let visualModeSetters = null;
  let queuedRemappings = [];
  const timelineListeners = new Set;
  const nodePathListeners = new Set;
  const updateTimelineSnapshot = (nextSnapshot) => {
    timelineSnapshot = nextSnapshot;
    for (const listener of timelineListeners) {
      listener();
    }
  };
  const recalculateTimeline = () => {
    updateTimelineSnapshot(calculateTimeline({
      sequences,
      overrideIdsToNodePaths: nodePaths
    }).tracks);
  };
  const setNodePaths = (nextNodePaths) => {
    nodePaths = nextNodePaths;
    for (const listener of nodePathListeners) {
      listener();
    }
    recalculateTimeline();
  };
  const selection = createCanvasSelectionController();
  const hover = createCanvasHoverController();
  const remapSequenceNodePaths = (remappings) => {
    if (remappings.length === 0) {
      return;
    }
    const nextNodePaths = remapOverrideIdToNodePaths(nodePaths, remappings);
    if (nextNodePaths !== null) {
      setNodePaths(nextNodePaths);
    }
    const nextSelection = remapCanvasSelection(selection.getSnapshot(), remappings);
    if (nextSelection !== null) {
      selection.setSnapshot(nextSelection);
    }
    hover.clear(null);
  };
  const controller = {
    timeline: {
      getSnapshot: () => timelineSnapshot,
      subscribe: (listener) => {
        timelineListeners.add(listener);
        return () => timelineListeners.delete(listener);
      }
    },
    selection,
    hover,
    overrides: {
      set: (nodePathInfo, key, value) => {
        visualModeSetters?.setDragOverrides(nodePathInfo.sequenceSubscriptionKey, key, value);
      },
      clear: (nodePathInfo) => {
        visualModeSetters?.clearDragOverrides(nodePathInfo.sequenceSubscriptionKey);
      }
    },
    setSequenceNodePaths: (nextNodePaths) => {
      if (nodePathsAreEqual(nodePaths, nextNodePaths)) {
        return;
      }
      setNodePaths({ ...nextNodePaths });
    },
    queueSequenceNodePathRemappings: (remappings) => {
      if (remappings.length > 0) {
        queuedRemappings.push(remappings);
      }
    },
    remapSequenceNodePaths
  };
  controllerInternals.set(controller, {
    setSequences: (nextSequences) => {
      sequences = nextSequences;
      recalculateTimeline();
    },
    clear: () => {
      sequences = [];
      updateTimelineSnapshot([]);
      controller.hover.clear(null);
    },
    nodePaths: {
      getSnapshot: () => nodePaths,
      subscribe: (listener) => {
        nodePathListeners.add(listener);
        return () => nodePathListeners.delete(listener);
      }
    },
    setVisualModeSetters: (setters) => {
      visualModeSetters = setters;
    },
    commitQueuedSequenceNodePathRemappings: () => {
      const pending = queuedRemappings;
      queuedRemappings = [];
      for (const remappings of pending) {
        remapSequenceNodePaths(remappings);
      }
    }
  });
  return controller;
};
var useCanvasController = () => {
  const [controller] = useState3(createCanvasController);
  return controller;
};
var getCanvasControllerInternals = (controller) => {
  const internals = controllerInternals.get(controller);
  if (!internals) {
    throw new Error("Invalid Canvas controller");
  }
  return internals;
};

// src/canvas-outline-overlay.tsx
import { PlayerInternals } from "@remotion/player";
import React2, {
  useCallback as useCallback4,
  useContext,
  useEffect as useEffect2,
  useLayoutEffect as useLayoutEffect3,
  useMemo as useMemo5,
  useRef as useRef3,
  useState as useState4
} from "react";
import { Internals as Internals11 } from "remotion";
import { jsx as jsx3, jsxs as jsxs2, Fragment } from "react/jsx-runtime";
var OUTLINE_COLOR = "#0b84f3";
var SNAP_COLOR = "#ff00ff";
var overlayStyle = {
  position: "absolute",
  inset: 0,
  overflow: "hidden",
  touchAction: "none",
  outline: "none"
};
var getOverlayTranslateTarget = ({
  selectableOutline,
  getDragOverrides,
  getPropStatuses,
  frame
}) => {
  const { registeredNodePathInfo, sequence } = selectableOutline;
  const { controls } = sequence;
  if (controls === null || registeredNodePathInfo === null) {
    return null;
  }
  const sourcePropStatuses = getPropStatuses?.(registeredNodePathInfo, [canvasTranslateFieldKey]) ?? null;
  const propStatuses = sourcePropStatuses === null ? null : Internals11.evaluateSourcePropStatuses(sourcePropStatuses, controls.videoConfigValues);
  const propStatus = propStatuses?.[canvasTranslateFieldKey] ?? null;
  if (propStatus !== null && propStatus.status !== "static" && (propStatus.status !== "keyframed" || propStatus.interpolationFunction !== "interpolate")) {
    return null;
  }
  const nodePath = registeredNodePathInfo.sequenceSubscriptionKey;
  const runtimeValues = controls.runtimeValues.getSnapshot();
  const { merged } = Internals11.computeEffectiveSchemaValuesDotNotation({
    schema: controls.schema,
    currentValue: runtimeValues,
    overrideValues: getDragOverrides(nodePath),
    propStatus: propStatuses ?? undefined,
    frame: (frame - selectableOutline.keyframeDisplayOffset) * selectableOutline.keyframePlaybackRate
  });
  const field = Internals11.flattenActiveSchema(controls.schema, (key) => merged[key])[canvasTranslateFieldKey];
  if (field?.type !== "translate") {
    return null;
  }
  return {
    nodePath,
    nodePathInfo: registeredNodePathInfo,
    schema: controls.schema,
    fieldDefault: field.default,
    propStatus,
    runtimeValue: runtimeValues[canvasTranslateFieldKey],
    keyframeDisplayOffset: getKeyframeDisplayOffset({
      propStatus,
      keyframeDisplayOffset: selectableOutline.keyframeDisplayOffset,
      keyframePlaybackRate: selectableOutline.keyframePlaybackRate
    }),
    keyframePlaybackRate: selectableOutline.keyframePlaybackRate
  };
};
var toSequencePropChanges = (changes, session) => {
  const targetsByKey = new Map(session.dragStates.map((dragState) => [dragState.key, dragState.target]));
  return changes.flatMap((change) => {
    const target = targetsByKey.get(Internals11.makeSequencePropsSubscriptionKey(change.nodePath));
    if (target === undefined) {
      return [];
    }
    const base = {
      nodePathInfo: target.nodePathInfo,
      key: change.fieldKey,
      value: change.value,
      schema: change.schema
    };
    return [
      change.type === "keyframed" ? { ...base, type: "keyframe", frame: change.sourceFrame } : { ...base, type: "static", defaultValue: target.fieldDefault ?? null }
    ];
  });
};
var CanvasOutlineElement = React2.memo(({
  controller,
  containerRef,
  outline,
  target,
  selectableItems,
  dragging,
  editing
}) => {
  const { hovered, onPointerEnter, onPointerLeave } = useCanvasSequenceHover(controller.hover, target.nodePathInfo, "canvas");
  const onHoverChange = useCallback4((key) => {
    if (key === null) {
      onPointerLeave();
    } else {
      onPointerEnter();
    }
  }, [onPointerEnter, onPointerLeave]);
  const onPointerDown = useCallback4((event) => {
    const decision = handleCanvasOutlinePointerDown({
      event,
      polygon: event.currentTarget,
      hasTarget: true,
      selected: target.selected,
      containsSelection: target.containsSelection,
      translateWithCommandKey: false,
      isMac: false
    });
    if (decision === null) {
      return;
    }
    containerRef.current?.focus({ preventScroll: true });
    const {
      interaction,
      shouldUpdateSelection,
      deferSelection,
      dragExistingSelection
    } = decision;
    const select = () => controller.selection.select(target.selection, interaction, selectableItems);
    if (!deferSelection && shouldUpdateSelection) {
      select();
    }
    if (interaction.shiftKey || interaction.toggleKey) {
      return;
    }
    const dragTargets = !editing.enabled ? [] : dragExistingSelection ? editing.getSelectedTranslateTargets() : [editing.getTranslateTarget(target)].filter((dragTarget) => dragTarget !== null);
    if (dragTargets.length === 0) {
      if (deferSelection) {
        select();
      }
      return;
    }
    const dragStates = getCanvasOutlineTranslateDragStates({
      dragTargets,
      getDragOverrides: editing.getDragOverrides,
      timelinePosition: editing.getCurrentFrame()
    });
    if (dragStates.length === 0) {
      if (deferSelection) {
        select();
      }
      return;
    }
    startCanvasOutlineTranslateDrag({
      event,
      captureTarget: event.currentTarget,
      dragStates,
      scale: editing.getScale(),
      snapping: {
        outlines: dragExistingSelection ? editing.getSelectedOutlines() : [outline],
        getTargets: editing.getSnapTargets,
        onSnapPointsChange: editing.onSnapPointsChange,
        modifierDisablesSnapping: true
      },
      setDragOverrides: editing.setDragOverrides,
      clearDragOverrides: editing.clearDragOverrides,
      onDragStart: () => {
        editing.onDraggingChange(true);
        controller.hover.clear("canvas");
      },
      onDragEnd: ({ changes, dragged, released, session }) => {
        if (dragged) {
          editing.onDraggingChange(false);
        }
        if (changes.length === 0) {
          if (deferSelection && !dragged && released) {
            select();
          }
          return;
        }
        editing.commitChanges(changes, session);
      }
    });
  }, [
    containerRef,
    controller.hover,
    controller.selection,
    editing,
    outline,
    selectableItems,
    target
  ]);
  return /* @__PURE__ */ jsx3(CanvasOutlinePolygon, {
    outline,
    directlySelected: target.selected,
    "data-selected": target.selected,
    dragging,
    visible: target.showSelectedOutline || hovered,
    interactive: true,
    stroke: OUTLINE_COLOR,
    fill: "transparent",
    onHoverChange,
    onPointerDown
  });
});
var ActiveCanvasOutlines = React2.memo(({
  controller,
  containerRef,
  contentRoot,
  scale,
  selectableOutlines,
  sequences,
  selectableItems,
  measureAll,
  dragging,
  editing,
  measuredRef
}) => {
  const frame = Internals11.Timeline.useTimelinePosition();
  const { selectedItems } = useCanvasSelection(controller.selection);
  const hover = useCanvasHover(controller.hover);
  const { getDragOverrides } = useContext(Internals11.VisualModeDragOverridesContext);
  const selectedSequenceKeys = useMemo5(() => getCanvasSelectedSequenceKeys(selectedItems), [selectedItems]);
  const sequenceKeysContainingSelection = useMemo5(() => getCanvasSequenceKeysContainingSelection(selectedItems), [selectedItems]);
  const hoveredTimelineNodePathKey = hover?.source === "timeline" ? hover.nodePathKey : null;
  const activeLayers = useMemo5(() => getCanvasActiveOutlineTargets({
    targets: selectableOutlines,
    selectedSequenceKeys,
    sequenceKeysContainingSelection,
    hoveredNodePathKey: hoveredTimelineNodePathKey,
    measureAll
  }), [
    hoveredTimelineNodePathKey,
    measureAll,
    selectableOutlines,
    selectedSequenceKeys,
    sequenceKeysContainingSelection
  ]);
  const runtimeControls = useMemo5(() => activeLayers.flatMap(({ sequence }) => sequence.controls ? [sequence.controls] : []), [activeLayers]);
  const runtimeSnapshots = useCanvasRuntimeValueSnapshots(runtimeControls);
  const valuesByStore = useMemo5(() => new Map(runtimeControls.map((controls, index) => [
    controls.runtimeValues,
    runtimeSnapshots[index]
  ])), [runtimeControls, runtimeSnapshots]);
  const targets = useMemo5(() => getCanvasOutlineLayoutTargets({
    selectableOutlines: getCanvasVisibleOutlineTargets({
      targets: activeLayers,
      timelinePosition: frame
    }),
    selectedSequenceKeys,
    sequenceKeysContainingSelection,
    targetKey: null
  }).map((target) => {
    const values = target.sequence.controls ? valuesByStore.get(target.sequence.controls.runtimeValues) ?? {} : {};
    const overrides = target.registeredNodePathInfo === null ? {} : getDragOverrides(target.registeredNodePathInfo.sequenceSubscriptionKey);
    const cropValue = (key) => {
      const override = Internals11.resolveDragOverrideValue({
        dragOverrideValue: overrides[key],
        frame: (frame - target.keyframeDisplayOffset) * target.keyframePlaybackRate
      });
      const value = override.type === "resolved" ? override.value : values[key];
      return typeof value === "number" && Number.isFinite(value) ? value : 0;
    };
    return {
      ...target,
      crop: Internals11.resolveSequenceCrop({
        cropLeft: cropValue("cropLeft"),
        cropRight: cropValue("cropRight"),
        cropTop: cropValue("cropTop"),
        cropBottom: cropValue("cropBottom")
      })
    };
  }), [
    activeLayers,
    frame,
    getDragOverrides,
    selectedSequenceKeys,
    sequenceKeysContainingSelection,
    valuesByStore
  ]);
  const { outlinesForRendering, outlinesByKey, targetsByKey } = useCanvasOutlines({
    contentRoot,
    targets,
    sequences,
    hoverController: controller.hover,
    freezeOrder: dragging
  });
  useLayoutEffect3(() => {
    measuredRef.current = { targets, outlinesByKey };
  }, [measuredRef, outlinesByKey, targets]);
  return /* @__PURE__ */ jsx3(Fragment, {
    children: outlinesForRendering.map((outline) => {
      const target = targetsByKey.get(outline.key);
      return target ? /* @__PURE__ */ jsx3(CanvasOutlineElement, {
        controller,
        containerRef,
        outline: scaleCanvasOutline(outline, scale),
        target,
        selectableItems,
        dragging,
        editing
      }, outline.key) : null;
    })
  });
});
var CanvasOutlineOverlay = React2.memo(({
  controller,
  resolveSequenceNodePathInfo,
  onSequencePropsChange,
  getSequencePropStatuses
}) => {
  const containerRef = useRef3(null);
  const canvasContent = useContext(PlayerInternals.CanvasContentContext);
  const [container, setContainer] = useState4(null);
  const attachContainer = useCallback4((element) => {
    containerRef.current = element;
    setContainer(element);
  }, []);
  const [hovered, setHovered] = useState4(false);
  const [dragScale, setDragScale] = useState4(null);
  const dragging = dragScale !== null;
  const [snapPoints, setSnapPoints] = useState4([]);
  const tracks = useSyncExternalStore(controller.timeline.subscribe, controller.timeline.getSnapshot, controller.timeline.getSnapshot);
  const selection = useCanvasSelection(controller.selection);
  const hover = useCanvasHover(controller.hover);
  const videoConfig = Internals11.useUnsafeVideoConfig();
  const compositionWidth = videoConfig?.width ?? 1;
  const compositionHeight = videoConfig?.height ?? 1;
  const { getCurrentFrame } = PlayerInternals.usePlayerMethods();
  const { getDragOverrides } = useContext(Internals11.VisualModeDragOverridesContext);
  const { setDragOverrides, clearDragOverrides } = useContext(Internals11.VisualModeSettersContext);
  const sequences = useMemo5(() => tracks.map(({ sequence }) => sequence), [tracks]);
  const resolvedTracks = useMemo5(() => tracks.map((track, index) => ({
    ...track,
    nodePathInfo: resolveSequenceNodePathInfo(track, index)
  })), [resolveSequenceNodePathInfo, tracks]);
  const selectableOutlines = useMemo5(() => getCanvasSelectableOutlines({
    tracks: resolvedTracks,
    timelinePosition: null,
    resolveSequenceNodePathInfo: null
  }), [resolvedTracks]);
  const selectableItems = useMemo5(() => resolvedTracks.flatMap(({ nodePathInfo }) => nodePathInfo === null || nodePathInfo.auxiliaryKeys.length !== 0 ? [] : [{ type: "sequence", nodePathInfo }]), [resolvedTracks]);
  useEffect2(() => {
    controller.hover.setHoveredSequence((current) => {
      if (current === null) {
        return current;
      }
      return selectableItems.some((item) => item.type !== "guide" && (current.source === "timeline" ? timelineSequenceNodePathToKey(item.nodePathInfo.sequenceSubscriptionKey) === current.nodePathKey : getCanvasSequenceSelectionKey(item.nodePathInfo) === current.key)) ? current : null;
    });
  }, [controller.hover, selectableItems]);
  useEffect2(() => {
    const ownerWindow = containerRef.current?.ownerDocument.defaultView;
    const clearHover = () => {
      setHovered(false);
      controller.hover.clear(null);
    };
    ownerWindow?.addEventListener("blur", clearHover);
    return () => {
      ownerWindow?.removeEventListener("blur", clearHover);
      controller.hover.clear("canvas");
    };
  }, [controller.hover]);
  const latestRef = useRef3({
    selectableOutlines,
    onSequencePropsChange,
    getSequencePropStatuses,
    compositionWidth,
    compositionHeight,
    getDragOverrides
  });
  useLayoutEffect3(() => {
    latestRef.current = {
      selectableOutlines,
      onSequencePropsChange,
      getSequencePropStatuses,
      compositionWidth,
      compositionHeight,
      getDragOverrides
    };
  }, [
    compositionHeight,
    compositionWidth,
    getDragOverrides,
    getSequencePropStatuses,
    onSequencePropsChange,
    selectableOutlines
  ]);
  const measuredRef = useRef3({
    targets: [],
    outlinesByKey: new Map
  });
  const editingEnabled = onSequencePropsChange !== null;
  const editing = useMemo5(() => {
    const getLatestDragOverrides = (nodePath) => latestRef.current.getDragOverrides(nodePath);
    const getTranslateTarget = (selectableOutline) => getOverlayTranslateTarget({
      selectableOutline,
      getDragOverrides: getLatestDragOverrides,
      getPropStatuses: latestRef.current.getSequencePropStatuses,
      frame: getCurrentFrame()
    });
    const getScale = () => {
      const width = containerRef.current?.getBoundingClientRect().width;
      return width ? width / latestRef.current.compositionWidth : 1;
    };
    return {
      enabled: editingEnabled,
      getScale,
      getCurrentFrame,
      getDragOverrides: getLatestDragOverrides,
      setDragOverrides,
      clearDragOverrides,
      getTranslateTarget,
      getSelectedTranslateTargets: () => {
        const selectedKeys = getCanvasSequenceKeysContainingSelection(controller.selection.getSnapshot().selectedItems);
        const targetsBySource = new Map;
        for (const selectableOutline of latestRef.current.selectableOutlines) {
          if (!selectedKeys.has(selectableOutline.key)) {
            continue;
          }
          const dragTarget = getTranslateTarget(selectableOutline);
          if (dragTarget === null) {
            continue;
          }
          const sourceKey = Internals11.makeSequencePropsSubscriptionKey(dragTarget.nodePath);
          if (!targetsBySource.has(sourceKey)) {
            targetsBySource.set(sourceKey, dragTarget);
          }
        }
        return [...targetsBySource.values()];
      },
      getSelectedOutlines: () => {
        const { targets, outlinesByKey } = measuredRef.current;
        const scale = getScale();
        return targets.flatMap((target) => {
          if (!target.selected && !target.containsSelection || getTranslateTarget(target) === null) {
            return [];
          }
          const outline = outlinesByKey.get(target.key);
          return outline === undefined ? [] : [scaleCanvasOutline(outline, scale)];
        });
      },
      getSnapTargets: () => getCanvasOutlineSnapTargets({
        compositionWidth: latestRef.current.compositionWidth,
        compositionHeight: latestRef.current.compositionHeight,
        guides: []
      }),
      onDraggingChange: (nextDragging) => {
        setDragScale(nextDragging ? getScale() : null);
      },
      onSnapPointsChange: setSnapPoints,
      commitChanges: (changes, session) => {
        const handler = latestRef.current.onSequencePropsChange;
        if (handler === null) {
          clearCanvasOutlineDragOverrides({
            clearDragOverrides,
            dragStates: session.dragStates
          });
          return;
        }
        handler(toSequencePropChanges(changes, session));
      }
    };
  }, [
    clearDragOverrides,
    controller.selection,
    editingEnabled,
    getCurrentFrame,
    setDragOverrides
  ]);
  const nudgeSessionRef = useRef3(null);
  const finishNudge = useCallback4(() => {
    const session = nudgeSessionRef.current;
    if (session === null) {
      return;
    }
    nudgeSessionRef.current = null;
    const changes = getCanvasOutlineTranslateDragChanges({
      dragStates: session.dragStates,
      lastValues: session.lastValues
    });
    if (changes.length === 0) {
      clearCanvasOutlineDragOverrides({
        clearDragOverrides,
        dragStates: session.dragStates
      });
      return;
    }
    editing.commitChanges(changes, session);
  }, [clearDragOverrides, editing]);
  useEffect2(() => finishNudge, [finishNudge]);
  const onKeyDown = useCallback4((event) => {
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      controller.selection.clear();
      return;
    }
    const direction = getCanvasOutlineNudgeDirection(event.key);
    if (direction === null || event.altKey || event.metaKey || event.ctrlKey || !editing.enabled) {
      return;
    }
    const session = nudgeSessionRef.current ?? (() => {
      const dragTargets = editing.getSelectedTranslateTargets();
      const dragStates = getCanvasOutlineTranslateDragStates({
        dragTargets,
        getDragOverrides: editing.getDragOverrides,
        timelinePosition: editing.getCurrentFrame()
      });
      return dragStates.length === 0 ? null : createCanvasOutlineTranslateSession(dragStates);
    })();
    if (session === null) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    nudgeSessionRef.current = session;
    applyCanvasOutlineTranslateDelta({
      session,
      ...getCanvasOutlineNudgeDeltas({
        deltaX: session.deltaX,
        deltaY: session.deltaY,
        direction,
        shiftKey: event.shiftKey
      }),
      setDragOverrides: editing.setDragOverrides
    });
  }, [controller.selection, editing]);
  const onKeyUp = useCallback4((event) => {
    if (getCanvasOutlineNudgeDirection(event.key) === null || nudgeSessionRef.current === null) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
    finishNudge();
  }, [finishNudge]);
  const { measurementActive, measureAllOutlines } = getCanvasOutlineActivity({
    canvasHovered: hovered,
    dragging,
    contextMenuOpen: false,
    hasSelection: selection.selectedItems.some((item) => item.type !== "guide"),
    hoveredSequence: hover
  });
  return /* @__PURE__ */ jsxs2("svg", {
    ref: attachContainer,
    style: overlayStyle,
    width: "100%",
    height: "100%",
    tabIndex: 0,
    role: "group",
    "aria-label": "Canvas selection",
    onPointerEnter: () => setHovered(true),
    onPointerLeave: () => {
      setHovered(false);
      controller.hover.clear("canvas");
    },
    onPointerDown: (event) => {
      if (event.button !== 0) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      containerRef.current?.focus({ preventScroll: true });
      controller.selection.clear();
    },
    onDoubleClick: (event) => event.stopPropagation(),
    onKeyDown,
    onKeyUp,
    onBlur: finishNudge,
    children: [
      measurementActive && container !== null && canvasContent?.rootRef.current ? /* @__PURE__ */ jsx3(ActiveCanvasOutlines, {
        controller,
        containerRef,
        contentRoot: canvasContent.rootRef.current,
        scale: canvasContent.scale,
        selectableOutlines,
        sequences,
        selectableItems,
        measureAll: measureAllOutlines,
        dragging,
        editing,
        measuredRef
      }) : null,
      dragScale === null ? null : /* @__PURE__ */ jsx3(CanvasOutlineSnapLines, {
        compositionHeight,
        compositionWidth,
        scale: dragScale,
        snapPoints,
        color: SNAP_COLOR
      })
    ]
  });
});

// src/sequence-node-path.ts
import { Internals as Internals12 } from "remotion";
var getCanvasSequenceSourceLocation = (track) => {
  const location = Internals12.parseOriginalSourceStack(track.sequence.getStack());
  if (!location) {
    return null;
  }
  return {
    fileName: location.fileName,
    line: location.line,
    column: location.column
  };
};
var getCanvasSequenceNodePathInfo = (track) => {
  return track.nodePathInfo ?? {
    sequenceSubscriptionKey: {
      absolutePath: "remotion-canvas",
      nodePath: ["sequence", track.sequence.id],
      sequenceKeys: [],
      effectKeys: [],
      videoConfigValues: track.sequence.controls?.videoConfigValues ?? null
    },
    auxiliaryKeys: [],
    index: 0,
    numberOfSequencesWithThisNodePath: 1,
    supportsEffects: track.sequence.controls?.supportsEffects === true
  };
};

// src/canvas.tsx
import { jsx as jsx4, jsxs as jsxs3, Fragment as Fragment2 } from "react/jsx-runtime";
var CanvasVisualModeBridge = ({ controller }) => {
  const setters = useContext2(Internals13.VisualModeSettersContext);
  const internals = getCanvasControllerInternals(controller);
  useEffect3(() => {
    internals.setVisualModeSetters(setters);
    return () => internals.setVisualModeSetters(null);
  }, [internals, setters]);
  return null;
};
var CanvasFn = ({
  controller,
  showOutlines = false,
  resolveSequenceNodePathInfo = getCanvasSequenceNodePathInfo,
  onSequencePropsChange,
  getSequencePropStatuses,
  ...playerProps
}, ref) => {
  if (typeof window !== "undefined") {
    installReactCommitObserver(window);
  }
  const internals = getCanvasControllerInternals(controller);
  const onTimelineSequenceChange = useCallback5((sequences) => internals.setSequences(sequences), [internals]);
  const nodePaths = useSyncExternalStore(internals.nodePaths.subscribe, internals.nodePaths.getSnapshot, internals.nodePaths.getSnapshot);
  const nodePathGetters = useMemo6(() => ({ overrideIdToNodePathMappings: nodePaths }), [nodePaths]);
  useEffect3(() => {
    return () => internals.clear();
  }, [internals]);
  useEffect3(() => {
    if (typeof window === "undefined") {
      return;
    }
    const commit = () => internals.commitQueuedSequenceNodePathRemappings();
    window.addEventListener(Internals13.REACT_REFRESH_STARTED_EVENT, commit);
    return () => window.removeEventListener(Internals13.REACT_REFRESH_STARTED_EVENT, commit);
  }, [internals]);
  const overlay = useMemo6(() => /* @__PURE__ */ jsxs3(Fragment2, {
    children: [
      /* @__PURE__ */ jsx4(CanvasVisualModeBridge, {
        controller
      }),
      showOutlines ? /* @__PURE__ */ jsx4(CanvasOutlineOverlay, {
        controller,
        resolveSequenceNodePathInfo,
        onSequencePropsChange: onSequencePropsChange ?? null,
        getSequencePropStatuses: getSequencePropStatuses ?? null
      }) : null
    ]
  }), [
    controller,
    getSequencePropStatuses,
    onSequencePropsChange,
    resolveSequenceNodePathInfo,
    showOutlines
  ]);
  return React3.createElement(Internals13.EnableInteractivityProvider, null, React3.createElement(Internals13.SequenceOutlineContext.Provider, { value: showOutlines }, React3.createElement(Internals13.OverrideIdsToNodePathsGettersContext.Provider, { value: nodePathGetters }, React3.createElement(PlayerInternals2.TimelineSequenceObserverContext.Provider, { value: onTimelineSequenceChange }, React3.createElement(PlayerInternals2.CanvasOverlayContext.Provider, { value: overlay }, React3.createElement(Player, {
    ...playerProps,
    ref
  }))))));
};
var forward = forwardRef2;
var Canvas = forward(CanvasFn);
// src/sequence-reorder.ts
var getCanvasSequenceReorderSelection = ({
  draggedItem,
  selectedItems
}) => {
  const draggedKey = getCanvasSelectionItemKey(draggedItem);
  if (selectedItems.length < 2 || selectedItems.some((item) => item.type !== "sequence") || !selectedItems.some((item) => getCanvasSelectionItemKey(item) === draggedKey)) {
    return [draggedItem.nodePathInfo];
  }
  return selectedItems.flatMap((item) => item.type === "sequence" ? [item.nodePathInfo] : []);
};
var getCanvasSequenceReorderInsertionIndex = ({
  sourceIndexes,
  targetIndex,
  position
}) => {
  if (sourceIndexes.length === 0 || targetIndex < 0 || sourceIndexes.some((index) => index < 0) || sourceIndexes.includes(targetIndex) || new Set(sourceIndexes).size !== sourceIndexes.length) {
    return null;
  }
  const sorted = [...sourceIndexes].sort((a, b) => a - b);
  const rawIndex = targetIndex + (position === "after" ? 1 : 0);
  const insertionIndex = rawIndex - sorted.filter((index) => index < rawIndex).length;
  if (sorted.every((index, offset) => index === sorted[0] + offset) && insertionIndex === sorted[0]) {
    return null;
  }
  return insertionIndex;
};
// src/keyframe-settings.ts
var extrapolateTypes = [
  "extend",
  "clamp",
  "identity",
  "wrap"
];
var getCanvasKeyframeSettings = (propStatus) => {
  const { interpolationFunction } = propStatus;
  const hasClamping = interpolationFunction === "interpolate" || interpolationFunction === "interpolatePaths";
  const hasOutput = interpolationFunction === "interpolate";
  return {
    clamping: hasClamping ? propStatus.clamping : null,
    extrapolateTypes: hasClamping ? extrapolateTypes.filter((type) => hasOutput || type !== "identity") : [],
    posterize: propStatus.posterize ?? null,
    output: hasOutput ? propStatus.output ?? "linear" : null
  };
};
var getCanvasKeyframeSettingsChange = ({
  nodePathInfo,
  schema,
  key,
  propStatus,
  settings
}) => {
  const current = getCanvasKeyframeSettings(propStatus);
  return {
    nodePathInfo,
    key,
    schema,
    operation: {
      type: "settings",
      clamping: current.clamping === null ? undefined : settings.clamping ?? current.clamping,
      posterize: settings.posterize === null || settings.posterize <= 0 ? undefined : settings.posterize,
      output: current.output === null ? undefined : settings.output ?? current.output
    }
  };
};
// src/keyframe-override.ts
import {
  addKeyframeToPropStatus,
  applyKeyframeSettingsToStatus,
  moveKeyframesInPropStatus as moveKeyframesInPropStatus2,
  removeKeyframeFromPropStatus
} from "@remotion/studio-shared";
var getCanvasKeyframeChangeOverride = ({
  propStatus,
  change
}) => {
  const { operation } = change;
  if (operation.type === "add") {
    const status = addKeyframeToPropStatus({
      status: propStatus,
      fieldKey: change.key,
      frame: operation.frame,
      value: operation.value,
      schema: change.schema
    });
    return status.status === "keyframed" ? { type: "keyframed", status } : null;
  }
  if (propStatus.status !== "keyframed") {
    return null;
  }
  switch (operation.type) {
    case "remove": {
      const status = removeKeyframeFromPropStatus({
        status: propStatus,
        frame: operation.frame,
        valueWhenLastKeyframeDeleted: operation.valueWhenLastKeyframeDeleted
      });
      if (status.status === "keyframed") {
        return { type: "keyframed", status };
      }
      return status.status === "static" ? { type: "static", value: status.codeValue } : null;
    }
    case "move": {
      const status = moveKeyframesInPropStatus2({
        status: propStatus,
        moves: operation.moves
      });
      return status.status === "keyframed" ? { type: "keyframed", status } : null;
    }
    case "easing":
    case "settings":
      return {
        type: "keyframed",
        status: applyKeyframeSettingsToStatus(propStatus, operation)
      };
    default:
      throw new Error(`Unexpected keyframe operation: ${JSON.stringify(operation)}`);
  }
};
// src/keyframe-drag.ts
import { Internals as Internals14 } from "remotion";
var canvasKeyframeDragThresholdPx = 3;
var groupCanvasKeyframeDragTargets = (targets) => {
  const groups = new Map;
  for (const target of targets) {
    const sourceFrame = getCanvasKeyframeSourceFrame({
      track: target.track,
      propStatus: target.propStatus,
      frame: target.frame
    });
    if (!target.propStatus.keyframes.some((keyframe) => keyframe.frame === sourceFrame)) {
      continue;
    }
    const groupKey = `${Internals14.makeSequencePropsSubscriptionKey(target.nodePathInfo.sequenceSubscriptionKey)}\x00${target.key}`;
    const group = groups.get(groupKey) ?? {
      nodePathInfo: target.nodePathInfo,
      schema: target.schema,
      key: target.key,
      targets: []
    };
    groups.set(groupKey, group);
    group.targets.push({
      propStatus: target.propStatus,
      displayFrame: target.frame,
      sourceFrame,
      keyframePlaybackRate: target.track.keyframePlaybackRate
    });
  }
  return [...groups.values()];
};
var startCanvasKeyframeDrag = ({
  event,
  captureTarget,
  targets,
  pixelsPerFrame,
  durationInFrames,
  overrides,
  onDragStart,
  onDragMove,
  onDragEnd
}) => {
  const groups = groupCanvasKeyframeDragTargets(targets);
  const moveTargets = groups.flatMap((group) => group.targets);
  const startClientX = event.clientX;
  let dragged = false;
  let lastDelta = 0;
  let previewed = false;
  const clearOverrides = () => {
    if (!previewed) {
      return;
    }
    previewed = false;
    for (const group of groups) {
      overrides.clear(group.nodePathInfo);
    }
  };
  const canMove = (delta) => groups.every((group) => canMoveCanvasKeyframes({ targets: group.targets, delta }));
  return startCapturedPointerSession({
    event,
    captureTarget,
    onMove: (moveEvent) => {
      const clientXDelta = moveEvent.clientX - startClientX;
      if (!dragged && Math.abs(clientXDelta) < canvasKeyframeDragThresholdPx) {
        return;
      }
      if (moveTargets.length === 0 || pixelsPerFrame <= 0) {
        return;
      }
      moveEvent.preventDefault();
      const delta = getBoundedKeyframeDragDelta({
        delta: Math.round(clientXDelta / pixelsPerFrame),
        durationInFrames,
        targets: moveTargets
      });
      if (dragged && delta === lastDelta) {
        return;
      }
      if (!dragged) {
        dragged = true;
        onDragStart?.();
      }
      lastDelta = delta;
      if (!canMove(delta)) {
        clearOverrides();
        onDragMove?.(0);
        return;
      }
      previewed = true;
      for (const group of groups) {
        overrides.set(group.nodePathInfo, group.key, getMovedCanvasKeyframeOverride({ targets: group.targets, delta }));
      }
      onDragMove?.(delta);
    },
    onEnd: (reason, endEvent) => {
      const released = isPointerSessionRelease(reason, endEvent);
      const moved = dragged && released && lastDelta !== 0 && canMove(lastDelta);
      if (!moved) {
        clearOverrides();
        onDragEnd({ changes: [], delta: 0, dragged, released });
        return;
      }
      onDragEnd({
        changes: groups.map((group) => ({
          nodePathInfo: group.nodePathInfo,
          key: group.key,
          schema: group.schema,
          operation: {
            type: "move",
            moves: getCanvasKeyframeMoves(group.targets, lastDelta)
          }
        })),
        delta: lastDelta,
        dragged,
        released
      });
    }
  });
};

// src/index.ts
var CanvasInternals = exports_canvas_internals;
export {
  Canvas,
  CanvasInternals,
  canvasKeyframeEasingPresets,
  createCanvasController,
  createCanvasHoverController,
  createCanvasSelectionController,
  getCanvasKeyframeChangeOverride,
  getCanvasKeyframeDisplayFrame,
  getCanvasKeyframeEasingChange,
  getCanvasKeyframeEasingSegments,
  getCanvasKeyframeSettings,
  getCanvasKeyframeSettingsChange,
  getCanvasKeyframeSourceFrame,
  getCanvasKeyframeToggle,
  getCanvasKeyframeValueChange,
  getCanvasKeyframes,
  getCanvasPropValueAtFrame,
  getCanvasSelectionItemKey,
  getCanvasSequenceNodePathInfo,
  getCanvasSequenceReorderInsertionIndex,
  getCanvasSequenceReorderSelection,
  getCanvasSequenceSourceLocation,
  startCanvasKeyframeDrag,
  useCanvasController,
  useCanvasHover,
  useCanvasSelection,
  useCanvasSequenceHover
};
